import * as a from "react";
import Ue, { useState as H, useEffect as F, useRef as X, createContext as Yt, useCallback as le, useId as Is, useMemo as Ut, useLayoutEffect as Jt, useContext as Os } from "react";
import { CalciteAction as Xt, CalciteFlow as Fs, CalciteFlowItem as Ct, CalciteLoader as $s, CalciteCardGroup as Ds, CalciteCard as Bs } from "@esri/calcite-components-react";
import { useSelector as wt, useDispatch as zs } from "react-redux";
import { createSlice as Za, createAsyncThunk as Ke, combineReducers as Gs } from "@reduxjs/toolkit";
import * as Ht from "@arcgis/core/intl";
import { useTranslation as qe } from "react-i18next";
import { CalciteNavigation as Ws, CalciteAction as La, CalciteNavigationLogo as Ks, CalciteDropdown as qs, CalciteNavigationUser as Ys, CalciteDropdownGroup as tt, CalciteDropdownItem as st, CalciteTooltip as Tt, CalciteShellPanel as Js, CalciteActionBar as Xs, CalciteFlow as Qs, CalciteFlowItem as el } from "@esri/calcite-components-react/dist";
import al from "@arcgis/core/widgets/LayerList";
import * as je from "@arcgis/core/core/reactiveUtils";
import { useMapViewContext as Fe, MapMode as ya, basemaps as tl, useMapState as sl } from "@origo/map-context";
import { Checkbox as ll, Tree as nl, Tooltip as Aa, ToolbarItem as ga, Button as _t, Slider as vt, NumberInput as rl, Select as ja, ColorPicker as Ca, Combobox as cl, Switch as Zt, SegmentedControl as ol, IconButton as Qt, Toolbar as ml, Notice as es, Loader as il, TextInput as bl, ListCard as dl, Dialog as yl, Alert as as } from "@origo/origo-ui";
import gl from "@arcgis/core/widgets/BasemapGallery";
import fl from "@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource";
import pl from "@arcgis/core/widgets/Print";
import hl from "@arcgis/core/Color";
import { scaleCIMSymbolTo as ul, applyCIMSymbolColor as Al, getCIMSymbolSize as Nl, getCIMSymbolColor as Sl } from "@arcgis/core/symbols/support/cimSymbolUtils";
import Ul from "@arcgis/core/symbols/CIMSymbol";
import wl from "@arcgis/core/symbols/WebStyleSymbol";
import _l from "@arcgis/core/symbols/SimpleMarkerSymbol";
import { renderPreviewHTML as vl } from "@arcgis/core/symbols/support/symbolUtils";
import jt from "@arcgis/core/widgets/Sketch/SketchViewModel";
import ht from "@arcgis/core/layers/GraphicsLayer";
import * as Ll from "@arcgis/core/geometry/operators/intersectsOperator";
import El from "@arcgis/core/views/interactive/snapping/SnappingOptions";
import xl from "@arcgis/core/views/interactive/snapping/FeatureSnappingLayerSource";
import * as kl from "@arcgis/core/geometry/operators/areaOperator";
import * as Ml from "@arcgis/core/geometry/operators/centroidOperator";
import * as Rt from "@arcgis/core/geometry/operators/lengthOperator";
import lt from "@arcgis/core/Graphic";
import Ea from "@arcgis/core/geometry/Point";
import Cl from "@arcgis/core/geometry/Polyline";
import ts from "@arcgis/core/portal/Portal";
import Hl from "@arcgis/core/layers/Layer";
import ss from "@arcgis/core/portal/PortalGroup";
import ls from "@arcgis/core/portal/PortalItem";
import Tl from "@arcgis/core/WebMap";
import { createPortal as ns } from "react-dom";
import Na from "@arcgis/core/geometry/Point.js";
import Zl from "@arcgis/core/geometry/Extent.js";
import jl from "@arcgis/core/Graphic.js";
import * as Rl from "@arcgis/core/core/reactiveUtils.js";
var ut = { exports: {} }, oa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vt;
function Vl() {
  if (Vt)
    return oa;
  Vt = 1;
  var t = Ue, e = Symbol.for("react.element"), l = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function y(d, b, i) {
    var g, h = {}, p = null, N = null;
    i !== void 0 && (p = "" + i), b.key !== void 0 && (p = "" + b.key), b.ref !== void 0 && (N = b.ref);
    for (g in b)
      r.call(b, g) && !o.hasOwnProperty(g) && (h[g] = b[g]);
    if (d && d.defaultProps)
      for (g in b = d.defaultProps, b)
        h[g] === void 0 && (h[g] = b[g]);
    return { $$typeof: e, type: d, key: p, ref: N, props: h, _owner: n.current };
  }
  return oa.Fragment = l, oa.jsx = y, oa.jsxs = y, oa;
}
var ma = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pt;
function Pl() {
  return Pt || (Pt = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ue, e = Symbol.for("react.element"), l = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), d = Symbol.for("react.context"), b = Symbol.for("react.forward_ref"), i = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), E = Symbol.iterator, u = "@@iterator";
    function S(s) {
      if (s === null || typeof s != "object")
        return null;
      var m = E && s[E] || s[u];
      return typeof m == "function" ? m : null;
    }
    var w = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function U(s) {
      {
        for (var m = arguments.length, f = new Array(m > 1 ? m - 1 : 0), A = 1; A < m; A++)
          f[A - 1] = arguments[A];
        M("error", s, f);
      }
    }
    function M(s, m, f) {
      {
        var A = w.ReactDebugCurrentFrame, k = A.getStackAddendum();
        k !== "" && (m += "%s", f = f.concat([k]));
        var Z = f.map(function(x) {
          return String(x);
        });
        Z.unshift("Warning: " + m), Function.prototype.apply.call(console[s], console, Z);
      }
    }
    var q = !1, te = !1, oe = !1, se = !1, ee = !1, O;
    O = Symbol.for("react.module.reference");
    function Q(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === r || s === o || ee || s === n || s === i || s === g || se || s === N || q || te || oe || typeof s == "object" && s !== null && (s.$$typeof === p || s.$$typeof === h || s.$$typeof === y || s.$$typeof === d || s.$$typeof === b || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === O || s.getModuleId !== void 0));
    }
    function _(s, m, f) {
      var A = s.displayName;
      if (A)
        return A;
      var k = m.displayName || m.name || "";
      return k !== "" ? f + "(" + k + ")" : f;
    }
    function T(s) {
      return s.displayName || "Context";
    }
    function j(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && U("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case r:
          return "Fragment";
        case l:
          return "Portal";
        case o:
          return "Profiler";
        case n:
          return "StrictMode";
        case i:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case d:
            var m = s;
            return T(m) + ".Consumer";
          case y:
            var f = s;
            return T(f._context) + ".Provider";
          case b:
            return _(s, s.render, "ForwardRef");
          case h:
            var A = s.displayName || null;
            return A !== null ? A : j(s.type) || "Memo";
          case p: {
            var k = s, Z = k._payload, x = k._init;
            try {
              return j(x(Z));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, ne = 0, G, B, me, ye, we, Me, C;
    function de() {
    }
    de.__reactDisabledLog = !0;
    function He() {
      {
        if (ne === 0) {
          G = console.log, B = console.info, me = console.warn, ye = console.error, we = console.group, Me = console.groupCollapsed, C = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: de,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        ne++;
      }
    }
    function Re() {
      {
        if (ne--, ne === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, s, {
              value: G
            }),
            info: $({}, s, {
              value: B
            }),
            warn: $({}, s, {
              value: me
            }),
            error: $({}, s, {
              value: ye
            }),
            group: $({}, s, {
              value: we
            }),
            groupCollapsed: $({}, s, {
              value: Me
            }),
            groupEnd: $({}, s, {
              value: C
            })
          });
        }
        ne < 0 && U("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var _e = w.ReactCurrentDispatcher, ve;
    function Le(s, m, f) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (k) {
            var A = k.stack.trim().match(/\n( *(at )?)/);
            ve = A && A[1] || "";
          }
        return `
` + ve + s;
      }
    }
    var Te = !1, Ee;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      Ee = new Ye();
    }
    function L(s, m) {
      if (!s || Te)
        return "";
      {
        var f = Ee.get(s);
        if (f !== void 0)
          return f;
      }
      var A;
      Te = !0;
      var k = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Z;
      Z = _e.current, _e.current = null, He();
      try {
        if (m) {
          var x = function() {
            throw Error();
          };
          if (Object.defineProperty(x.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(x, []);
            } catch (J) {
              A = J;
            }
            Reflect.construct(s, [], x);
          } else {
            try {
              x.call();
            } catch (J) {
              A = J;
            }
            s.call(x.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (J) {
            A = J;
          }
          s();
        }
      } catch (J) {
        if (J && A && typeof J.stack == "string") {
          for (var v = J.stack.split(`
`), K = A.stack.split(`
`), R = v.length - 1, P = K.length - 1; R >= 1 && P >= 0 && v[R] !== K[P]; )
            P--;
          for (; R >= 1 && P >= 0; R--, P--)
            if (v[R] !== K[P]) {
              if (R !== 1 || P !== 1)
                do
                  if (R--, P--, P < 0 || v[R] !== K[P]) {
                    var ae = `
` + v[R].replace(" at new ", " at ");
                    return s.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", s.displayName)), typeof s == "function" && Ee.set(s, ae), ae;
                  }
                while (R >= 1 && P >= 0);
              break;
            }
        }
      } finally {
        Te = !1, _e.current = Z, Re(), Error.prepareStackTrace = k;
      }
      var Ae = s ? s.displayName || s.name : "", ge = Ae ? Le(Ae) : "";
      return typeof s == "function" && Ee.set(s, ge), ge;
    }
    function D(s, m, f) {
      return L(s, !1);
    }
    function Y(s) {
      var m = s.prototype;
      return !!(m && m.isReactComponent);
    }
    function z(s, m, f) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return L(s, Y(s));
      if (typeof s == "string")
        return Le(s);
      switch (s) {
        case i:
          return Le("Suspense");
        case g:
          return Le("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case b:
            return D(s.render);
          case h:
            return z(s.type, m, f);
          case p: {
            var A = s, k = A._payload, Z = A._init;
            try {
              return z(Z(k), m, f);
            } catch {
            }
          }
        }
      return "";
    }
    var W = Object.prototype.hasOwnProperty, re = {}, pe = w.ReactDebugCurrentFrame;
    function he(s) {
      if (s) {
        var m = s._owner, f = z(s.type, s._source, m ? m.type : null);
        pe.setExtraStackFrame(f);
      } else
        pe.setExtraStackFrame(null);
    }
    function Je(s, m, f, A, k) {
      {
        var Z = Function.call.bind(W);
        for (var x in s)
          if (Z(s, x)) {
            var v = void 0;
            try {
              if (typeof s[x] != "function") {
                var K = Error((A || "React class") + ": " + f + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw K.name = "Invariant Violation", K;
              }
              v = s[x](m, x, A, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (R) {
              v = R;
            }
            v && !(v instanceof Error) && (he(k), U("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", A || "React class", f, x, typeof v), he(null)), v instanceof Error && !(v.message in re) && (re[v.message] = !0, he(k), U("Failed %s type: %s", f, v.message), he(null));
          }
      }
    }
    var V = Array.isArray;
    function be(s) {
      return V(s);
    }
    function I(s) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, f = m && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return f;
      }
    }
    function Ne(s) {
      try {
        return Ve(s), !1;
      } catch {
        return !0;
      }
    }
    function Ve(s) {
      return "" + s;
    }
    function Xe(s) {
      if (Ne(s))
        return U("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", I(s)), Ve(s);
    }
    var xe = w.ReactCurrentOwner, Pa = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Qe, ea, $e;
    $e = {};
    function Ia(s) {
      if (W.call(s, "ref")) {
        var m = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function Oa(s) {
      if (W.call(s, "key")) {
        var m = Object.getOwnPropertyDescriptor(s, "key").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function Fa(s, m) {
      if (typeof s.ref == "string" && xe.current && m && xe.current.stateNode !== m) {
        var f = j(xe.current.type);
        $e[f] || (U('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(xe.current.type), s.ref), $e[f] = !0);
      }
    }
    function $a(s, m) {
      {
        var f = function() {
          Qe || (Qe = !0, U("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        f.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Da(s, m) {
      {
        var f = function() {
          ea || (ea = !0, U("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        f.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var Ba = function(s, m, f, A, k, Z, x) {
      var v = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: s,
        key: m,
        ref: f,
        props: x,
        // Record the component responsible for creating this element.
        _owner: Z
      };
      return v._store = {}, Object.defineProperty(v._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(v, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.defineProperty(v, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.freeze && (Object.freeze(v.props), Object.freeze(v)), v;
    };
    function za(s, m, f, A, k) {
      {
        var Z, x = {}, v = null, K = null;
        f !== void 0 && (Xe(f), v = "" + f), Oa(m) && (Xe(m.key), v = "" + m.key), Ia(m) && (K = m.ref, Fa(m, k));
        for (Z in m)
          W.call(m, Z) && !Pa.hasOwnProperty(Z) && (x[Z] = m[Z]);
        if (s && s.defaultProps) {
          var R = s.defaultProps;
          for (Z in R)
            x[Z] === void 0 && (x[Z] = R[Z]);
        }
        if (v || K) {
          var P = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          v && $a(x, P), K && Da(x, P);
        }
        return Ba(s, v, K, k, A, xe.current, x);
      }
    }
    var De = w.ReactCurrentOwner, aa = w.ReactDebugCurrentFrame;
    function ue(s) {
      if (s) {
        var m = s._owner, f = z(s.type, s._source, m ? m.type : null);
        aa.setExtraStackFrame(f);
      } else
        aa.setExtraStackFrame(null);
    }
    var Be;
    Be = !1;
    function ze(s) {
      return typeof s == "object" && s !== null && s.$$typeof === e;
    }
    function ta() {
      {
        if (De.current) {
          var s = j(De.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function Ga(s) {
      {
        if (s !== void 0) {
          var m = s.fileName.replace(/^.*[\\\/]/, ""), f = s.lineNumber;
          return `

Check your code at ` + m + ":" + f + ".";
        }
        return "";
      }
    }
    var sa = {};
    function Wa(s) {
      {
        var m = ta();
        if (!m) {
          var f = typeof s == "string" ? s : s.displayName || s.name;
          f && (m = `

Check the top-level render call using <` + f + ">.");
        }
        return m;
      }
    }
    function la(s, m) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var f = Wa(m);
        if (sa[f])
          return;
        sa[f] = !0;
        var A = "";
        s && s._owner && s._owner !== De.current && (A = " It was passed a child from " + j(s._owner.type) + "."), ue(s), U('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, A), ue(null);
      }
    }
    function na(s, m) {
      {
        if (typeof s != "object")
          return;
        if (be(s))
          for (var f = 0; f < s.length; f++) {
            var A = s[f];
            ze(A) && la(A, m);
          }
        else if (ze(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var k = S(s);
          if (typeof k == "function" && k !== s.entries)
            for (var Z = k.call(s), x; !(x = Z.next()).done; )
              ze(x.value) && la(x.value, m);
        }
      }
    }
    function Ka(s) {
      {
        var m = s.type;
        if (m == null || typeof m == "string")
          return;
        var f;
        if (typeof m == "function")
          f = m.propTypes;
        else if (typeof m == "object" && (m.$$typeof === b || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        m.$$typeof === h))
          f = m.propTypes;
        else
          return;
        if (f) {
          var A = j(m);
          Je(f, s.props, "prop", A, s);
        } else if (m.PropTypes !== void 0 && !Be) {
          Be = !0;
          var k = j(m);
          U("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", k || "Unknown");
        }
        typeof m.getDefaultProps == "function" && !m.getDefaultProps.isReactClassApproved && U("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qa(s) {
      {
        for (var m = Object.keys(s.props), f = 0; f < m.length; f++) {
          var A = m[f];
          if (A !== "children" && A !== "key") {
            ue(s), U("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", A), ue(null);
            break;
          }
        }
        s.ref !== null && (ue(s), U("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
      }
    }
    var ra = {};
    function ca(s, m, f, A, k, Z) {
      {
        var x = Q(s);
        if (!x) {
          var v = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var K = Ga(k);
          K ? v += K : v += ta();
          var R;
          s === null ? R = "null" : be(s) ? R = "array" : s !== void 0 && s.$$typeof === e ? (R = "<" + (j(s.type) || "Unknown") + " />", v = " Did you accidentally export a JSX literal instead of a component?") : R = typeof s, U("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, v);
        }
        var P = za(s, m, f, k, Z);
        if (P == null)
          return P;
        if (x) {
          var ae = m.children;
          if (ae !== void 0)
            if (A)
              if (be(ae)) {
                for (var Ae = 0; Ae < ae.length; Ae++)
                  na(ae[Ae], s);
                Object.freeze && Object.freeze(ae);
              } else
                U("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(ae, s);
        }
        if (W.call(m, "key")) {
          var ge = j(s), J = Object.keys(m).filter(function(at) {
            return at !== "key";
          }), Ge = J.length > 0 ? "{key: someKey, " + J.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ra[ge + Ge]) {
            var et = J.length > 0 ? "{" + J.join(": ..., ") + ": ...}" : "{}";
            U(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, ge, et, ge), ra[ge + Ge] = !0;
          }
        }
        return s === r ? qa(P) : Ka(P), P;
      }
    }
    function Ya(s, m, f) {
      return ca(s, m, f, !0);
    }
    function Ja(s, m, f) {
      return ca(s, m, f, !1);
    }
    var Xa = Ja, Qa = Ya;
    ma.Fragment = r, ma.jsx = Xa, ma.jsxs = Qa;
  }()), ma;
}
process.env.NODE_ENV === "production" ? ut.exports = Vl() : ut.exports = Pl();
var c = ut.exports;
const Il = ({
  panels: t,
  side: e,
  activePanel: l,
  onPanelChange: r
}) => /* @__PURE__ */ c.jsx(c.Fragment, { children: Object.entries(t).map(([n, o]) => /* @__PURE__ */ c.jsx(
  Xt,
  {
    icon: o.icon,
    text: o.label,
    onClick: () => r?.(l === n ? null : n),
    active: l === n
  },
  n
)) }), Ol = {
  left: null,
  right: null
  // panelene er lukket ved oppstart
}, rs = Za({
  name: "panel",
  initialState: Ol,
  reducers: {
    setActiveLeftPanel(t, e) {
      t.left = e.payload;
    },
    setActiveRightPanel(t, e) {
      t.right = e.payload;
    }
  }
}), { setActiveLeftPanel: hi, setActiveRightPanel: ui } = rs.actions, Ai = rs.reducer, Ni = () => wt((t) => t.panel.left), Si = () => wt((t) => t.panel.right), Ui = () => zs();
function wi({
  title: t,
  description: e,
  logo: l = "geodata-logo.png",
  user: r,
  onSignOut: n,
  onShowInfo: o,
  onToggleMenu: y,
  showMenuButton: d = !1,
  showInfoButton: b = !1
}) {
  const { t: i, i18n: g } = qe("uiComponents"), [h, p] = H(!1);
  return F(() => {
    Ht.setLocale(g.language);
  }, []), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs(Ws, { slot: "header", children: [
      d && /* @__PURE__ */ c.jsx(
        La,
        {
          slot: "navigation-action",
          icon: "hamburger",
          text: "Toggle menu",
          onClick: y
        }
      ),
      /* @__PURE__ */ c.jsx(
        Ks,
        {
          slot: "logo",
          heading: t || i("header.title"),
          description: e || i("header.description"),
          thumbnail: l
        }
      ),
      b && /* @__PURE__ */ c.jsx(
        La,
        {
          slot: "content-end",
          id: "header-information",
          icon: "question",
          text: i("header.showInfoLabel"),
          scale: "l",
          onClick: o
        }
      ),
      /* @__PURE__ */ c.jsxs(
        qs,
        {
          slot: "user",
          id: "header-user-dropdown",
          onCalciteDropdownOpen: () => p(!0),
          onCalciteDropdownClose: () => p(!1),
          open: h ? !0 : void 0,
          onCalciteDropdownSelect: () => p(!1),
          widthScale: "m",
          children: [
            /* @__PURE__ */ c.jsx(
              La,
              {
                slot: "trigger",
                id: "header-settings",
                icon: "gear",
                text: i("header.showInfoLabel"),
                scale: "l"
              }
            ),
            r && /* @__PURE__ */ c.jsx(
              Ys,
              {
                slot: "trigger",
                active: h ? !0 : void 0,
                fullName: r.fullName,
                username: r.username,
                thumbnail: r.thumbnailUrl
              }
            ),
            /* @__PURE__ */ c.jsx(tt, { selectionMode: "none", children: /* @__PURE__ */ c.jsx(st, { iconStart: "language-translate", onCalciteDropdownItemSelect: () => {
              const N = g.language == "nb" ? "en" : "nb";
              g.changeLanguage(N), Ht.setLocale(N);
            }, children: i("header.languageToggleLabel") }) }),
            /* @__PURE__ */ c.jsx(tt, { selectionMode: "none", children: r?.orgUrl && /* @__PURE__ */ c.jsx(st, { iconStart: "arcgis-online", onCalciteDropdownItemSelect: () => {
              window.open(r.orgUrl, "_blank");
            }, children: i("header.arcgisOnlineLabel") }) }),
            n && /* @__PURE__ */ c.jsx(tt, { selectionMode: "none", children: /* @__PURE__ */ c.jsx(st, { iconStart: "sign-out", onCalciteDropdownItemSelect: n, children: i("header.signoutLabel") }) })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ c.jsx(Tt, { placement: "bottom-end", closeOnClick: !0, referenceElement: "header-information", children: i("header.showInfoTooltip") }),
    /* @__PURE__ */ c.jsx(Tt, { placement: "bottom-end", closeOnClick: !0, referenceElement: "header-user-dropdown", open: void 0, children: i("header.userDropdownTooltip") })
  ] });
}
const _i = ({ panels: t, activePanel: e }) => {
  if (!e || !t[e])
    return null;
  console.log("Rendering LeftPanel with activePanel:", e);
  const l = t[e].component;
  return /* @__PURE__ */ c.jsx("div", { className: "left-panel", children: /* @__PURE__ */ c.jsx(l, {}) });
}, vi = ({ panels: t, activePanel: e }) => !e || !t[e] ? null : /* @__PURE__ */ c.jsx("div", { className: "right-panel", children: t[e].panel }), Fl = ({
  panels: t,
  activePanel: e,
  className: l,
  onHeadingChange: r,
  onDescriptionChange: n
}) => {
  if (!e || !t[e])
    return null;
  const y = t[e].component;
  return /* @__PURE__ */ c.jsx("div", { className: l, children: /* @__PURE__ */ c.jsx(
    y,
    {
      onHeadingChange: r,
      onDescriptionChange: n
    }
  ) });
}, cs = ({
  panels: t,
  activePanel: e,
  onPanelChange: l,
  onPanelClose: r,
  side: n,
  expanded: o,
  initialWidth: y,
  onPanelInfo: d
}) => {
  const [b, i] = H(""), [g, h] = H(void 0);
  if (F(() => {
    if (e && t[e]) {
      const u = t[e];
      i(u.heading || u.label), h(u.description);
    } else
      i(""), h(void 0);
  }, [e, t]), !t)
    return null;
  const p = n === "left", N = n === "left" ? "start" : "end", E = n === "left" ? "panel-start" : "panel-end";
  return /* @__PURE__ */ c.jsxs(
    Js,
    {
      position: N,
      slot: E,
      resizable: !0,
      collapsed: !e,
      style: {
        "--calcite-shell-panel-width": y || "400px",
        "--calcite-shell-panel-max-width": "70vw"
      },
      ...p && { layout: "vertical" },
      children: [
        /* @__PURE__ */ c.jsx(Xs, { id: "main_toolbar", slot: "action-bar", expanded: o, children: /* @__PURE__ */ c.jsx(
          Il,
          {
            panels: t,
            side: n,
            activePanel: e,
            onPanelChange: l
          }
        ) }),
        /* @__PURE__ */ c.jsx(Qs, { children: /* @__PURE__ */ c.jsxs(
          el,
          {
            heading: b,
            collapsible: !0,
            closable: !0,
            closed: !e,
            description: g,
            onCalciteFlowItemClose: r,
            children: [
              e && /* @__PURE__ */ c.jsx(
                La,
                {
                  slot: "header-actions-end",
                  id: "panel-information",
                  icon: "question",
                  text: "Show panel info",
                  scale: "l",
                  onClick: () => d?.(e)
                }
              ),
              /* @__PURE__ */ c.jsx(
                Fl,
                {
                  panels: t,
                  activePanel: e,
                  className: p ? "left-panel" : "right-panel",
                  onHeadingChange: i,
                  onDescriptionChange: h
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, Li = (t) => /* @__PURE__ */ c.jsx(
  cs,
  {
    ...t,
    side: "left",
    expanded: !0
  }
), Ei = (t) => /* @__PURE__ */ c.jsx(
  cs,
  {
    ...t,
    side: "right"
  }
);
function xi() {
  const { t } = qe("map"), e = X(null), l = X(), { mapView: r, sceneView: n, mapMode: o } = Fe();
  F(() => () => {
    l.current?.removeHandles("location-analytics");
  }, []), F(() => {
    if (!l.current) {
      const b = o === ya.ThreeD ? n : r;
      b && (l.current = y(b));
    }
  }, [o, r, n]), F(() => {
    if (!l.current)
      return;
    const b = o === ya.ThreeD ? n : r;
    b && l.current.view !== b && (console.log(`Switching LayerList to ${o === ya.ThreeD ? "3D" : "2D"} view`), l.current.view = b);
  }, [o, r, n]);
  const y = (b) => {
    console.log("Creating LayerList widget with view:", b.type);
    const i = new al({
      view: b,
      // Bruk den passede view'et
      container: e.current,
      filterPlaceholder: t("layerlist.filterPlaceholder"),
      dragEnabled: !0,
      visibleElements: {
        filter: !0,
        statusIndicators: !0
      },
      listItemCreatedFunction: function(p) {
        const N = p.item;
        N.actionsSections = [
          [
            {
              title: "Delete",
              icon: "trash",
              id: "delete"
            },
            {
              title: "Layer information",
              icon: "information",
              id: "information"
            }
          ]
        ];
      }
    }), g = i.on("trigger-action", (p) => {
      console.log(p), p.action.id === "delete" && l.current?.view?.map && l.current.view.map.remove(p.item.layer);
    }), h = je.watch(() => l.current?.viewModel.state, (p) => {
      console.log("LayerList state", p);
    });
    return i.addHandles([g, h], "location-analytics"), i;
  }, d = {
    display: "unset"
  };
  return /* @__PURE__ */ c.jsx("div", { children: /* @__PURE__ */ c.jsx("div", { id: "esri-layer-list", style: d, className: "widget-container", ref: e }) });
}
const $l = "LayerListCustom-module__item___qrsm5", Dl = "LayerListCustom-module__row___07KOG", Bl = "LayerListCustom-module__dragHandle___-70p3", zl = "LayerListCustom-module__dragging___JoSbZ", Gl = "LayerListCustom-module__dropAbove___4kUlw", Wl = "LayerListCustom-module__dropBelow___JIlJ9", Kl = "LayerListCustom-module__expandBtn___WsMcW", ql = "LayerListCustom-module__spacer___mSQAU", Yl = "LayerListCustom-module__children___cKm0l", Jl = "LayerListCustom-module__container___6-8QZ", Xl = "LayerListCustom-module__searchInput___dCQFL", Se = {
  item: $l,
  row: Dl,
  dragHandle: Bl,
  dragging: zl,
  dropAbove: Gl,
  dropBelow: Wl,
  expandBtn: Kl,
  spacer: ql,
  children: Yl,
  container: Jl,
  searchInput: Xl
}, Ql = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M236,184a12,12,0,0,1-24,0A84,84,0,0,0,68.6,124.6L53.11,140H88a12,12,0,0,1,0,24H24a12,12,0,0,1-12-12V88a12,12,0,0,1,24,0v35.16l15.66-15.55A108,108,0,0,1,236,184Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M88,152H24V88Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M201.54,110.46a104,104,0,0,0-145.4-1.63L29.66,82.34A8,8,0,0,0,16,88v64a8,8,0,0,0,8,8H88a8,8,0,0,0,5.66-13.66L67.47,120.16A88,88,0,0,1,216,184a8,8,0,0,0,16,0A103.33,103.33,0,0,0,201.54,110.46ZM32,144V107.31L68.69,144Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,67.47,120.16l26.19,26.18A8,8,0,0,1,88,160H24a8,8,0,0,1-8-8V88a8,8,0,0,1,13.66-5.66l26.48,26.48A104,104,0,0,1,232,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M230,184a6,6,0,0,1-12,0A90,90,0,0,0,64.36,120.36L38.55,146H88a6,6,0,0,1,0,12H24a6,6,0,0,1-6-6V88a6,6,0,0,1,12,0v49.58l25.89-25.72A102,102,0,0,1,230,184Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,65.78,121.78L43.4,144H88a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0v44.77l22.48-22.33A104,104,0,0,1,232,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M228,184a4,4,0,0,1-8,0A92,92,0,0,0,63,119L33.7,148H88a4,4,0,0,1,0,8H24a4,4,0,0,1-4-4V88a4,4,0,0,1,8,0v54.39l29.3-29.11A100,100,0,0,1,228,184Z" }))
  ]
]), en = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M244,88v64a12,12,0,0,1-12,12H168a12,12,0,0,1,0-24h34.9l-15.48-15.37A84,84,0,0,0,44,184a12,12,0,0,1-24,0,108,108,0,0,1,184.37-76.37L220,123.16V88a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M232,88v64H168Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M235.06,80.61a8,8,0,0,0-8.72,1.73l-26.48,26.49A104,104,0,0,0,24,184a8,8,0,0,0,16,0,88,88,0,0,1,148.53-63.84l-26.19,26.18A8,8,0,0,0,168,160h64a8,8,0,0,0,8-8V88A8,8,0,0,0,235.06,80.61ZM224,144H187.31L224,107.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M240,88v64a8,8,0,0,1-8,8H168a8,8,0,0,1-5.66-13.66l26.19-26.18A88,88,0,0,0,40,184a8,8,0,0,1-16,0,104,104,0,0,1,175.86-75.18l26.48-26.48A8,8,0,0,1,240,88Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M238,88v64a6,6,0,0,1-6,6H168a6,6,0,0,1,0-12h49.45l-25.8-25.63A90,90,0,0,0,38,184a6,6,0,0,1-12,0,102,102,0,0,1,174.12-72.12L226,137.58V88a6,6,0,0,1,12,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M240,88v64a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h44.6l-22.36-22.21A88,88,0,0,0,40,184a8,8,0,0,1-16,0,104,104,0,0,1,177.54-73.54L224,132.77V88a8,8,0,0,1,16,0Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M236,88v64a4,4,0,0,1-4,4H168a4,4,0,0,1,0-8h54.3l-29.24-29A92,92,0,0,0,36,184a4,4,0,0,1-8,0,100,100,0,0,1,170.71-70.71L228,142.39V88a4,4,0,0,1,8,0Z" }))
  ]
]), an = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), tn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]), sn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), ln = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M232,128A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Z" }))
  ]
]), nn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M224.15,179.17l-46.83-46.82,37.93-13.51.76-.3a20,20,0,0,0-1.76-37.27L54.16,29A20,20,0,0,0,29,54.16L81.27,214.24A20,20,0,0,0,118.54,216c.11-.25.21-.5.3-.76l13.51-37.92,46.83,46.82a20,20,0,0,0,28.28,0l16.69-16.68A20,20,0,0,0,224.15,179.17Zm-30.83,25.17-48.48-48.48A20,20,0,0,0,130.7,150a20.66,20.66,0,0,0-3.74.35A20,20,0,0,0,112.35,162c-.11.25-.21.5-.3.76L100.4,195.5,54.29,54.29l141.21,46.1-32.71,11.66c-.26.09-.51.19-.76.3a20,20,0,0,0-6.17,32.48h0l48.49,48.48Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M213.66,201,201,213.66a8,8,0,0,1-11.31,0l-51.31-51.31a8,8,0,0,0-13,2.46l-17.82,46.41a8,8,0,0,1-14.85-.71L40.41,50.44a8,8,0,0,1,10-10L210.51,92.68a8,8,0,0,1,.71,14.85l-46.41,17.82a8,8,0,0,0-2.46,13l51.31,51.31A8,8,0,0,1,213.66,201Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M220.49,207.8,207.8,220.49a12,12,0,0,1-17,0l-56.57-56.57L115,214.08l-.13.33A15.84,15.84,0,0,1,100.26,224l-.78,0a15.82,15.82,0,0,1-14.41-11L32.8,52.92A15.95,15.95,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.33.13-50.16,19.27,56.57,56.56A12,12,0,0,1,220.49,207.8Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M166.59,134.1a1.91,1.91,0,0,1-.55-1.79,2,2,0,0,1,1.08-1.42l46.25-17.76.24-.1A14,14,0,0,0,212.38,87L52.29,34.7A13.95,13.95,0,0,0,34.7,52.29L87,212.38a13.82,13.82,0,0,0,12.6,9.6c.23,0,.46,0,.69,0A13.84,13.84,0,0,0,113,213.61a2.44,2.44,0,0,0,.1-.24l17.76-46.25a2,2,0,0,1,3.21-.53l51.31,51.31a14,14,0,0,0,19.8,0l12.69-12.69a14,14,0,0,0,0-19.8Zm42.82,62.63-12.68,12.68a2,2,0,0,1-2.83,0L142.59,158.1a14,14,0,0,0-22.74,4.32,2.44,2.44,0,0,0-.1.24L102,208.91a2,2,0,0,1-3.61-.26L46.11,48.57a1.87,1.87,0,0,1,.47-2A1.92,1.92,0,0,1,47.93,46a2.22,2.22,0,0,1,.64.1L208.65,98.38a2,2,0,0,1,.26,3.61l-46.25,17.76-.24.1a14,14,0,0,0-4.32,22.74h0l51.31,51.31A2,2,0,0,1,209.41,196.73Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M165.17,135.51a4,4,0,0,1,1.17-6.46l46.31-17.79.16-.06a12,12,0,0,0-1.05-22.33L51.67,36.6A12,12,0,0,0,36.6,51.67L88.87,211.76A11.86,11.86,0,0,0,99.67,220h.58a11.86,11.86,0,0,0,11-7.19l.06-.16,17.79-46.31a4,4,0,0,1,6.47-1.17l51.31,51.32a12,12,0,0,0,17,0l12.69-12.69a12,12,0,0,0,0-17Zm45.66,62.63-12.69,12.69a4,4,0,0,1-5.66,0l-51.31-51.31a12,12,0,0,0-8.48-3.52,12.13,12.13,0,0,0-2.24.21,12,12,0,0,0-8.77,7l-.06.16-17.79,46.31a4,4,0,0,1-7.36-.42L44.2,49.19a4,4,0,0,1,5-5L209.27,96.47a4,4,0,0,1,.42,7.36l-46.31,17.78-.16.07a12,12,0,0,0-3.71,19.49l51.32,51.31A4,4,0,0,1,210.83,198.14Z" }))
  ]
]), rn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M108,60A16,16,0,1,1,92,44,16,16,0,0,1,108,60Zm56,16a16,16,0,1,0-16-16A16,16,0,0,0,164,76ZM92,112a16,16,0,1,0,16,16A16,16,0,0,0,92,112Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,112ZM92,180a16,16,0,1,0,16,16A16,16,0,0,0,92,180Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M208,32V224a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V32A16,16,0,0,1,64,16H192A16,16,0,0,1,208,32Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M192,16H64A16,16,0,0,0,48,32V224a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V32A16,16,0,0,0,192,16ZM100,200a12,12,0,1,1,12-12A12,12,0,0,1,100,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,80Zm56,120a12,12,0,1,1,12-12A12,12,0,0,1,156,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M102,60A10,10,0,1,1,92,50,10,10,0,0,1,102,60Zm62,10a10,10,0,1,0-10-10A10,10,0,0,0,164,70ZM92,118a10,10,0,1,0,10,10A10,10,0,0,0,92,118Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,118ZM92,186a10,10,0,1,0,10,10A10,10,0,0,0,92,186Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M100,60a8,8,0,1,1-8-8A8,8,0,0,1,100,60Zm64,8a8,8,0,1,0-8-8A8,8,0,0,0,164,68ZM92,120a8,8,0,1,0,8,8A8,8,0,0,0,92,120Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,120ZM92,188a8,8,0,1,0,8,8A8,8,0,0,0,92,188Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,188Z" }))
  ]
]), cn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M251,123.13c-.37-.81-9.13-20.26-28.48-39.61C196.63,57.67,164,44,128,44S59.37,57.67,33.51,83.52C14.16,102.87,5.4,122.32,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212s68.63-13.66,94.48-39.51c19.36-19.35,28.12-38.79,28.49-39.61A12.08,12.08,0,0,0,251,123.13Zm-46.06,33C183.47,177.27,157.59,188,128,188s-55.47-10.73-76.91-31.88A130.36,130.36,0,0,1,29.52,128,130.45,130.45,0,0,1,51.09,99.89C72.54,78.73,98.41,68,128,68s55.46,10.73,76.91,31.89A130.36,130.36,0,0,1,226.48,128,130.45,130.45,0,0,1,204.91,156.12ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,148Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M245.48,125.57c-.34-.78-8.66-19.23-27.24-37.81C201,70.54,171.38,50,128,50S55,70.54,37.76,87.76c-18.58,18.58-26.9,37-27.24,37.81a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206s73-20.53,90.24-37.75c18.58-18.58,26.9-37,27.24-37.8A6,6,0,0,0,245.48,125.57ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.77,134.77,0,0,1,22.69,128,134.56,134.56,0,0,1,46.55,95.94C69.22,73.42,96.62,62,128,62s58.78,11.42,81.45,33.94A134.56,134.56,0,0,1,233.31,128C226.94,140.21,195,194,128,194Zm0-112a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M243.66,126.38c-.34-.76-8.52-18.89-26.83-37.2C199.87,72.22,170.7,52,128,52S56.13,72.22,39.17,89.18c-18.31,18.31-26.49,36.44-26.83,37.2a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17s71.87-20.21,88.83-37.17c18.31-18.31,26.49-36.43,26.83-37.2A4.08,4.08,0,0,0,243.66,126.38Zm-32.7,35c-23.07,23-51,34.62-83,34.62s-59.89-11.65-83-34.62A135.71,135.71,0,0,1,20.44,128,135.69,135.69,0,0,1,45,94.62C68.11,71.65,96,60,128,60s59.89,11.65,83,34.62A135.79,135.79,0,0,1,235.56,128,135.71,135.71,0,0,1,211,161.38ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z" }))
  ]
]), on = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), mn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M207.83,56.53C186.32,43.29,158,36,128,36S69.68,43.29,48.17,56.53C24.85,70.89,12,90.6,12,112s12.85,41.14,36.17,55.5c18.48,11.37,42,18.34,67.29,20.08-2,11.07-9.09,17.75-15.22,21.54-13.48,8.31-32.75,9.18-46.86,2.1A12,12,0,1,0,42.62,232.7a71.76,71.76,0,0,0,32,7.3,73.2,73.2,0,0,0,38.18-10.43c15.45-9.54,25-24.58,26.83-41.9,25.6-1.64,49.47-8.65,68.16-20.15C231.15,153.16,244,133.45,244,112S231.15,70.89,207.83,56.53Zm-134.44,97a21,21,0,0,1,20.16-9.35c10.36,1.39,16.54,9.43,19.72,19.13A135.3,135.3,0,0,1,73.39,153.56Zm64.87,10.14a61.84,61.84,0,0,0-10.76-24.82,46.08,46.08,0,0,0-30.75-18.46c-18-2.41-34.52,5.89-44.1,21C42.2,133,36,122.84,36,112c0-28.19,42.13-52,92-52s92,23.82,92,52C220,138.26,183.51,160.71,138.26,163.7Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M232,112c0,35.35-46.56,64-104,64S24,147.35,24,112,70.56,48,128,48,232,76.65,232,112Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M205.73,59.93C184.85,47.08,157.24,40,128,40S71.15,47.08,50.27,59.93C28.17,73.52,16,92,16,112S28.17,150.44,50.27,164c19,11.67,43.49,18.56,69.73,19.73v0a37.35,37.35,0,0,1-18.58,33c-14.64,8.86-34.62,9.52-49.72,1.64a8,8,0,1,0-7.4,14.18A66.4,66.4,0,0,0,75,240a67.31,67.31,0,0,0,34.74-9.5c17-10.27,26.29-26.86,26.29-46.7v0c26.24-1.17,50.76-8.06,69.73-19.73C227.83,150.44,240,132,240,112S227.83,73.52,205.73,59.93ZM67.41,155.18c5.24-9.55,15.45-12,23.53-11,10.9,1.42,21.86,9.13,26.61,23.42C99.11,166.45,81.85,162.16,67.41,155.18Zm129.94-4.77c-16.95,10.43-39.17,16.53-63.13,17.43a54.37,54.37,0,0,0-11.39-23.07A47.17,47.17,0,0,0,93,128.35c-17-2.2-31.72,5.11-39.38,18.7C39.64,137,32,124.73,32,112c0-14.21,9.47-27.86,26.65-38.43C77.05,62.23,101.68,56,128,56S179,62.23,197.35,73.55C214.53,84.12,224,97.77,224,112S214.53,139.84,197.35,150.41Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M93.43,136.11a17.14,17.14,0,0,0-15.35,6.1c9.31,6.56,22.51,11.33,37.43,13.07C110.41,143.33,101.72,137,93.43,136.11Z" }), /* @__PURE__ */ a.createElement("path", { d: "M224,48V208a16,16,0,0,1-16,16H127.65a4,4,0,0,1-3.23-6.34c7.5-10.23,11.58-23.24,11.58-37.84,0-2.79-.13-5.46-.35-8.05C176.79,169.33,208,147.47,208,120c0-29.15-35.14-52-80-52S48,90.84,48,120c0,27.31,30.82,49.07,71.58,51.73a77,77,0,0,1,.42,8.09c0,17.62-7.65,31.95-21,39.32A38.77,38.77,0,0,1,79.27,224H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-32,72c0-19.51-29.31-36-64-36s-64,16.48-64,36a21.29,21.29,0,0,0,3,10.63A33.65,33.65,0,0,1,95.16,120.2c15,1.63,30.84,13.4,37.54,35.68C165.3,154.47,192,138.62,192,120Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M204.68,61.63C184.11,49,156.88,42,128,42S71.89,49,51.32,61.63C29.83,74.85,18,92.73,18,112s11.83,37.13,33.32,50.35C70.45,174.1,95.35,181,122,181.85c0,.64,0,1.28,0,1.94,0,14.76-6.94,27.1-19.54,34.73-15.22,9.22-36,9.9-51.68,1.71a6,6,0,1,0-5.56,10.63A64.45,64.45,0,0,0,75,238a65.24,65.24,0,0,0,33.7-9.22c16.34-9.89,25.33-25.87,25.33-45,0-.65,0-1.29,0-1.94,26.65-.89,51.57-7.74,70.72-19.52C226.17,149.11,238,131.23,238,112S226.17,74.85,204.68,61.63Zm-140,94.46c5.32-12,17.2-15.07,26.48-13.87,12.28,1.6,24.64,10.67,29.08,27.55C99.73,168.81,80.48,164.08,64.72,156.09Zm133.67-4c-17.62,10.85-40.83,17.1-65.77,17.79a52.77,52.77,0,0,0-11.31-23.84,45.24,45.24,0,0,0-28.56-15.73c-16.89-2.2-31.49,5.54-38.41,19.68C38.61,139.37,30,126,30,112c0-14.93,9.8-29.18,27.61-40.13C76.32,60.34,101.32,54,128,54s51.68,6.34,70.39,17.85C216.2,82.8,226,97.05,226,112S216.2,141.16,198.39,152.11Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M205.73,59.93C184.85,47.08,157.24,40,128,40S71.15,47.08,50.27,59.93C28.17,73.52,16,92,16,112S28.17,150.44,50.27,164c19,11.67,43.49,18.56,69.73,19.73v0a37.35,37.35,0,0,1-18.58,33c-14.64,8.86-34.62,9.52-49.72,1.64a8,8,0,1,0-7.4,14.18A66.4,66.4,0,0,0,75,240a67.31,67.31,0,0,0,34.74-9.5c17-10.27,26.29-26.86,26.29-46.7v0c26.24-1.17,50.76-8.06,69.73-19.73C227.83,150.44,240,132,240,112S227.83,73.52,205.73,59.93ZM67.41,155.18c5.24-9.55,15.44-12,23.53-11,10.9,1.42,21.86,9.13,26.61,23.42C99.11,166.45,81.85,162.16,67.41,155.18Zm129.94-4.77c-16.95,10.43-39.17,16.53-63.13,17.43a54.37,54.37,0,0,0-11.39-23.07A47.17,47.17,0,0,0,93,128.35c-17-2.2-31.72,5.11-39.38,18.7C39.64,137,32,124.73,32,112c0-14.21,9.47-27.86,26.65-38.43C77.05,62.23,101.68,56,128,56S179,62.23,197.35,73.55C214.53,84.12,224,97.77,224,112S214.53,139.84,197.35,150.41Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M203.64,63.34C183.37,50.87,156.51,44,128,44S72.63,50.87,52.36,63.34C31.49,76.19,20,93.48,20,112s11.49,35.83,32.36,48.68c19.29,11.87,44.55,18.65,71.51,19.28.08,1.27.13,2.56.13,3.9,0,15.49-7.28,28.44-20.51,36.46-15.79,9.57-37.34,10.28-53.64,1.77a4,4,0,1,0-3.7,7.09A62.32,62.32,0,0,0,74.91,236a63.56,63.56,0,0,0,32.73-8.82c15.71-9.52,24.36-24.9,24.36-43.3,0-1.32-.05-2.61-.12-3.9,27.06-.59,52.41-7.38,71.76-19.28C224.51,147.85,236,130.56,236,112S224.51,76.19,203.64,63.34ZM62.16,157.15c5.3-14.49,18.83-18.22,29.3-16.85,13.64,1.78,27.38,12.19,31.38,31.66C99.66,171.25,78.55,165.78,62.16,157.15ZM131,172a51.35,51.35,0,0,0-11.18-24.59,43.28,43.28,0,0,0-27.3-15.06c-16.82-2.19-31.24,6-37.33,20.74C38.33,142.35,28,127.9,28,112c0-33.09,44.86-60,100-60s100,26.93,100,60C228,144.52,184.74,171.06,131,172Z" }))
  ]
]), bn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M217.47,38.53a36,36,0,0,0-57.95,41l-80,80a36.07,36.07,0,0,0-41,7h0a36,36,0,1,0,58,9.95l80-80a36,36,0,0,0,41-57.95Zm-145,162a12,12,0,1,1,0-17A12,12,0,0,1,72.48,200.5Zm128-128a12,12,0,0,1-17,0h0a12,12,0,1,1,17,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M81,175A24,24,0,1,1,47,175,24,24,0,0,1,81,175ZM209,47A24,24,0,1,0,209,81,24,24,0,0,0,209,47Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M214.64,41.36a32,32,0,0,0-50.2,38.89L80.25,164.44a32.06,32.06,0,0,0-38.89,4.94h0a32,32,0,1,0,50.2,6.37l84.19-84.19a32,32,0,0,0,38.89-50.2Zm-139.33,162a16,16,0,0,1-22.64-22.64h0a16,16,0,0,1,22.63,0h0A16,16,0,0,1,75.31,203.33Zm128-128a16,16,0,1,1,0-22.63A16,16,0,0,1,203.33,75.3Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M211.81,83.79a28,28,0,0,1-33.12,4.83L88.62,178.69a28,28,0,1,1-44.43-6.48h0a28,28,0,0,1,33.12-4.83l90.07-90.07a28,28,0,1,1,44.43,6.48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M213.23,42.77A30,30,0,0,0,167,80.54L80.54,167a30.07,30.07,0,0,0-37.77,3.81h0A30,30,0,1,0,89,175.46L175.46,89a30,30,0,0,0,37.77-46.25Zm-136.51,162a18,18,0,1,1,0-25.46A18,18,0,0,1,76.72,204.74Zm128-128a18,18,0,0,1-25.46,0h0a18,18,0,1,1,25.46,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M214.64,41.36a32,32,0,0,0-50.2,38.89L80.25,164.44a32.06,32.06,0,0,0-38.89,4.94h0a32,32,0,1,0,50.2,6.37l84.19-84.19a32,32,0,0,0,38.89-50.2Zm-139.33,162a16,16,0,0,1-22.64-22.64h0a16,16,0,0,1,22.63,0h0A16,16,0,0,1,75.31,203.33Zm128-128a16,16,0,1,1,0-22.63A16,16,0,0,1,203.33,75.3Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M211.81,44.19a28,28,0,0,0-42.23,36.57L80.76,169.58a28,28,0,0,0-36.57,2.63h0a28,28,0,1,0,42.23,3l88.82-88.82a28,28,0,0,0,36.57-42.23Zm-133.67,162a20,20,0,1,1,0-28.28A20,20,0,0,1,78.14,206.15Zm128-128a20,20,0,0,1-28.28,0h0a20,20,0,1,1,28.28,0Z" }))
  ]
]), dn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M200,36H160a20,20,0,0,0-20,20v88a12,12,0,0,1-24,0V56A20,20,0,0,0,96,36H56A20,20,0,0,0,36,56v88a92,92,0,0,0,92,92h.71c50.34-.38,91.3-42.1,91.3-93V56A20,20,0,0,0,200,36Zm-4,24V84H164V60ZM92,60V84H60V60Zm36.52,152H128a68,68,0,0,1-68-68V108H92v36a36,36,0,0,0,72,0V108h32v35C196,180.77,165.73,211.72,128.52,212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M104,56V96H48V56a8,8,0,0,1,8-8H96A8,8,0,0,1,104,56Zm96-8H160a8,8,0,0,0-8,8V96h56V56A8,8,0,0,0,200,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V88H160V56ZM96,56V88H56V56Zm32.55,160A72,72,0,0,1,56,144V104H96v40a32,32,0,0,0,64,0V104h40v39C200,183,168,215.71,128.55,216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M200,42H160a14,14,0,0,0-14,14v88a18,18,0,0,1-36,0V56A14,14,0,0,0,96,42H56A14,14,0,0,0,42,56v88a86,86,0,0,0,86,86h.65c47.06-.35,85.35-39.38,85.35-87V56A14,14,0,0,0,200,42ZM160,54h40a2,2,0,0,1,2,2V90H158V56A2,2,0,0,1,160,54ZM56,54H96a2,2,0,0,1,2,2V90H54V56A2,2,0,0,1,56,54Zm72.56,164H128a74,74,0,0,1-74-74V102H98v42a30,30,0,0,0,60,0V102h44v41C202,184.05,169.06,217.7,128.56,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V88H160V56ZM96,56V88H56V56Zm32.55,160A72,72,0,0,1,56,144V104H96v40a32,32,0,0,0,64,0V104h40v39C200,183,168,215.71,128.55,216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M200,44H160a12,12,0,0,0-12,12v88a20,20,0,0,1-40,0V56A12,12,0,0,0,96,44H56A12,12,0,0,0,44,56v88a84,84,0,0,0,84,84h.64c46-.34,83.36-38.47,83.36-85V56A12,12,0,0,0,200,44Zm-40,8h40a4,4,0,0,1,4,4V92H156V56A4,4,0,0,1,160,52ZM56,52H96a4,4,0,0,1,4,4V92H52V56A4,4,0,0,1,56,52Zm72.58,168H128a76,76,0,0,1-76-76V100h48v44a28,28,0,0,0,56,0V100h48v43C204,185.15,170.17,219.69,128.58,220Z" }))
  ]
]), yn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }))
  ]
]), gn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,60a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,60Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,124Zm0-112a92.1,92.1,0,0,0-92,92c0,77.36,81.64,135.4,85.12,137.83a12,12,0,0,0,13.76,0,259,259,0,0,0,42.18-39C205.15,170.57,220,136.37,220,104A92.1,92.1,0,0,0,128,12Zm31.3,174.71A249.35,249.35,0,0,1,128,216.89a249.35,249.35,0,0,1-31.3-30.18C80,167.37,60,137.31,60,104a68,68,0,0,1,136,0C196,137.31,176,167.37,159.3,186.71Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.17,83.41,134.55a8,8,0,0,0,9.18,0C136,236.17,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,66a38,38,0,1,0,38,38A38,38,0,0,0,128,66Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,128,130Zm0-112a86.1,86.1,0,0,0-86,86c0,30.91,14.34,63.74,41.47,94.94a252.32,252.32,0,0,0,41.09,38,6,6,0,0,0,6.88,0,252.32,252.32,0,0,0,41.09-38c27.13-31.2,41.47-64,41.47-94.94A86.1,86.1,0,0,0,128,18Zm0,206.51C113,212.93,54,163.62,54,104a74,74,0,0,1,148,0C202,163.62,143,212.93,128,224.51Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,68a36,36,0,1,0,36,36A36,36,0,0,0,128,68Zm0,64a28,28,0,1,1,28-28A28,28,0,0,1,128,132Zm0-112a84.09,84.09,0,0,0-84,84c0,30.42,14.17,62.79,41,93.62a250,250,0,0,0,40.73,37.66,4,4,0,0,0,4.58,0A250,250,0,0,0,171,197.62c26.81-30.83,41-63.2,41-93.62A84.09,84.09,0,0,0,128,20Zm37.1,172.23A254.62,254.62,0,0,1,128,227a254.62,254.62,0,0,1-37.1-34.81C73.15,171.8,52,139.9,52,104a76,76,0,0,1,152,0C204,139.9,182.85,171.8,165.1,192.23Z" }))
  ]
]), fn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M233.47,97.45a36,36,0,0,0-50.92-50.92h0a36.18,36.18,0,0,0-4.12,4.95l-22.55-6.15a36,36,0,0,0-61.34-22.8h0a36.05,36.05,0,0,0-7.8,39.24L57.19,88.37a36.08,36.08,0,0,0-42.66,6.17h0a36,36,0,0,0,45.73,55.21l65.28,47.87A36,36,0,1,0,182.62,180L208,108A35.91,35.91,0,0,0,233.47,97.45Zm-93.74,80.81L74.45,130.39a36.19,36.19,0,0,0-1.21-24.17L102.8,79.61a36,36,0,0,0,42.66-6.16,35.47,35.47,0,0,0,4.12-5l22.55,6.15a35.86,35.86,0,0,0,10.42,22.8A38.06,38.06,0,0,0,185.4,100L160,172A36,36,0,0,0,139.73,178.26ZM216.5,63.5a12,12,0,1,1-17,0A12,12,0,0,1,216.5,63.5Zm-105-24a12,12,0,1,1,0,17A12,12,0,0,1,111.51,39.5Zm-80,89a12,12,0,1,1,17,0A12,12,0,0,1,31.5,128.49Zm137,88a12,12,0,1,1,0-17A12,12,0,0,1,168.49,216.5Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M137,65A24,24,0,1,1,137,31,24,24,0,0,1,137,65ZM23,103A24,24,0,1,0,57,103,24,24,0,0,0,23,103Zm120,88A24,24,0,1,0,177,191,24,24,0,0,0,143,191ZM225,55A24,24,0,1,0,225,89,24,24,0,0,0,225,55Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M230.64,49.36a32,32,0,0,0-45.26,0h0a31.9,31.9,0,0,0-5.16,6.76L152,48.42A32,32,0,0,0,97.37,25.36h0a32.06,32.06,0,0,0-5.76,37.41L57.67,93.32a32.05,32.05,0,0,0-40.31,4.05h0a32,32,0,0,0,42.89,47.41l70,51.36a32,32,0,1,0,47.57-14.69l27.39-77.59q1.38.12,2.76.12a32,32,0,0,0,22.63-54.62Zm-122-12.69h0a16,16,0,1,1,0,22.64A16,16,0,0,1,108.68,36.67Zm-80,94.65a16,16,0,0,1,0-22.64h0a16,16,0,1,1,0,22.64Zm142.65,88a16,16,0,0,1-22.63-22.63h0a16,16,0,1,1,22.63,22.63Zm-8.55-43.18a32,32,0,0,0-23,7.08l-70-51.36a32.17,32.17,0,0,0-1.34-26.65l33.95-30.55a32,32,0,0,0,45.47-10.81L176,71.56a32,32,0,0,0,14.12,27Zm56.56-92.84A16,16,0,1,1,196.7,60.68h0a16,16,0,0,1,22.63,22.63Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M227.81,52.19a28,28,0,0,0-39.6,0h0a28.14,28.14,0,0,0-4,5L148,47.33A28,28,0,0,0,100.2,28.19h0A28,28,0,0,0,94.7,60L54.58,96.1a28,28,0,0,0-34.39,4.1h0a28,28,0,0,0,36.7,42.12l76.75,56.28a28,28,0,1,0,46.17-10.39,27.66,27.66,0,0,0-3.33-2.84L206.63,100q.69,0,1.38,0a28,28,0,0,0,19.8-47.79ZM161.39,180.05a28,28,0,0,0-18.29,5.64L66.36,129.41A28.15,28.15,0,0,0,65.29,108l40.12-36.11a28,28,0,0,0,38.37-9.12L180,72.66a27.88,27.88,0,0,0,8.17,19.13,28.61,28.61,0,0,0,3.32,2.85Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M229.23,50.78a30,30,0,0,0-42.44,0h0a29.82,29.82,0,0,0-5.56,7.69l-31.31-8.54A30,30,0,0,0,98.78,26.77h0A30.09,30.09,0,0,0,94.13,63.2L57.83,95.87a30.07,30.07,0,0,0-39.06,2.91h0a30,30,0,0,0,41.38,43.44l72.6,53.25a30,30,0,1,0,48.47-8.68,29.65,29.65,0,0,0-5.77-4.5l28.44-80.59A31.57,31.57,0,0,0,208,102a30,30,0,0,0,21.22-51.2Zm-122-15.52a18,18,0,1,1,0,25.46A18,18,0,0,1,107.27,35.26Zm-80,97.47a18,18,0,1,1,25.46,0A18,18,0,0,1,27.26,132.73Zm145.47,88a18,18,0,1,1,0-25.46A18,18,0,0,1,172.73,220.74Zm-8.61-42.43a30,30,0,0,0-24.27,7.48L67.24,132.54a30.14,30.14,0,0,0-1.38-27.75l36.3-32.67a30,30,0,0,0,44.62-10.61l31.31,8.54a30,30,0,0,0,8.7,23.16,30.47,30.47,0,0,0,5.78,4.51Zm56.62-93.59a18,18,0,1,1,0-25.46A18,18,0,0,1,220.74,84.72Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M230.64,49.36a32,32,0,0,0-45.26,0h0a31.9,31.9,0,0,0-5.16,6.76L152,48.42A32,32,0,0,0,97.37,25.36h0a32.06,32.06,0,0,0-5.76,37.41L57.67,93.32a32.05,32.05,0,0,0-40.31,4.05h0a32,32,0,0,0,42.89,47.41l70,51.36a32,32,0,1,0,47.57-14.69l27.39-77.59q1.38.12,2.76.12a32,32,0,0,0,22.63-54.62Zm-122-12.69h0a16,16,0,1,1,0,22.64A16,16,0,0,1,108.68,36.67Zm-80,94.65a16,16,0,0,1,0-22.64h0a16,16,0,1,1,0,22.64Zm142.65,88a16,16,0,0,1-22.63-22.63h0a16,16,0,1,1,22.63,22.63Zm-8.55-43.18a32,32,0,0,0-23,7.08l-70-51.36a32.17,32.17,0,0,0-1.34-26.65l33.95-30.55a32,32,0,0,0,45.47-10.81L176,71.56a32,32,0,0,0,14.12,27Zm56.56-92.84A16,16,0,1,1,196.7,60.68h0a16,16,0,0,1,22.63,22.63Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M227.81,52.19a28,28,0,0,0-39.6,0h0a27.84,27.84,0,0,0-5.88,8.65l-34.56-9.42A28,28,0,0,0,100.2,28.19h0a28.05,28.05,0,0,0-3.48,35.37L57.91,98.49a28,28,0,0,0-37.72,1.71h0a28,28,0,0,0,39.6,39.6l.18-.19,75.32,55.24A28,28,0,1,0,173,183.2l29.56-83.75A28.52,28.52,0,0,0,208,100a28,28,0,0,0,19.8-47.79ZM105.86,33.85a20,20,0,1,1,0,28.29A20,20,0,0,1,105.86,33.85Zm-80,100.29a20,20,0,1,1,28.28,0A20,20,0,0,1,25.85,134.14Zm148.3,88a20,20,0,1,1,0-28.28A20,20,0,0,1,174.15,222.15Zm-8.7-41.6a28,28,0,0,0-25.25,7.66h0l-.18.19L64.71,133.16a28.13,28.13,0,0,0-1.44-28.73L102.08,69.5a28,28,0,0,0,43.6-10.36l34.56,9.43a28,28,0,0,0,8,23.22,27.64,27.64,0,0,0,6.8,5Zm56.7-94.41a20,20,0,1,1,0-28.29A20,20,0,0,1,222.15,86.14Z" }))
  ]
]), pn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,160H44V60H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,158a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,156a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4Z" }))
  ]
]), hn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M100,40a12,12,0,0,1,12-12h32a12,12,0,0,1,0,24H112A12,12,0,0,1,100,40Zm44,164H112a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24ZM208,28H184a12,12,0,0,0,0,24h20V72a12,12,0,0,0,24,0V48A20,20,0,0,0,208,28Zm8,72a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V112A12,12,0,0,0,216,100Zm0,72a12,12,0,0,0-12,12v20H184a12,12,0,0,0,0,24h24a20,20,0,0,0,20-20V184A12,12,0,0,0,216,172ZM40,156a12,12,0,0,0,12-12V112a12,12,0,0,0-24,0v32A12,12,0,0,0,40,156Zm32,48H52V184a12,12,0,0,0-24,0v24a20,20,0,0,0,20,20H72a12,12,0,0,0,0-24ZM40,84A12,12,0,0,0,52,72V52H72a12,12,0,0,0,0-24H48A20,20,0,0,0,28,48V72A12,12,0,0,0,40,84ZM80,68h96a12,12,0,0,1,12,12v96a12,12,0,0,1-12,12H80a12,12,0,0,1-12-12V80A12,12,0,0,1,80,68Zm12,96h72V92H92Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M176,80v96H80V80Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80Zm144,96V80a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v96a8,8,0,0,0,8,8h96A8,8,0,0,0,184,176Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M106,40a6,6,0,0,1,6-6h32a6,6,0,0,1,0,12H112A6,6,0,0,1,106,40Zm38,170H112a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12ZM208,34H184a6,6,0,0,0,0,12h24a2,2,0,0,1,2,2V72a6,6,0,0,0,12,0V48A14,14,0,0,0,208,34Zm8,72a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V112A6,6,0,0,0,216,106Zm0,72a6,6,0,0,0-6,6v24a2,2,0,0,1-2,2H184a6,6,0,0,0,0,12h24a14,14,0,0,0,14-14V184A6,6,0,0,0,216,178ZM40,150a6,6,0,0,0,6-6V112a6,6,0,0,0-12,0v32A6,6,0,0,0,40,150Zm32,60H48a2,2,0,0,1-2-2V184a6,6,0,0,0-12,0v24a14,14,0,0,0,14,14H72a6,6,0,0,0,0-12ZM40,78a6,6,0,0,0,6-6V48a2,2,0,0,1,2-2H72a6,6,0,0,0,0-12H48A14,14,0,0,0,34,48V72A6,6,0,0,0,40,78ZM176,182H80a6,6,0,0,1-6-6V80a6,6,0,0,1,6-6h96a6,6,0,0,1,6,6v96A6,6,0,0,1,176,182Zm-6-96H86v84h84Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M108,40a4,4,0,0,1,4-4h32a4,4,0,0,1,0,8H112A4,4,0,0,1,108,40Zm36,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4,4,0,0,1,4,4V72a4,4,0,0,0,8,0V48A12,12,0,0,0,208,36Zm8,72a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V112A4,4,0,0,0,216,108Zm0,72a4,4,0,0,0-4,4v24a4,4,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12,12,0,0,0,12-12V184A4,4,0,0,0,216,180ZM40,148a4,4,0,0,0,4-4V112a4,4,0,0,0-8,0v32A4,4,0,0,0,40,148Zm32,64H48a4,4,0,0,1-4-4V184a4,4,0,0,0-8,0v24a12,12,0,0,0,12,12H72a4,4,0,0,0,0-8ZM40,76a4,4,0,0,0,4-4V48a4,4,0,0,1,4-4H72a4,4,0,0,0,0-8H48A12,12,0,0,0,36,48V72A4,4,0,0,0,40,76ZM180,176a4,4,0,0,1-4,4H80a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4h96a4,4,0,0,1,4,4Zm-8-92H84v88h88Z" }))
  ]
]), un = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,50H174V40a22,22,0,0,0-22-22H104A22,22,0,0,0,82,40V50H40a6,6,0,0,0,0,12H50V208a14,14,0,0,0,14,14H192a14,14,0,0,0,14-14V62h10a6,6,0,0,0,0-12ZM94,40a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10V50H94ZM194,208a2,2,0,0,1-2,2H64a2,2,0,0,1-2-2V62H194ZM110,104v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Zm48,0v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M216,52H172V40a20,20,0,0,0-20-20H104A20,20,0,0,0,84,40V52H40a4,4,0,0,0,0,8H52V208a12,12,0,0,0,12,12H192a12,12,0,0,0,12-12V60h12a4,4,0,0,0,0-8ZM92,40a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12V52H92ZM196,208a4,4,0,0,1-4,4H64a4,4,0,0,1-4-4V60H196ZM108,104v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Zm48,0v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Z" }))
  ]
]), An = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z" }))
  ]
]), Nn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-12-80V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,172Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm-6-82V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,172Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm-4-84V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,172Z" }))
  ]
]), Sn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]), At = Yt({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), ce = a.forwardRef(
  (t, e) => {
    const {
      alt: l,
      color: r,
      size: n,
      weight: o,
      mirrored: y,
      children: d,
      weights: b,
      ...i
    } = t, {
      color: g = "currentColor",
      size: h,
      weight: p = "regular",
      mirrored: N = !1,
      ...E
    } = a.useContext(At);
    return /* @__PURE__ */ a.createElement(
      "svg",
      {
        ref: e,
        xmlns: "http://www.w3.org/2000/svg",
        width: n ?? h,
        height: n ?? h,
        fill: r ?? g,
        viewBox: "0 0 256 256",
        transform: y || N ? "scale(-1, 1)" : void 0,
        ...E,
        ...i
      },
      !!l && /* @__PURE__ */ a.createElement("title", null, l),
      d,
      b.get(o ?? p)
    );
  }
);
ce.displayName = "IconBase";
const os = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: Ql }));
os.displayName = "ArrowArcLeftIcon";
const ms = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: en }));
ms.displayName = "ArrowArcRightIcon";
const Lt = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: an }));
Lt.displayName = "CaretDownIcon";
const Et = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: tn }));
Et.displayName = "CaretRightIcon";
const is = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: sn }));
is.displayName = "CheckCircleIcon";
const bs = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: ln }));
bs.displayName = "CircleIcon";
const ds = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: nn }));
ds.displayName = "CursorIcon";
const ys = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: rn }));
ys.displayName = "DotsSixVerticalIcon";
const Nt = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: cn }));
Nt.displayName = "EyeIcon";
const Ra = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: on }));
Ra.displayName = "InfoIcon";
const gs = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: mn }));
gs.displayName = "LassoIcon";
const fs = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: bn }));
fs.displayName = "LineSegmentIcon";
const ps = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: dn }));
ps.displayName = "MagnetStraightIcon";
const hs = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: yn }));
hs.displayName = "MagnifyingGlassIcon";
const us = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: gn }));
us.displayName = "MapPinIcon";
const As = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: fn }));
As.displayName = "PolygonIcon";
const Ns = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: pn }));
Ns.displayName = "RectangleIcon";
const Ss = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: hn }));
Ss.displayName = "SelectionAllIcon";
const xt = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: un }));
xt.displayName = "TrashIcon";
const Us = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: An }));
Us.displayName = "WarningIcon";
const kt = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: Nn }));
kt.displayName = "WarningCircleIcon";
const ws = a.forwardRef((t, e) => /* @__PURE__ */ a.createElement(ce, { ref: e, ...t, weights: Sn }));
ws.displayName = "XIcon";
function Un(t, e) {
  t.visible = e;
}
function _s({
  layer: t,
  depth: e = 0,
  search: l = "",
  defaultExpanded: r = !1,
  dragIndex: n,
  dragFrom: o,
  dragOver: y,
  layerCount: d,
  onDragStart: b,
  onDragEnter: i,
  onDrop: g,
  onDragEnd: h,
  onReorder: p
}) {
  const [N, E] = H(r), [u, S] = H(t.visible), w = X(null), U = t.type === "group", [M, q] = H(
    () => U ? [...t.layers] : []
  ), te = [...M].reverse(), oe = l.trim() ? te.filter((C) => Ha(C, l)) : te, [se, ee] = H(null), [O, Q] = H(null), _ = l.trim() && te.some(
    (C) => Ha(C, l)
  );
  F(() => {
    _ && E(!0);
  }, [_]), F(() => {
    const C = je.watch(
      () => t.visible,
      (de) => S(de)
    );
    return () => C.remove();
  }, [t]), F(() => {
    if (!U)
      return;
    const C = t, de = C.layers.on(
      "change",
      () => q([...C.layers])
    );
    return () => de.remove();
  }, [U, t]);
  const T = le(
    (C) => {
      Un(t, C.target.checked);
    },
    [t]
  ), j = le(
    (C, de) => {
      if (!U || C === de)
        return;
      const He = t, Re = [...He.layers].reverse(), _e = Re[C], ve = Re[de];
      He.layers.reorder(_e, He.layers.indexOf(ve));
    },
    [U, t]
  ), $ = le(
    (C) => {
      se !== null && C !== se && j(se, C), ee(null), Q(null);
    },
    [se, j]
  ), ne = le(() => {
    ee(null), Q(null);
  }, []), G = n !== void 0 && b !== void 0, B = G && o === n, me = G && y === n && o !== null && o !== n, ye = me && (o ?? 0) > n, we = me && (o ?? 0) < n, Me = [
    Se.row,
    B ? Se.dragging : "",
    ye ? Se.dropAbove : "",
    we ? Se.dropBelow : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      role: "treeitem",
      "aria-expanded": U ? N : void 0,
      className: Se.item,
      children: [
        /* @__PURE__ */ c.jsxs(
          "div",
          {
            ref: w,
            className: Me,
            style: { "--depth": e },
            onDragOver: G ? (C) => {
              C.preventDefault(), C.dataTransfer.dropEffect = "move", i?.(n);
            } : void 0,
            onDrop: G ? (C) => {
              C.preventDefault(), g?.(n);
            } : void 0,
            onDragEnd: G ? () => h?.() : void 0,
            children: [
              G && /* @__PURE__ */ c.jsx(
                "button",
                {
                  type: "button",
                  className: Se.dragHandle,
                  draggable: !0,
                  "aria-label": `Flytt ${t.title || t.id}. Bruk piltast opp eller ned for å endre rekkefølge.`,
                  onDragStart: (C) => {
                    C.dataTransfer.effectAllowed = "move", w.current && C.dataTransfer.setDragImage(w.current, 10, 10), b?.(n);
                  },
                  onKeyDown: (C) => {
                    !p || d === void 0 || (C.key === "ArrowUp" && n > 0 ? (C.preventDefault(), p(n, n - 1)) : C.key === "ArrowDown" && n < d - 1 && (C.preventDefault(), p(n, n + 1)));
                  },
                  children: /* @__PURE__ */ c.jsx(ys, { size: 16, weight: "bold" })
                }
              ),
              U ? /* @__PURE__ */ c.jsx(
                "button",
                {
                  type: "button",
                  className: Se.expandBtn,
                  onClick: () => E((C) => !C),
                  "aria-label": N ? "Lukk" : "Utvid",
                  children: N ? /* @__PURE__ */ c.jsx(Lt, { size: 16, weight: "light" }) : /* @__PURE__ */ c.jsx(Et, { size: 16, weight: "light" })
                }
              ) : /* @__PURE__ */ c.jsx("span", { className: Se.spacer, "aria-hidden": !0 }),
              /* @__PURE__ */ c.jsx(
                ll,
                {
                  label: t.title || t.id,
                  checked: u,
                  onChange: T
                }
              )
            ]
          }
        ),
        U && N && /* @__PURE__ */ c.jsx("div", { role: "group", className: Se.children, children: oe.map((C, de) => /* @__PURE__ */ c.jsx(
          _s,
          {
            layer: C,
            depth: e + 1,
            search: l,
            dragIndex: l.trim() ? void 0 : de,
            dragFrom: l.trim() ? null : se,
            dragOver: l.trim() ? null : O,
            layerCount: oe.length,
            onDragStart: l.trim() ? void 0 : ee,
            onDragEnter: l.trim() ? void 0 : Q,
            onDrop: l.trim() ? void 0 : $,
            onDragEnd: l.trim() ? void 0 : ne,
            onReorder: l.trim() ? void 0 : j
          },
          C.id
        )) })
      ]
    }
  );
}
function Ha(t, e) {
  const l = e.toLowerCase();
  return (t.title || t.id).toLowerCase().includes(l) ? !0 : t.type === "group" ? t.layers.some(
    (r) => Ha(r, l)
  ) : !1;
}
function ki({ visibleLayerTitle: t } = {}) {
  const { mapView: e } = Fe(), [l, r] = H([]), [n, o] = H(""), [y, d] = H(null), [b, i] = H(null), g = X(null), h = le(
    (w) => [...w].reverse().filter((U) => U.listMode !== "hide").filter((U) => !t || U.title === t),
    [t]
  );
  F(() => {
    g.current = e?.map ?? null;
  }, [e]), F(() => {
    if (!e?.map)
      return;
    const w = e.map, U = () => r(h(w.layers));
    U();
    const M = w.layers.on("change", U);
    return () => M.remove();
  }, [e, h]);
  const p = le((w, U) => {
    const M = g.current;
    if (!M || w === U)
      return;
    const q = h(M.layers), te = q[w], oe = q[U];
    M.layers.reorder(te, M.layers.indexOf(oe));
  }, [h]), N = le(
    (w) => {
      y !== null && w !== y && p(y, w), d(null), i(null);
    },
    [y, p]
  ), E = le(() => {
    d(null), i(null);
  }, []), u = n.trim() === "", S = n.trim() ? l.filter((w) => Ha(w, n)) : l;
  return /* @__PURE__ */ c.jsxs("div", { id: "layer-list-custom", className: Se.container, children: [
    !t && /* @__PURE__ */ c.jsx("div", { className: Se.search, children: /* @__PURE__ */ c.jsx(
      "input",
      {
        type: "search",
        className: Se.searchInput,
        placeholder: "Søk etter kartlag",
        value: n,
        onChange: (w) => o(w.target.value),
        "aria-label": "Søk etter kartlag"
      }
    ) }),
    /* @__PURE__ */ c.jsx(nl, { children: S.map((w, U) => /* @__PURE__ */ c.jsx(
      _s,
      {
        layer: w,
        search: n,
        defaultExpanded: !!t && w.title === t,
        dragIndex: u ? U : void 0,
        dragFrom: u ? y : null,
        dragOver: u ? b : null,
        layerCount: S.length,
        onDragStart: u ? d : void 0,
        onDragEnter: u ? i : void 0,
        onDrop: u ? N : void 0,
        onDragEnd: u ? E : void 0,
        onReorder: u ? p : void 0
      },
      w.id
    )) })
  ] });
}
const wn = "https://labs.geodataonline.no/bakgrunnskart/";
function Mi() {
  const t = X(null), e = X(), { mapView: l, sceneView: r, mapMode: n } = Fe(), { t: o, i18n: y } = qe("map"), d = () => {
    const b = tl.basemaps.map((i) => {
      const g = i.clone();
      if (g.title = o(i.title), i.thumbnailUrl && !i.thumbnailUrl.startsWith("http") && !i.thumbnailUrl.startsWith("data:")) {
        const h = new URL(i.thumbnailUrl, wn);
        g.thumbnailUrl = h.href;
      }
      return g;
    });
    return new fl({
      basemaps: b
    });
  };
  return F(() => {
    t.current && l && !e.current && (e.current = new gl({
      view: l,
      source: d(),
      container: t.current
    }));
  }, [l]), F(() => {
    const b = () => {
      e.current && (e.current.source = d());
    };
    return y.on("languageChanged", b), () => {
      y.off("languageChanged", b);
    };
  }, [y]), F(() => {
    e.current && (n == ya.TwoD && l ? e.current.view = l : n == ya.ThreeD && r && (e.current.view = r));
  }, [n, l, r]), /* @__PURE__ */ c.jsx("div", { id: "esri-basemap-gallery", className: "widget-container", ref: t });
}
function Ci() {
  const t = X(null), e = X(), { mapView: l } = Fe();
  return F(() => (t?.current && l && (e.current = new pl({
    view: l,
    container: t.current,
    // specify your own print service
    printServiceUrl: "https://services.geodataonline.no/arcgis/rest/services/Georapport/Kartutskrift/GPServer/Standard"
  })), () => {
  }), []), /* @__PURE__ */ c.jsx("div", { id: "print-details", className: "widget-container", ref: t });
}
const Hi = ({ children: t }) => {
  const [e, l] = H([]), r = (o, y, d) => {
    const b = d || `flow-item-${Date.now()}`;
    l((i) => [...i, { content: o, heading: y, id: b }]);
  }, n = (o) => new Promise((y) => {
    l((d) => d.slice(0, o)), setTimeout(() => y(), 50);
  });
  return /* @__PURE__ */ c.jsxs(Fs, { children: [
    /* @__PURE__ */ c.jsx(Ct, { heading: "", children: t(r) }),
    e.map((o, y) => /* @__PURE__ */ c.jsx(
      Ct,
      {
        heading: o.heading,
        beforeBack: () => n(y),
        children: o.content
      },
      o.id
    ))
  ] });
}, _n = "DrawingBlock-module__block___R5QZD", vn = "DrawingBlock-module__open___pPJL9", Ln = "DrawingBlock-module__header___2OncX", En = "DrawingBlock-module__headerActions___DF-R0", xn = "DrawingBlock-module__trigger___ykZgk", kn = "DrawingBlock-module__heading___hTUwI", Mn = "DrawingBlock-module__indicator___PMMPf", Cn = "DrawingBlock-module__contentWrapper___AVgV7", Hn = "DrawingBlock-module__content___DSuRC", Ze = {
  block: _n,
  open: vn,
  header: Ln,
  headerActions: En,
  trigger: xn,
  heading: kn,
  indicator: Mn,
  contentWrapper: Cn,
  content: Hn
};
function Tn({ heading: t, open: e, onOpenChange: l, headerActions: r, children: n }) {
  const o = Is(), y = `${o}-content`, d = `${o}-heading`;
  return /* @__PURE__ */ c.jsxs("section", { className: `${Ze.block} ${e ? Ze.open : ""}`, children: [
    /* @__PURE__ */ c.jsxs("div", { className: Ze.header, children: [
      /* @__PURE__ */ c.jsxs(
        "button",
        {
          type: "button",
          "aria-expanded": e,
          "aria-controls": y,
          onClick: () => l(!e),
          className: Ze.trigger,
          children: [
            /* @__PURE__ */ c.jsx(Lt, { size: 16, weight: "bold", className: Ze.indicator, "aria-hidden": "true" }),
            /* @__PURE__ */ c.jsx("span", { id: d, className: Ze.heading, children: t })
          ]
        }
      ),
      r && /* @__PURE__ */ c.jsx("div", { className: Ze.headerActions, children: r })
    ] }),
    /* @__PURE__ */ c.jsx("section", { id: y, "aria-labelledby": d, className: Ze.contentWrapper, children: /* @__PURE__ */ c.jsx("div", { className: Ze.content, children: n }) })
  ] });
}
const Zn = "DrawingCustomToolbar-module__root___LPkOc", jn = "DrawingCustomToolbar-module__group___SrZ-n", Rn = "DrawingCustomToolbar-module__label___6lIrf", Vn = "DrawingCustomToolbar-module__toolRow___1D-C6", Pn = "DrawingCustomToolbar-module__toolbarItem___7-ufb", In = "DrawingCustomToolbar-module__divider___MZewe", Ce = {
  root: Zn,
  group: jn,
  label: Rn,
  toolRow: Vn,
  toolbarItem: Pn,
  divider: In
}, It = { weight: "duotone", size: 24 }, On = [
  { key: "point", icon: /* @__PURE__ */ c.jsx(us, {}), label: "Punkt", tooltip: "Tegn punkt" },
  { key: "polyline", icon: /* @__PURE__ */ c.jsx(fs, {}), label: "Linje", tooltip: "Tegn linje" },
  { key: "polygon", icon: /* @__PURE__ */ c.jsx(As, {}), label: "Polygon", tooltip: "Tegn polygon" },
  { key: "rectangle", icon: /* @__PURE__ */ c.jsx(Ns, {}), label: "Rektangel", tooltip: "Tegn rektangel" },
  { key: "circle", icon: /* @__PURE__ */ c.jsx(bs, {}), label: "Sirkel", tooltip: "Tegn sirkel" }
], Fn = [
  { key: "click", icon: /* @__PURE__ */ c.jsx(ds, {}), label: "Velg", tooltip: "Velg objekt" },
  { key: "rectangle", icon: /* @__PURE__ */ c.jsx(Ss, {}), label: "Velg med rektangel", tooltip: "Velg med rektangel" },
  { key: "lasso", icon: /* @__PURE__ */ c.jsx(gs, {}), label: "Velg med lasso", tooltip: "Velg med lasso" }
], $n = ({
  activeTool: t,
  selectMode: e,
  snappingEnabled: l,
  hasDrawings: r,
  selectionCount: n,
  onCreate: o,
  onSelect: y,
  onDelete: d,
  onToggleSnapping: b
}) => /* @__PURE__ */ c.jsxs("div", { className: Ce.root, children: [
  /* @__PURE__ */ c.jsx("div", { className: Ce.group, children: /* @__PURE__ */ c.jsx(At.Provider, { value: It, children: /* @__PURE__ */ c.jsxs("div", { className: Ce.toolRow, role: "toolbar", "aria-label": "Tegneverktøy", children: [
    On.map(({ key: i, icon: g, label: h, tooltip: p }) => /* @__PURE__ */ c.jsx(Aa, { content: p, position: "bottom", children: /* @__PURE__ */ c.jsx(ga, { icon: g, label: h, active: t === i, onClick: () => o(i), className: Ce.toolbarItem }) }, i)),
    /* @__PURE__ */ c.jsx("span", { className: Ce.divider, "aria-hidden": "true" }),
    /* @__PURE__ */ c.jsx(Aa, { content: l ? "Slå av snap" : "Slå på snap", position: "bottom", children: /* @__PURE__ */ c.jsx(ga, { icon: /* @__PURE__ */ c.jsx(ps, {}), label: "Snap", active: l, onClick: b, className: Ce.toolbarItem }) })
  ] }) }) }),
  r && /* @__PURE__ */ c.jsx("div", { className: Ce.group, children: /* @__PURE__ */ c.jsx(At.Provider, { value: It, children: /* @__PURE__ */ c.jsxs("div", { className: Ce.toolRow, role: "toolbar", "aria-label": "Valgverktøy", children: [
    Fn.map(({ key: i, icon: g, label: h, tooltip: p }) => /* @__PURE__ */ c.jsx(Aa, { content: p, position: "bottom", children: /* @__PURE__ */ c.jsx(ga, { icon: g, label: h, active: e === i, onClick: () => y(i), className: Ce.toolbarItem }) }, i)),
    n > 0 && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("span", { className: Ce.divider, "aria-hidden": "true" }),
      /* @__PURE__ */ c.jsx(Aa, { content: "Slett valgt objekt", position: "bottom", children: /* @__PURE__ */ c.jsxs(_t, { rightIcon: /* @__PURE__ */ c.jsx(xt, { size: 16 }), onClick: d, variant: "secondary", size: "sm", children: [
        n,
        " valgt"
      ] }) })
    ] })
  ] }) }) })
] }), vs = [
  { value: "solid", label: "Heltrukket" },
  { value: "dash", label: "Stiplet" },
  { value: "dot", label: "Prikker" },
  { value: "dash-dot", label: "Strek-prikk" },
  { value: "dash-dot-dot", label: "Strek-prikk-prikk" }
];
function pa(t) {
  if (!t)
    return "#0000ff";
  const [e, l, r] = Array.isArray(t) ? [t[0], t[1], t[2]] : [t.r ?? 0, t.g ?? 0, t.b ?? 0];
  return `#${e.toString(16).padStart(2, "0")}${l.toString(16).padStart(2, "0")}${r.toString(16).padStart(2, "0")}`;
}
function ha(t) {
  if (!t)
    return 0;
  let e = Array.isArray(t) ? t[3] : t.a ?? 1;
  return e > 1 && (e = e / 255), Math.round((1 - e) * 100);
}
function ua(t, e) {
  const l = parseInt(t.slice(1, 3), 16), r = parseInt(t.slice(3, 5), 16), n = parseInt(t.slice(5, 7), 16), o = (100 - e) / 100;
  return [l, r, n, o];
}
const Dn = "SymbolSettings-module__settings___DHOLk", Bn = "SymbolSettings-module__sliderRow___PWdGI", zn = "SymbolSettings-module__slider___Nmjob", Gn = "SymbolSettings-module__numberInput___5WpgX", Wn = "SymbolSettings-module__colorRow___Ta3Eg", Kn = "SymbolSettings-module__opacityBox___PuUvi", qn = "SymbolSettings-module__opacityBoxInput___bVIsv", Yn = "SymbolSettings-module__opacityUnit___hezvo", fe = {
  settings: Dn,
  sliderRow: Bn,
  slider: zn,
  numberInput: Gn,
  colorRow: Wn,
  opacityBox: Kn,
  opacityBoxInput: qn,
  opacityUnit: Yn
}, Ta = ({ label: t, value: e, min: l, max: r, step: n, unit: o, onChange: y }) => /* @__PURE__ */ c.jsxs("div", { className: fe.sliderRow, children: [
  /* @__PURE__ */ c.jsx(
    vt,
    {
      label: t,
      min: l,
      max: r,
      step: n,
      value: e,
      showValue: !1,
      onChange: (d) => y(Number(d.target.value)),
      className: fe.slider
    }
  ),
  /* @__PURE__ */ c.jsx(
    rl,
    {
      label: "",
      min: l,
      max: r,
      step: n,
      value: e,
      unit: o,
      onChange: (d) => y(Number(d.target.value)),
      className: fe.numberInput
    }
  )
] }), Jn = ({ sketchVM: t, initialSymbol: e, onSymbolChange: l }) => {
  const r = t, [n, o] = H(() => {
    const d = e ?? r.polylineSymbol;
    return {
      color: pa(d?.color),
      transparency: ha(d?.color),
      width: d?.width ?? 2,
      style: d?.style ?? "solid"
    };
  });
  function y(d) {
    const b = { ...n, ...d };
    o(b);
    const i = {
      type: "simple-line",
      color: ua(b.color, b.transparency),
      width: b.width,
      style: b.style
    };
    l ? l(i) : r.polylineSymbol = i;
  }
  return /* @__PURE__ */ c.jsxs("div", { className: fe.settings, children: [
    /* @__PURE__ */ c.jsx(
      ja,
      {
        label: "Stil",
        value: n.style,
        options: vs,
        onChange: (d) => y({ style: d.target.value })
      }
    ),
    /* @__PURE__ */ c.jsx(
      Ca,
      {
        label: "Farge",
        value: n.color,
        onChange: (d) => y({ color: d })
      }
    ),
    /* @__PURE__ */ c.jsx(
      Ta,
      {
        label: "Gjennomsiktighet",
        value: n.transparency,
        min: 0,
        max: 100,
        step: 1,
        unit: "%",
        onChange: (d) => y({ transparency: d })
      }
    ),
    /* @__PURE__ */ c.jsx(
      Ta,
      {
        label: "Bredde",
        value: n.width,
        min: 0.5,
        max: 20,
        step: 0.5,
        unit: "px",
        onChange: (d) => y({ width: d })
      }
    )
  ] });
}, Xn = ({ sketchVM: t, initialSymbol: e, onSymbolChange: l }) => {
  const r = t, [n, o] = H(() => {
    const d = e ?? r.polygonSymbol;
    return {
      fillColor: pa(d?.color),
      fillTransparency: ha(d?.color),
      outlineColor: pa(d?.outline?.color),
      outlineTransparency: ha(d?.outline?.color),
      outlineWidth: d?.outline?.width ?? 1,
      outlineStyle: d?.outline?.style ?? "solid"
    };
  });
  function y(d) {
    const b = { ...n, ...d };
    o(b);
    const i = {
      type: "simple-fill",
      color: ua(b.fillColor, b.fillTransparency),
      outline: {
        color: ua(b.outlineColor, b.outlineTransparency),
        width: b.outlineWidth,
        style: b.outlineStyle
      }
    };
    l ? l(i) : r.polygonSymbol = i;
  }
  return /* @__PURE__ */ c.jsxs("div", { className: fe.settings, children: [
    /* @__PURE__ */ c.jsxs("div", { className: fe.colorRow, children: [
      /* @__PURE__ */ c.jsx(
        Ca,
        {
          label: "Fyllfarge",
          value: n.fillColor,
          onChange: (d) => y({ fillColor: d }),
          stretch: !0
        }
      ),
      /* @__PURE__ */ c.jsxs("div", { className: fe.opacityBox, children: [
        /* @__PURE__ */ c.jsx(Nt, { size: 12 }),
        /* @__PURE__ */ c.jsx(
          "input",
          {
            type: "number",
            className: fe.opacityBoxInput,
            min: 0,
            max: 100,
            step: 1,
            value: n.fillTransparency,
            "aria-label": "Fyllgjennomsiktighet",
            onChange: (d) => y({ fillTransparency: Number(d.target.value) })
          }
        ),
        /* @__PURE__ */ c.jsx("span", { className: fe.opacityUnit, "aria-hidden": "true", children: "%" })
      ] })
    ] }),
    /* @__PURE__ */ c.jsxs("div", { className: fe.colorRow, children: [
      /* @__PURE__ */ c.jsx(
        Ca,
        {
          label: "Omrissfarge",
          value: n.outlineColor,
          onChange: (d) => y({ outlineColor: d }),
          stretch: !0
        }
      ),
      /* @__PURE__ */ c.jsxs("div", { className: fe.opacityBox, children: [
        /* @__PURE__ */ c.jsx(Nt, { size: 12 }),
        /* @__PURE__ */ c.jsx(
          "input",
          {
            type: "number",
            className: fe.opacityBoxInput,
            min: 0,
            max: 100,
            step: 1,
            value: n.outlineTransparency,
            "aria-label": "Omrissgjennomsiktighet",
            onChange: (d) => y({ outlineTransparency: Number(d.target.value) })
          }
        ),
        /* @__PURE__ */ c.jsx("span", { className: fe.opacityUnit, "aria-hidden": "true", children: "%" })
      ] })
    ] }),
    /* @__PURE__ */ c.jsx(
      ja,
      {
        label: "Omrissstil",
        value: n.outlineStyle,
        options: vs,
        onChange: (d) => y({ outlineStyle: d.target.value })
      }
    ),
    /* @__PURE__ */ c.jsx(
      vt,
      {
        label: "Omrissbredde",
        value: n.outlineWidth,
        min: 0.5,
        max: 20,
        step: 0.5,
        formatValue: (d) => `${d} px`,
        onChange: (d) => y({ outlineWidth: Number(d.target.value) })
      }
    )
  ] });
}, Ls = [
  {
    name: "shapes-circle-3",
    symbolName: "Circle 3_Shapes_3",
    label: "Circle 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-circle-2",
    symbolName: "Double Circle",
    label: "Circle 2",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-triangle-3",
    symbolName: "Triangle 3_Shapes_3",
    label: "Triangle 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-square-3",
    symbolName: "Square 3_Shapes_3",
    label: "Square 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-rectangle",
    symbolName: "Rectangle",
    label: "Rectangle",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-diamond-3",
    symbolName: "Diamond 3_Shapes_3",
    label: "Diamond 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-hexagon-3",
    symbolName: "Hexagon 3_Shapes_3",
    label: "Hexagon 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-pentagon-3",
    symbolName: "Pentagon 3_Shapes_3",
    label: "Pentagon 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-octagon",
    symbolName: "Triangle 3",
    label: "Octagon",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-octagon-2",
    symbolName: "Octagon 2",
    label: "Octagon 2",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-star-3",
    symbolName: "Star 3_Shapes_3",
    label: "Star 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-cross-3",
    symbolName: "Cross 3_Shapes_3",
    label: "Cross 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-asterisk-1",
    symbolName: "asterisk ",
    label: "asterisk 1",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-asterisk-2",
    symbolName: "asterisk 2",
    label: "asterisk 2",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-plus",
    symbolName: "Plus",
    label: "Plus",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-x",
    symbolName: "X",
    label: "X",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "pins-pin-drop-x",
    symbolName: "Point symbol",
    label: "Pin drop x",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-push-pin-1",
    symbolName: "Point symbol_1",
    label: "Push pin 1",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-circle-pin-drop",
    symbolName: "Point symbol_2",
    label: "Circle pin drop",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-wide-pin-drop",
    symbolName: "Point symbol_3",
    label: "Wide pin drop",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-map-location",
    symbolName: "Point symbol_5",
    label: "Map location",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-simple-pin",
    symbolName: "Point symbol_6",
    label: "Simple pin",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-push-pin-2",
    symbolName: "Point symbol_7",
    label: "Push pin 2",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-location-pin",
    symbolName: "Point symbol_8",
    label: "Location pin",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-location",
    symbolName: "Point symbol_9",
    label: "Location",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "vehicles-transport-ship",
    symbolName: "Point symbol",
    label: "Transport ship",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-plane",
    symbolName: "Point symbol_1",
    label: "Plane",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-subway",
    symbolName: "Point symbol_2",
    label: "Subway",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-motorcycle",
    symbolName: "Point symbol_3",
    label: "Motorcycle",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-bus",
    symbolName: "Point symbol_4",
    label: "Bus",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-roller-coaster",
    symbolName: "Point symbol_5",
    label: "Roller coaster",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-ferris-wheel",
    symbolName: "Point symbol_6",
    label: "Ferris wheel",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cruise-ship",
    symbolName: "Point symbol_7",
    label: "Cruise ship",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-traffic-light-horizontal",
    symbolName: "Point symbol_8",
    label: "Traffic light horizontal",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-traffic-light-vertical",
    symbolName: "Point symbol_9",
    label: "Traffic light vertical",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-warning-sign",
    symbolName: "Point symbol_10",
    label: "Warning sign",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-fuel-pump",
    symbolName: "Point symbol_11",
    label: "Fuel pump",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-barrier-sign",
    symbolName: "Point symbol_12",
    label: "Barrier sign",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-anchor",
    symbolName: "Point symbol_13",
    label: "Anchor",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-seating",
    symbolName: "Point symbol_14",
    label: "Seating",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-rocket-ship",
    symbolName: "Point symbol_15",
    label: "Rocket ship",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-speed-boat",
    symbolName: "Point symbol_16",
    label: "Speed boat",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-sail-boat",
    symbolName: "Point symbol_17",
    label: "Sail boat",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-plane-2",
    symbolName: "Point symbol_18",
    label: "Plane 2",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-helicopter",
    symbolName: "Point symbol_19",
    label: "Helicopter",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-train-stop",
    symbolName: "Point symbol_20",
    label: "Train stop",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cable-car",
    symbolName: "Point symbol_21",
    label: "Cable car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-commuter-train",
    symbolName: "Point symbol_22",
    label: "Commuter train",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-steam-locomotive",
    symbolName: "Point symbol_24",
    label: "Steam locomotive",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-train-and-mountains",
    symbolName: "Point symbol_25",
    label: "Train and mountains",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-high-speed-train-1",
    symbolName: "Point symbol_26",
    label: "High-speed train 1",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-high-speed-train-2",
    symbolName: "Point symbol_27",
    label: "High-speed train 2",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-high-speed-train-3",
    symbolName: "Point symbol_28",
    label: "High-speed train 3",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-train-on-track",
    symbolName: "Point symbol_29",
    label: "Train on track",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cable-car-side-profile",
    symbolName: "Point symbol_30",
    label: "Cable car side profile",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-bilevel-rail-car",
    symbolName: "Point symbol_31",
    label: "Bilevel rail car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-aerial-tramway-1",
    symbolName: "Point symbol_32",
    label: "Aerial tramway 1",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-aerial-tramway-2",
    symbolName: "Point symbol_33",
    label: "Aerial tramway 2",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-aerial-tramway-small",
    symbolName: "Point symbol_34",
    label: "Aerial tramway small",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-taxi",
    symbolName: "Point symbol_35",
    label: "Taxi",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-blue-car",
    symbolName: "Point symbol_36",
    label: "Blue car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-red-bus",
    symbolName: "Point symbol_37",
    label: "Red bus",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-police-car",
    symbolName: "Point symbol_38",
    label: "Police car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-emergency-light",
    symbolName: "Point symbol_39",
    label: "Emergency light",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-bicycle",
    symbolName: "Point symbol_40",
    label: "Bicycle",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-classic-motorcycle",
    symbolName: "Point symbol_41",
    label: "Classic motorcycle",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-tractor",
    symbolName: "Point symbol_42",
    label: "Tractor",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-truck-small",
    symbolName: "Point symbol_43",
    label: "Truck small",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-transport-truck",
    symbolName: "Point symbol_44",
    label: "Transport truck",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-van",
    symbolName: "Point symbol_45",
    label: "Van",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-fire-truck",
    symbolName: "Point symbol_46",
    label: "Fire truck",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-ambulance",
    symbolName: "Point symbol_47",
    label: "Ambulance",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-police-car-side-profile",
    symbolName: "Point symbol_48",
    label: "Police car side profile",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-race-car",
    symbolName: "Point symbol_49",
    label: "Race car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cable-car-side",
    symbolName: "Point symbol_50",
    label: "Cable car side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-commuter-bus-side",
    symbolName: "Point symbol_51",
    label: "Commuter bus side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-blue-car-side",
    symbolName: "Point symbol_52",
    label: "Blue car side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-taxi-side",
    symbolName: "Point symbol_53",
    label: "Taxi side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-red-car-side",
    symbolName: "Point symbol_54",
    label: "Red car side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "animals-hedgehog",
    symbolName: "Hedgehog",
    label: "Hedgehog",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-wolf",
    symbolName: "Wolf",
    label: "Wolf",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-porcupine",
    symbolName: "Porcupine",
    label: "Porcupine",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-bear",
    symbolName: "Bear",
    label: "Bear",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-gorilla",
    symbolName: "Gorilla",
    label: "Gorilla",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-mouse",
    symbolName: "Mouse",
    label: "Mouse",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-warthog",
    symbolName: "Warthog",
    label: "Warthog",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-ox",
    symbolName: "Ox",
    label: "Ox",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-hippo",
    symbolName: "Hippo",
    label: "Hippo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-fox",
    symbolName: "Fox",
    label: "Fox",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-lion",
    symbolName: "Lion",
    label: "Lion",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-squirrel",
    symbolName: "Squirrel",
    label: "Squirrel",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-beaver",
    symbolName: "Beaver",
    label: "Beaver",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-coyote",
    symbolName: "Coyote",
    label: "Coyote",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-monkey",
    symbolName: "Monkey",
    label: "Monkey",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-rhino",
    symbolName: "Rhino",
    label: "Rhino",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-camel",
    symbolName: "Camel",
    label: "Camel",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-monkey-2",
    symbolName: "Monkey 2",
    label: "Monkey 2",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-armadillo",
    symbolName: "Armadillo",
    label: "Armadillo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-kiwi",
    symbolName: "Kiwi",
    label: "Kiwi",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-calf",
    symbolName: "Calf",
    label: "Calf",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-rabbit",
    symbolName: "Rabbit",
    label: "Rabbit",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-pig",
    symbolName: "Pig",
    label: "Pig",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-otter",
    symbolName: "Otter",
    label: "Otter",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-warthog-2",
    symbolName: "Warthog 2",
    label: "Warthog 2",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-ostrich",
    symbolName: "Ostrich",
    label: "Ostrich",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-lamb",
    symbolName: "Lamb",
    label: "Lamb",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-donkey",
    symbolName: "Donkey",
    label: "Donkey",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-cow",
    symbolName: "Cow",
    label: "Cow",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-dog",
    symbolName: "Dog",
    label: "Dog",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-elephant",
    symbolName: "Elephant",
    label: "Elephant",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-fish",
    symbolName: "Fish",
    label: "Fish",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-mouse-2",
    symbolName: "Mouse 2",
    label: "Mouse 2",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-chicken",
    symbolName: "Chicken",
    label: "Chicken",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-duck",
    symbolName: "Duck",
    label: "Duck",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-parrot",
    symbolName: "Parrot",
    label: "Parrot",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-cat",
    symbolName: "Cat",
    label: "Cat",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-buffalo",
    symbolName: "Buffalo",
    label: "Buffalo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-mongoose",
    symbolName: "Mongoose",
    label: "Mongoose",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-bird",
    symbolName: "Bird",
    label: "Bird",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-turtle",
    symbolName: "Turtle",
    label: "Turtle",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-horse",
    symbolName: "Horse",
    label: "Horse",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-muskrat",
    symbolName: "Muskrat",
    label: "Muskrat",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-leopard",
    symbolName: "Leopard ",
    label: "Leopard ",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-lion-king",
    symbolName: "Lion King",
    label: "Lion King",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-caribou",
    symbolName: "Caribou",
    label: "Caribou",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-kangaroo",
    symbolName: "Kangaroo",
    label: "Kangaroo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-elk",
    symbolName: "Elk",
    label: "Elk",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "landforms-symbol-1",
    symbolName: "Asset 111pencilcolored",
    label: "Symbol 1",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-2",
    symbolName: "Asset 112pencilcolored",
    label: "Symbol 2",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-3",
    symbolName: "Asset 113pencilcolored",
    label: "Symbol 3",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-4",
    symbolName: "Asset 114pencilcolored",
    label: "Symbol 4",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-5",
    symbolName: "Asset 118pencilcolored",
    label: "Symbol 5",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-6",
    symbolName: "Asset 119pencilcolored",
    label: "Symbol 6",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-7",
    symbolName: "Asset 436pencilcolored",
    label: "Symbol 7",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-8",
    symbolName: "Asset 434pencilcolored",
    label: "Symbol 8",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-9",
    symbolName: "Asset 437pencilcolored",
    label: "Symbol 9",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-10",
    symbolName: "Asset 439pencilcolored",
    label: "Symbol 10",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-11",
    symbolName: "Asset 438pencilcolored",
    label: "Symbol 11",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-12",
    symbolName: "Asset 440pencilcolored",
    label: "Symbol 12",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-13",
    symbolName: "Asset 466pencilcolored",
    label: "Symbol 13",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-14",
    symbolName: "Asset 467pencilcolored",
    label: "Symbol 14",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-15",
    symbolName: "Asset 468pencilcolored",
    label: "Symbol 15",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-16",
    symbolName: "Asset 469pencilcolored",
    label: "Symbol 16",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-17",
    symbolName: "Asset 470pencilcolored",
    label: "Symbol 17",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-18",
    symbolName: "Asset 471pencilcolored",
    label: "Symbol 18",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-19",
    symbolName: "Asset 472pencilcolored",
    label: "Symbol 19",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-20",
    symbolName: "Asset 473pencilcolored",
    label: "Symbol 20",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-21",
    symbolName: "Asset 474pencilcolored",
    label: "Symbol 21",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-22",
    symbolName: "Asset 475pencilcolored",
    label: "Symbol 22",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-23",
    symbolName: "Asset 476pencilcolored",
    label: "Symbol 23",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-24",
    symbolName: "Asset 477pencilcolored",
    label: "Symbol 24",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-25",
    symbolName: "Asset 478pencilcolored",
    label: "Symbol 25",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-26",
    symbolName: "Asset 479pencilcolored",
    label: "Symbol 26",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-27",
    symbolName: "Asset 480pencilcolored",
    label: "Symbol 27",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-28",
    symbolName: "Asset 481pencilcolored",
    label: "Symbol 28",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-29",
    symbolName: "Asset 482pencilcolored",
    label: "Symbol 29",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-30",
    symbolName: "Asset 483pencilcolored",
    label: "Symbol 30",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-31",
    symbolName: "Asset 484pencilcolored",
    label: "Symbol 31",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-32",
    symbolName: "Asset 485pencilcolored",
    label: "Symbol 32",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-33",
    symbolName: "Asset 486pencilcolored",
    label: "Symbol 33",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-34",
    symbolName: "Asset 487pencilcolored",
    label: "Symbol 34",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-35",
    symbolName: "Asset 488pencilcolored",
    label: "Symbol 35",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-36",
    symbolName: "Asset 489pencilcolored",
    label: "Symbol 36",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-37",
    symbolName: "Asset 490pencilcolored",
    label: "Symbol 37",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-38",
    symbolName: "Asset 491pencilcolored",
    label: "Symbol 38",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-39",
    symbolName: "Asset 492pencilcolored",
    label: "Symbol 39",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-40",
    symbolName: "Asset 493pencilcolored",
    label: "Symbol 40",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-41",
    symbolName: "Asset 494pencilcolored",
    label: "Symbol 41",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-42",
    symbolName: "Asset 495pencilcolored",
    label: "Symbol 42",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-43",
    symbolName: "Asset 496pencilcolored",
    label: "Symbol 43",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-44",
    symbolName: "Asset 497pencilcolored",
    label: "Symbol 44",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-45",
    symbolName: "Asset 498pencilcolored",
    label: "Symbol 45",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-46",
    symbolName: "Asset 499pencilcolored",
    label: "Symbol 46",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-47",
    symbolName: "Asset 500pencilcolored",
    label: "Symbol 47",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-48",
    symbolName: "Asset 501pencilcolored",
    label: "Symbol 48",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-49",
    symbolName: "Asset 502pencilcolored",
    label: "Symbol 49",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-50",
    symbolName: "Asset 503pencilcolored",
    label: "Symbol 50",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-51",
    symbolName: "Asset 504pencilcolored",
    label: "Symbol 51",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-52",
    symbolName: "Asset 505pencilcolored",
    label: "Symbol 52",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-53",
    symbolName: "Asset 506pencilcolored",
    label: "Symbol 53",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-54",
    symbolName: "Asset 507pencilcolored",
    label: "Symbol 54",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-55",
    symbolName: "Asset 508pencilcolored",
    label: "Symbol 55",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-56",
    symbolName: "Asset 509pencilcolored",
    label: "Symbol 56",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-57",
    symbolName: "Asset 510pencilcolored",
    label: "Symbol 57",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-58",
    symbolName: "Asset 511pencilcolored",
    label: "Symbol 58",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-59",
    symbolName: "Asset 512pencilcolored",
    label: "Symbol 59",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-60",
    symbolName: "Asset 513pencilcolored",
    label: "Symbol 60",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-61",
    symbolName: "Asset 514pencilcolored",
    label: "Symbol 61",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-62",
    symbolName: "Asset 515pencilcolored",
    label: "Symbol 62",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-63",
    symbolName: "Asset 516pencilcolored",
    label: "Symbol 63",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-64",
    symbolName: "Asset 517pencilcolored",
    label: "Symbol 64",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-65",
    symbolName: "Asset 518pencilcolored",
    label: "Symbol 65",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-66",
    symbolName: "Asset 519pencilcolored",
    label: "Symbol 66",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-67",
    symbolName: "Asset 520pencilcolored",
    label: "Symbol 67",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-68",
    symbolName: "Asset 521pencilcolored",
    label: "Symbol 68",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-69",
    symbolName: "Asset 522pencilcolored",
    label: "Symbol 69",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-70",
    symbolName: "Asset 523pencilcolored",
    label: "Symbol 70",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-71",
    symbolName: "Asset 524pencilcolored",
    label: "Symbol 71",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-72",
    symbolName: "Asset 525pencilcolored",
    label: "Symbol 72",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-73",
    symbolName: "Asset 526pencilcolored",
    label: "Symbol 73",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-74",
    symbolName: "Asset 527pencilcolored",
    label: "Symbol 74",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-75",
    symbolName: "Asset 528pencilcolored",
    label: "Symbol 75",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-76",
    symbolName: "Asset 529pencilcolored",
    label: "Symbol 76",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-77",
    symbolName: "Asset 530pencilcolored",
    label: "Symbol 77",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-78",
    symbolName: "Asset 531pencilcolored",
    label: "Symbol 78",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-79",
    symbolName: "Asset 532pencilcolored",
    label: "Symbol 79",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-80",
    symbolName: "Asset 533pencilcolored",
    label: "Symbol 80",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-81",
    symbolName: "Asset 534pencilcolored",
    label: "Symbol 81",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-82",
    symbolName: "Asset 535pencilcolored",
    label: "Symbol 82",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-83",
    symbolName: "Asset 536pencilcolored",
    label: "Symbol 83",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-84",
    symbolName: "Asset 537pencilcolored",
    label: "Symbol 84",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-85",
    symbolName: "Asset 538pencilcolored",
    label: "Symbol 85",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-86",
    symbolName: "Asset 539pencilcolored",
    label: "Symbol 86",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-87",
    symbolName: "Asset 549pencilcolored",
    label: "Symbol 87",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-88",
    symbolName: "Asset 540pencilcolored",
    label: "Symbol 88",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-89",
    symbolName: "Asset 541pencilcolored",
    label: "Symbol 89",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-90",
    symbolName: "Asset 542pencilcolored",
    label: "Symbol 90",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-91",
    symbolName: "Asset 543pencilcolored",
    label: "Symbol 91",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-92",
    symbolName: "Asset 544pencilcolored",
    label: "Symbol 92",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-93",
    symbolName: "Asset 545pencilcolored",
    label: "Symbol 93",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-94",
    symbolName: "Asset 546pencilcolored",
    label: "Symbol 94",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-95",
    symbolName: "Asset 547pencilcolored",
    label: "Symbol 95",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-96",
    symbolName: "Asset 548pencilcolored",
    label: "Symbol 96",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-97",
    symbolName: "Asset 550pencilcolored",
    label: "Symbol 97",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-98",
    symbolName: "Asset 551pencilcolored",
    label: "Symbol 98",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-99",
    symbolName: "Asset 552pencilcolored",
    label: "Symbol 99",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-100",
    symbolName: "Asset 553pencilcolored",
    label: "Symbol 100",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-101",
    symbolName: "Asset 554pencilcolored",
    label: "Symbol 101",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-102",
    symbolName: "Asset 555pencilcolored",
    label: "Symbol 102",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-103",
    symbolName: "Asset 556pencilcolored",
    label: "Symbol 103",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-104",
    symbolName: "Asset 557pencilcolored",
    label: "Symbol 104",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-105",
    symbolName: "Asset 558pencilcolored",
    label: "Symbol 105",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-106",
    symbolName: "Asset 559pencilcolored",
    label: "Symbol 106",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-107",
    symbolName: "Asset 560pencilcolored",
    label: "Symbol 107",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-108",
    symbolName: "Asset 561pencilcolored",
    label: "Symbol 108",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-109",
    symbolName: "Asset 562pencilcolored",
    label: "Symbol 109",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-110",
    symbolName: "Asset 563pencilcolored",
    label: "Symbol 110",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-111",
    symbolName: "Asset 564pencilcolored",
    label: "Symbol 111",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-112",
    symbolName: "Asset 565pencilcolored",
    label: "Symbol 112",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-113",
    symbolName: "Asset 566pencilcolored",
    label: "Symbol 113",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-114",
    symbolName: "Asset 567pencilcolored",
    label: "Symbol 114",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-115",
    symbolName: "Asset 568pencilcolored",
    label: "Symbol 115",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-116",
    symbolName: "Asset 569pencilcolored",
    label: "Symbol 116",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-117",
    symbolName: "Asset 570pencilcolored",
    label: "Symbol 117",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-118",
    symbolName: "Asset 571pencilcolored",
    label: "Symbol 118",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-119",
    symbolName: "Asset 572pencilcolored",
    label: "Symbol 119",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-120",
    symbolName: "Asset 573pencilcolored",
    label: "Symbol 120",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-121",
    symbolName: "Asset 574pencilcolored",
    label: "Symbol 121",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-122",
    symbolName: "Asset 575pencilcolored",
    label: "Symbol 122",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-123",
    symbolName: "Asset 576pencilcolored",
    label: "Symbol 123",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-124",
    symbolName: "Asset 577pencilcolored",
    label: "Symbol 124",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-125",
    symbolName: "Asset 578pencilcolored",
    label: "Symbol 125",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-126",
    symbolName: "Asset 579pencilcolored",
    label: "Symbol 126",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-127",
    symbolName: "Asset 580pencilcolored",
    label: "Symbol 127",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-128",
    symbolName: "Asset 581pencilcolored",
    label: "Symbol 128",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-129",
    symbolName: "Asset 582pencilcolored",
    label: "Symbol 129",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-130",
    symbolName: "Asset 583pencilcolored",
    label: "Symbol 130",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-131",
    symbolName: "Asset 584pencilcolored",
    label: "Symbol 131",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-132",
    symbolName: "Asset 586pencilcolored",
    label: "Symbol 132",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-133",
    symbolName: "Asset 587pencilcolored",
    label: "Symbol 133",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-134",
    symbolName: "Asset 588pencilcolored",
    label: "Symbol 134",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-135",
    symbolName: "Asset 589pencilcolored",
    label: "Symbol 135",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-136",
    symbolName: "Asset 590pencilcolored",
    label: "Symbol 136",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-137",
    symbolName: "Asset 591pencilcolored",
    label: "Symbol 137",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-138",
    symbolName: "Asset 592pencilcolored",
    label: "Symbol 138",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-139",
    symbolName: "Asset 593pencilcolored",
    label: "Symbol 139",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-140",
    symbolName: "Asset 594pencilcolored",
    label: "Symbol 140",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-141",
    symbolName: "Asset 595pencilcolored",
    label: "Symbol 141",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-142",
    symbolName: "Asset 596pencilcolored",
    label: "Symbol 142",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-143",
    symbolName: "Asset 597pencilcolored",
    label: "Symbol 143",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-144",
    symbolName: "Asset 598pencilcolored",
    label: "Symbol 144",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-145",
    symbolName: "Asset 599pencilcolored",
    label: "Symbol 145",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-146",
    symbolName: "Asset 600pencilcolored",
    label: "Symbol 146",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-147",
    symbolName: "Asset 601pencilcolored",
    label: "Symbol 147",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-148",
    symbolName: "Asset 602pencilcolored",
    label: "Symbol 148",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-149",
    symbolName: "Asset 603pencilcolored",
    label: "Symbol 149",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-150",
    symbolName: "Asset 605pencilcolored",
    label: "Symbol 150",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-151",
    symbolName: "Asset 606pencilcolored",
    label: "Symbol 151",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-152",
    symbolName: "Asset 607pencilcolored",
    label: "Symbol 152",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-153",
    symbolName: "Asset 608pencilcolored",
    label: "Symbol 153",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-154",
    symbolName: "Asset 609pencilcolored",
    label: "Symbol 154",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-155",
    symbolName: "Asset 610pencilcolored",
    label: "Symbol 155",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-156",
    symbolName: "Asset 611pencilcolored",
    label: "Symbol 156",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-157",
    symbolName: "Asset 612pencilcolored",
    label: "Symbol 157",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-158",
    symbolName: "Asset 613pencilcolored",
    label: "Symbol 158",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-159",
    symbolName: "Asset 614pencilcolored",
    label: "Symbol 159",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-160",
    symbolName: "Asset 615pencilcolored",
    label: "Symbol 160",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-161",
    symbolName: "Asset 616pencilcolored",
    label: "Symbol 161",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "trees-symbol-1",
    symbolName: "Asset 100trees",
    label: "Symbol 1",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-2",
    symbolName: "Asset 101trees",
    label: "Symbol 2",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-3",
    symbolName: "Asset 102trees",
    label: "Symbol 3",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-4",
    symbolName: "Asset 103trees",
    label: "Symbol 4",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-5",
    symbolName: "Asset 104trees",
    label: "Symbol 5",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-6",
    symbolName: "Asset 105trees",
    label: "Symbol 6",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-7",
    symbolName: "Asset 106trees",
    label: "Symbol 7",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-8",
    symbolName: "Asset 107trees",
    label: "Symbol 8",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-9",
    symbolName: "Asset 108trees",
    label: "Symbol 9",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-10",
    symbolName: "Asset 109trees",
    label: "Symbol 10",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-11",
    symbolName: "Asset 110trees",
    label: "Symbol 11",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-12",
    symbolName: "Asset 111trees",
    label: "Symbol 12",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-13",
    symbolName: "Asset 112trees",
    label: "Symbol 13",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-14",
    symbolName: "Asset 113trees",
    label: "Symbol 14",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-15",
    symbolName: "Asset 114trees",
    label: "Symbol 15",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-16",
    symbolName: "Asset 115trees",
    label: "Symbol 16",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-17",
    symbolName: "Asset 116trees",
    label: "Symbol 17",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-18",
    symbolName: "Asset 117trees",
    label: "Symbol 18",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-19",
    symbolName: "Asset 118trees",
    label: "Symbol 19",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-20",
    symbolName: "Asset 119trees",
    label: "Symbol 20",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-21",
    symbolName: "Asset 120trees",
    label: "Symbol 21",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-22",
    symbolName: "Asset 121trees",
    label: "Symbol 22",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-23",
    symbolName: "Asset 122trees",
    label: "Symbol 23",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-24",
    symbolName: "Asset 123trees",
    label: "Symbol 24",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-25",
    symbolName: "Asset 124trees",
    label: "Symbol 25",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-26",
    symbolName: "Asset 125trees",
    label: "Symbol 26",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-27",
    symbolName: "Asset 126trees",
    label: "Symbol 27",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-28",
    symbolName: "Asset 12trees",
    label: "Symbol 28",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-29",
    symbolName: "Asset 20trees",
    label: "Symbol 29",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-30",
    symbolName: "Asset 22trees",
    label: "Symbol 30",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-31",
    symbolName: "Asset 35trees",
    label: "Symbol 31",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-32",
    symbolName: "Asset 41trees",
    label: "Symbol 32",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-33",
    symbolName: "Asset 42trees",
    label: "Symbol 33",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-34",
    symbolName: "Asset 43trees",
    label: "Symbol 34",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-35",
    symbolName: "Asset 44trees",
    label: "Symbol 35",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-36",
    symbolName: "Asset 45trees",
    label: "Symbol 36",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-37",
    symbolName: "Asset 46trees",
    label: "Symbol 37",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-38",
    symbolName: "Asset 47trees",
    label: "Symbol 38",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-39",
    symbolName: "Asset 48trees",
    label: "Symbol 39",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-40",
    symbolName: "Asset 57trees",
    label: "Symbol 40",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-41",
    symbolName: "Asset 58trees",
    label: "Symbol 41",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-42",
    symbolName: "Asset 59trees",
    label: "Symbol 42",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-43",
    symbolName: "Asset 60trees",
    label: "Symbol 43",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-44",
    symbolName: "Asset 61trees",
    label: "Symbol 44",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-45",
    symbolName: "Asset 62trees",
    label: "Symbol 45",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-46",
    symbolName: "Asset 63trees",
    label: "Symbol 46",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-47",
    symbolName: "Asset 64trees",
    label: "Symbol 47",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-48",
    symbolName: "Asset 65trees",
    label: "Symbol 48",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-49",
    symbolName: "Asset 66trees",
    label: "Symbol 49",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-50",
    symbolName: "Asset 67trees",
    label: "Symbol 50",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-51",
    symbolName: "Asset 68trees",
    label: "Symbol 51",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-52",
    symbolName: "Asset 69trees",
    label: "Symbol 52",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-53",
    symbolName: "Asset 70trees",
    label: "Symbol 53",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-54",
    symbolName: "Asset 71trees",
    label: "Symbol 54",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-55",
    symbolName: "Asset 73trees",
    label: "Symbol 55",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-56",
    symbolName: "Asset 74trees",
    label: "Symbol 56",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-57",
    symbolName: "Asset 75trees",
    label: "Symbol 57",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-58",
    symbolName: "Asset 76trees",
    label: "Symbol 58",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-59",
    symbolName: "Asset 77trees",
    label: "Symbol 59",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-60",
    symbolName: "Asset 78trees",
    label: "Symbol 60",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-61",
    symbolName: "Asset 79trees",
    label: "Symbol 61",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-62",
    symbolName: "Asset 80trees",
    label: "Symbol 62",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-63",
    symbolName: "Asset 81trees",
    label: "Symbol 63",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-64",
    symbolName: "Asset 82trees",
    label: "Symbol 64",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-65",
    symbolName: "Asset 83trees",
    label: "Symbol 65",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-66",
    symbolName: "Asset 84trees",
    label: "Symbol 66",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-67",
    symbolName: "Asset 85trees",
    label: "Symbol 67",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-68",
    symbolName: "Asset 86trees",
    label: "Symbol 68",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-69",
    symbolName: "Asset 87trees",
    label: "Symbol 69",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-70",
    symbolName: "Asset 88trees",
    label: "Symbol 70",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-71",
    symbolName: "Asset 89trees",
    label: "Symbol 71",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-72",
    symbolName: "Asset 90trees",
    label: "Symbol 72",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-73",
    symbolName: "Asset 91trees",
    label: "Symbol 73",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-74",
    symbolName: "Asset 92trees",
    label: "Symbol 74",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-75",
    symbolName: "Asset 93trees",
    label: "Symbol 75",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-76",
    symbolName: "Asset 94trees",
    label: "Symbol 76",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-77",
    symbolName: "Asset 95trees",
    label: "Symbol 77",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-78",
    symbolName: "Asset 96trees",
    label: "Symbol 78",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-79",
    symbolName: "Asset 97trees",
    label: "Symbol 79",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-80",
    symbolName: "Asset 98trees",
    label: "Symbol 80",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-81",
    symbolName: "Asset 99trees",
    label: "Symbol 81",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "buildings-apartment-building",
    symbolName: "Asset 10building",
    label: "Apartment building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-modern-building",
    symbolName: "Asset 10building2",
    label: "Modern building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-house",
    symbolName: "Asset 10house",
    label: "House",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-clock-tower",
    symbolName: "Asset 11building2",
    label: "Clock tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-simple-house",
    symbolName: "Asset 2house",
    label: "Simple house",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-glass-building",
    symbolName: "Asset 12building",
    label: "Glass building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-complex",
    symbolName: "Asset 12building2",
    label: "Complex",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-simple-building",
    symbolName: "Asset 12house",
    label: "Simple building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-two-towers",
    symbolName: "Asset 13building",
    label: "Two towers",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-classic-apartment",
    symbolName: "Asset 13building2",
    label: "Classic apartment",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-modern-house-circle-window",
    symbolName: "Asset 13house",
    label: "Modern house circle window",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-tower",
    symbolName: "Asset 14building",
    label: "Tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-towers",
    symbolName: "Asset 14building2",
    label: "Towers",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-house-with-garage",
    symbolName: "Asset 14house",
    label: "House with garage",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-building-with-flag",
    symbolName: "Asset 15building",
    label: "Building with flag",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-narrow-tower",
    symbolName: "Asset 15building2",
    label: "Narrow tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-large-home",
    symbolName: "Asset 15house",
    label: "Large home",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-city-buildings",
    symbolName: "Asset 16building",
    label: "City buildings",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-mid-rise",
    symbolName: "Asset 16building2",
    label: "Mid-rise ",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-mart",
    symbolName: "Asset 16house",
    label: "Mart",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-hospital",
    symbolName: "Asset 17building",
    label: "Hospital",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-multiple-buildings",
    symbolName: "Asset 17building2",
    label: "Multiple buildings",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-mansion",
    symbolName: "Asset 17house",
    label: "Mansion",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-school-tower",
    symbolName: "Asset 18building",
    label: "School tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-high-rise",
    symbolName: "Asset 18building2",
    label: "High-rise ",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-townhouse",
    symbolName: "Asset 18house",
    label: "Townhouse",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-glass-tower",
    symbolName: "Asset 19building",
    label: "Glass tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-multi-storey-building",
    symbolName: "Asset 19building2",
    label: "Multi-storey building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-restaurant",
    symbolName: "Asset 19house",
    label: "Restaurant",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-cityscape",
    symbolName: "Asset 1building",
    label: "Cityscape",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-education",
    symbolName: "Asset 1building2",
    label: "Education",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-split-level-home",
    symbolName: "Asset 1house",
    label: "Split-level home",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-garage",
    symbolName: "Asset 20building2",
    label: "Garage",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-shopping-center",
    symbolName: "Asset 20house",
    label: "Shopping center",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-city-building",
    symbolName: "Asset 2building",
    label: "City building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyscraper",
    symbolName: "Asset 2building2",
    label: "Skyscraper",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-school",
    symbolName: "Asset 3building",
    label: "School",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-building-with-outline",
    symbolName: "Asset 3building2",
    label: "Building with outline",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-modern-house",
    symbolName: "Asset 3house",
    label: "Modern house",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-office-building",
    symbolName: "Asset 4building",
    label: "Office building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyline-2",
    symbolName: "Asset 4building2",
    label: "Skyline 2",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-two-storey-house",
    symbolName: "Asset 4house",
    label: "Two storey house",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-campus",
    symbolName: "Asset 5building",
    label: "Campus",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-college",
    symbolName: "Asset 5building2",
    label: "College",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-store",
    symbolName: "Asset 5house",
    label: "Store",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-government-building",
    symbolName: "Asset 6building",
    label: "Government building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-capitol",
    symbolName: "Asset 6building2",
    label: "Capitol",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-shop",
    symbolName: "Asset 6house",
    label: "Shop",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-official-building",
    symbolName: "Asset 7building",
    label: "Official building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyline",
    symbolName: "Asset 7building2",
    label: "Skyline",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-house-with-chimney",
    symbolName: "Asset 7house",
    label: "House with chimney",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyline-3",
    symbolName: "Asset 8building",
    label: "Skyline 3",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-bungalow",
    symbolName: "Asset 8house",
    label: "Bungalow",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-high-rise-2",
    symbolName: "Asset 9building",
    label: "High-rise",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-condo",
    symbolName: "Asset 9building2",
    label: "Condo",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-low-rise",
    symbolName: "Asset 9house",
    label: "Low-rise",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "human-landscape-1-symbol-1",
    symbolName: "Asset 9pencil",
    label: "Symbol 1",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-2",
    symbolName: "Asset 10pencil",
    label: "Symbol 2",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-3",
    symbolName: "Asset 11pencil",
    label: "Symbol 3",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-4",
    symbolName: "Asset 12pencil",
    label: "Symbol 4",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-5",
    symbolName: "Asset 13pencil",
    label: "Symbol 5",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-6",
    symbolName: "Asset 14pencil",
    label: "Symbol 6",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-7",
    symbolName: "Asset 15pencil",
    label: "Symbol 7",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-8",
    symbolName: "Asset 16pencil",
    label: "Symbol 8",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-9",
    symbolName: "Asset 17pencil",
    label: "Symbol 9",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-10",
    symbolName: "Asset 18pencil",
    label: "Symbol 10",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-11",
    symbolName: "Asset 19pencil",
    label: "Symbol 11",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-12",
    symbolName: "Asset 1pencil",
    label: "Symbol 12",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-13",
    symbolName: "Asset 20pencil",
    label: "Symbol 13",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-14",
    symbolName: "Asset 21pencil",
    label: "Symbol 14",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-15",
    symbolName: "Asset 22pencil",
    label: "Symbol 15",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-16",
    symbolName: "Asset 23pencil",
    label: "Symbol 16",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-17",
    symbolName: "Asset 24pencil",
    label: "Symbol 17",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-18",
    symbolName: "Asset 25pencil",
    label: "Symbol 18",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-19",
    symbolName: "Asset 26pencil",
    label: "Symbol 19",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-20",
    symbolName: "Asset 27pencil",
    label: "Symbol 20",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-21",
    symbolName: "Asset 28pencil",
    label: "Symbol 21",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-22",
    symbolName: "Asset 29pencil",
    label: "Symbol 22",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-23",
    symbolName: "Asset 2pencil",
    label: "Symbol 23",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-24",
    symbolName: "Asset 30pencil",
    label: "Symbol 24",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-25",
    symbolName: "Asset 31pencil",
    label: "Symbol 25",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-26",
    symbolName: "Asset 32pencil",
    label: "Symbol 26",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-27",
    symbolName: "Asset 33pencil",
    label: "Symbol 27",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-28",
    symbolName: "Asset 34pencil",
    label: "Symbol 28",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-29",
    symbolName: "Asset 35pencil",
    label: "Symbol 29",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-30",
    symbolName: "Asset 36pencil",
    label: "Symbol 30",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-31",
    symbolName: "Asset 37pencil",
    label: "Symbol 31",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-32",
    symbolName: "Asset 38pencil",
    label: "Symbol 32",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-33",
    symbolName: "Asset 39pencil",
    label: "Symbol 33",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-34",
    symbolName: "Asset 3pencil",
    label: "Symbol 34",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-35",
    symbolName: "Asset 40pencil",
    label: "Symbol 35",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-36",
    symbolName: "Asset 41pencil",
    label: "Symbol 36",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-37",
    symbolName: "Asset 42pencil",
    label: "Symbol 37",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-38",
    symbolName: "Asset 43pencil",
    label: "Symbol 38",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-39",
    symbolName: "Asset 44pencil",
    label: "Symbol 39",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-40",
    symbolName: "Asset 45pencil",
    label: "Symbol 40",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-41l",
    symbolName: "Asset 46pencil",
    label: "Symbol 41l",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-42",
    symbolName: "Asset 47pencil",
    label: "Symbol 42",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-43",
    symbolName: "Asset 48pencil",
    label: "Symbol 43",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-44",
    symbolName: "Asset 49pencil",
    label: "Symbol 44",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-45",
    symbolName: "Asset 4pencil",
    label: "Symbol 45",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-46",
    symbolName: "Asset 50pencil",
    label: "Symbol 46",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-47",
    symbolName: "Asset 51pencil",
    label: "Symbol 47",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-48",
    symbolName: "Asset 52pencil",
    label: "Symbol 48",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-49",
    symbolName: "Asset 53pencil",
    label: "Symbol 49",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-50",
    symbolName: "Asset 54pencil",
    label: "Symbol 50",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-51",
    symbolName: "Asset 55pencil",
    label: "Symbol 51",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-52",
    symbolName: "Asset 56pencil",
    label: "Symbol 52",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-53",
    symbolName: "Asset 57pencil",
    label: "Symbol 53",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-54",
    symbolName: "Asset 58pencil",
    label: "Symbol 54",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-55",
    symbolName: "Asset 59pencil",
    label: "Symbol 55",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-56",
    symbolName: "Asset 5pencil",
    label: "Symbol 56",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-57",
    symbolName: "Asset 60pencil",
    label: "Symbol 57",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-58",
    symbolName: "Asset 61pencil",
    label: "Symbol 58",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-59",
    symbolName: "Asset 62pencil",
    label: "Symbol 59",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-60",
    symbolName: "Asset 63pencil",
    label: "Symbol 60",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-61",
    symbolName: "Asset 64pencil",
    label: "Symbol 61",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-62",
    symbolName: "Asset 65pencil",
    label: "Symbol 62",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-63",
    symbolName: "Asset 66pencil",
    label: "Symbol 63",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-64",
    symbolName: "Asset 67pencil",
    label: "Symbol 64",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-65",
    symbolName: "Asset 68pencil",
    label: "Symbol 65",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-66",
    symbolName: "Asset 69pencil",
    label: "Symbol 66",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-67",
    symbolName: "Asset 6pencil",
    label: "Symbol 67",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-68",
    symbolName: "Asset 70pencil",
    label: "Symbol 68",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-69",
    symbolName: "Asset 71pencil",
    label: "Symbol 69",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-70",
    symbolName: "Asset 7pencil",
    label: "Symbol 70",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-71",
    symbolName: "Asset 8pencil",
    label: "Symbol 71",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-72",
    symbolName: "Asset 138",
    label: "Symbol 72",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-73",
    symbolName: "Asset 139",
    label: "Symbol 73",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-74",
    symbolName: "Asset 14",
    label: "Symbol 74",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-75",
    symbolName: "Asset 140",
    label: "Symbol 75",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-76",
    symbolName: "Asset 141",
    label: "Symbol 76",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-77",
    symbolName: "Asset 142",
    label: "Symbol 77",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-78",
    symbolName: "Asset 143",
    label: "Symbol 78",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-79",
    symbolName: "Asset 144",
    label: "Symbol 79",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-80",
    symbolName: "Asset 145",
    label: "Symbol 80",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-81",
    symbolName: "Asset 146",
    label: "Symbol 81",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-82",
    symbolName: "Asset 147",
    label: "Symbol 82",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-83",
    symbolName: "Asset 148",
    label: "Symbol 83",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-84",
    symbolName: "Asset 15",
    label: "Symbol 84",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-85",
    symbolName: "Asset 150",
    label: "Symbol 85",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-86",
    symbolName: "Asset 151",
    label: "Symbol 86",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-87",
    symbolName: "Asset 152",
    label: "Symbol 87",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-88",
    symbolName: "Asset 153",
    label: "Symbol 88",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-89",
    symbolName: "Asset 154",
    label: "Symbol 89",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-90",
    symbolName: "Asset 158",
    label: "Symbol 90",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-91",
    symbolName: "Asset 159",
    label: "Symbol 91",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-92",
    symbolName: "Asset 164",
    label: "Symbol 92",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-93",
    symbolName: "Asset 165",
    label: "Symbol 93",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-94",
    symbolName: "Asset 166",
    label: "Symbol 94",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-95",
    symbolName: "Asset 167",
    label: "Symbol 95",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-96",
    symbolName: "Asset 168",
    label: "Symbol 96",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-97",
    symbolName: "Asset 169",
    label: "Symbol 97",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-98",
    symbolName: "Asset 17",
    label: "Symbol 98",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-99",
    symbolName: "Asset 170",
    label: "Symbol 99",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-100",
    symbolName: "Asset 171",
    label: "Symbol 100",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-101",
    symbolName: "Asset 172",
    label: "Symbol 101",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-102",
    symbolName: "Asset 173",
    label: "Symbol 102",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-103",
    symbolName: "Asset 174",
    label: "Symbol 103",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-104",
    symbolName: "Asset 175",
    label: "Symbol 104",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-105",
    symbolName: "Asset 176",
    label: "Symbol 105",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-106",
    symbolName: "Asset 177",
    label: "Symbol 106",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-107",
    symbolName: "Asset 178",
    label: "Symbol 107",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-108",
    symbolName: "Asset 179",
    label: "Symbol 108",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-109",
    symbolName: "Asset 18",
    label: "Symbol 109",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-110",
    symbolName: "Asset 180",
    label: "Symbol 110",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-111",
    symbolName: "Asset 181",
    label: "Symbol 111",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-112",
    symbolName: "Asset 182",
    label: "Symbol 112",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-113",
    symbolName: "Asset 183",
    label: "Symbol 113",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-114",
    symbolName: "Asset 184",
    label: "Symbol 114",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-115",
    symbolName: "Asset 19",
    label: "Symbol 115",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-116",
    symbolName: "Asset 191",
    label: "Symbol 116",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-117",
    symbolName: "Asset 192",
    label: "Symbol 117",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-118",
    symbolName: "Asset 193",
    label: "Symbol 118",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-119",
    symbolName: "Asset 194",
    label: "Symbol 119",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-120",
    symbolName: "Asset 195",
    label: "Symbol 120",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-2-symbol-1",
    symbolName: "Asset 100pencilcolored",
    label: "Symbol 1",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-2",
    symbolName: "Asset 101pencilcolored",
    label: "Symbol 2",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-3",
    symbolName: "Asset 103pencilcolored",
    label: "Symbol 3",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-4",
    symbolName: "Asset 104pencilcolored",
    label: "Symbol 4",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-5",
    symbolName: "Asset 105pencilcolored",
    label: "Symbol 5",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-6",
    symbolName: "Asset 107pencilcolored",
    label: "Symbol 6",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-7",
    symbolName: "Asset 108pencilcolored",
    label: "Symbol 7",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-8",
    symbolName: "Asset 109pencilcolored",
    label: "Symbol 8",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-9",
    symbolName: "Asset 120pencilcolored",
    label: "Symbol 9",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-10",
    symbolName: "Asset 127pencilcolored",
    label: "Symbol 10",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-11",
    symbolName: "Asset 219pencilcolored",
    label: "Symbol 11",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-12",
    symbolName: "Asset 220pencilcolored",
    label: "Symbol 12",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-13",
    symbolName: "Asset 221pencilcolored",
    label: "Symbol 13",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-14",
    symbolName: "Asset 222pencilcolored",
    label: "Symbol 14",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-15",
    symbolName: "Asset 223pencilcolored",
    label: "Symbol 15",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-16",
    symbolName: "Asset 224pencilcolored",
    label: "Symbol 16",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-17",
    symbolName: "Asset 225pencilcolored",
    label: "Symbol 17",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-18",
    symbolName: "Asset 226pencilcolored",
    label: "Symbol 18",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-19",
    symbolName: "Asset 227pencilcolored",
    label: "Symbol 19",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-20",
    symbolName: "Asset 228pencilcolored",
    label: "Symbol 20",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-21",
    symbolName: "Asset 229pencilcolored",
    label: "Symbol 21",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-22",
    symbolName: "Asset 230pencilcolored",
    label: "Symbol 22",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-23",
    symbolName: "Asset 231pencilcolored",
    label: "Symbol 23",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-24",
    symbolName: "Asset 232pencilcolored",
    label: "Symbol 24",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-25",
    symbolName: "Asset 233pencilcolored",
    label: "Symbol 25",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-26",
    symbolName: "Asset 234pencilcolored",
    label: "Symbol 26",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-27",
    symbolName: "Asset 235pencilcolored",
    label: "Symbol 27",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-28",
    symbolName: "Asset 236pencilcolored",
    label: "Symbol 28",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-29",
    symbolName: "Asset 237pencilcolored",
    label: "Symbol 29",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-30",
    symbolName: "Asset 238pencilcolored",
    label: "Symbol 30",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-31",
    symbolName: "Asset 239pencilcolored",
    label: "Symbol 31",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-32",
    symbolName: "Asset 99pencilcolored",
    label: "Symbol 32",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-33",
    symbolName: "Asset 98pencilcolored",
    label: "Symbol 33",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-34",
    symbolName: "Asset 96pencilcolored",
    label: "Symbol 34",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-35",
    symbolName: "Asset 95pencilcolored",
    label: "Symbol 35",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-36",
    symbolName: "Asset 94pencilcolored",
    label: "Symbol 36",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-37",
    symbolName: "Asset 93pencilcolored",
    label: "Symbol 37",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-38",
    symbolName: "Asset 92pencilcolored",
    label: "Symbol 38",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-39",
    symbolName: "Asset 91pencilcolored",
    label: "Symbol 39",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-40",
    symbolName: "Asset 90pencilcolored",
    label: "Symbol 40",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-41",
    symbolName: "Asset 89pencilcolored",
    label: "Symbol 41",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-42",
    symbolName: "Asset 88pencilcolored",
    label: "Symbol 42",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-43",
    symbolName: "Asset 72pencilcolored",
    label: "Symbol 43",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-44",
    symbolName: "Asset 71pencilcolored",
    label: "Symbol 44",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-45",
    symbolName: "Asset 70pencilcolored",
    label: "Symbol 45",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-46",
    symbolName: "Asset 69pencilcolored",
    label: "Symbol 46",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-47",
    symbolName: "Asset 68pencilcolored",
    label: "Symbol 47",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-48",
    symbolName: "Asset 67pencilcolored",
    label: "Symbol 48",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-49",
    symbolName: "Asset 66pencilcolored",
    label: "Symbol 49",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-50",
    symbolName: "Asset 64pencilcolored",
    label: "Symbol 50",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-51",
    symbolName: "Asset 63pencilcolored",
    label: "Symbol 51",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-52",
    symbolName: "Asset 62pencilcolored",
    label: "Symbol 52",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-53",
    symbolName: "Asset 409pencilcolored",
    label: "Symbol 53",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-54",
    symbolName: "Asset 410pencilcolored",
    label: "Symbol 54",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-55",
    symbolName: "Asset 411pencilcolored",
    label: "Symbol 55",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-56",
    symbolName: "Asset 412pencilcolored",
    label: "Symbol 56",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-57",
    symbolName: "Asset 413pencilcolored",
    label: "Symbol 57",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-58",
    symbolName: "Asset 414pencilcolored",
    label: "Symbol 58",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-59",
    symbolName: "Asset 415pencilcolored",
    label: "Symbol 59",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-60",
    symbolName: "Asset 416pencilcolored",
    label: "Symbol 60",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-61",
    symbolName: "Asset 417pencilcolored",
    label: "Symbol 61",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-62",
    symbolName: "Asset 418pencilcolored",
    label: "Symbol 62",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-63",
    symbolName: "Asset 419pencilcolored",
    label: "Symbol 63",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-64",
    symbolName: "Asset 420pencilcolored",
    label: "Symbol 64",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-65",
    symbolName: "Asset 421pencilcolored",
    label: "Symbol 65",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-66",
    symbolName: "Asset 422pencilcolored",
    label: "Symbol 66",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-67",
    symbolName: "Asset 423pencilcolored",
    label: "Symbol 67",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-68",
    symbolName: "Asset 424pencilcolored",
    label: "Symbol 68",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-69",
    symbolName: "Asset 425pencilcolored",
    label: "Symbol 69",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-70",
    symbolName: "Asset 426pencilcolored",
    label: "Symbol 70",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-71",
    symbolName: "Asset 427pencilcolored",
    label: "Symbol 71",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-72",
    symbolName: "Asset 428pencilcolored",
    label: "Symbol 72",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-73",
    symbolName: "Asset 429pencilcolored",
    label: "Symbol 73",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-74",
    symbolName: "Asset 42pencilcolored",
    label: "Symbol 74",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-75",
    symbolName: "Asset 430pencilcolored",
    label: "Symbol 75",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-76",
    symbolName: "Asset 431pencilcolored",
    label: "Symbol 76",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-77",
    symbolName: "Asset 432pencilcolored",
    label: "Symbol 77",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-78",
    symbolName: "Asset 433pencilcolored",
    label: "Symbol 78",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-79",
    symbolName: "Asset 43pencilcolored",
    label: "Symbol 79",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-80",
    symbolName: "Asset 44pencilcolored",
    label: "Symbol 80",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-81",
    symbolName: "Asset 45pencilcolored",
    label: "Symbol 81",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-82",
    symbolName: "Asset 46pencilcolored",
    label: "Symbol 82",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-83",
    symbolName: "Asset 47pencilcolored",
    label: "Symbol 83",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-84",
    symbolName: "Asset 51pencilcolored",
    label: "Symbol 84",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-85",
    symbolName: "Asset 52pencilcolored",
    label: "Symbol 85",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-86",
    symbolName: "Asset 54pencilcolored",
    label: "Symbol 86",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-87",
    symbolName: "Asset 55pencilcolored",
    label: "Symbol 87",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-88",
    symbolName: "Asset 57pencilcolored",
    label: "Symbol 88",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "natural-landscape-1-symbol-1",
    symbolName: "Asset 1",
    label: "Symbol 1",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-2",
    symbolName: "Asset 10",
    label: "Symbol 2",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-3",
    symbolName: "Asset 100",
    label: "Symbol 3",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-4",
    symbolName: "Asset 102",
    label: "Symbol 4",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-5",
    symbolName: "Asset 103",
    label: "Symbol 5",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-6",
    symbolName: "Asset 104",
    label: "Symbol 6",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-7",
    symbolName: "Asset 106",
    label: "Symbol 7",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-8",
    symbolName: "Asset 108",
    label: "Symbol 8",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-9",
    symbolName: "Asset 109",
    label: "Symbol 9",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-10",
    symbolName: "Asset 11",
    label: "Symbol 10",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-11",
    symbolName: "Asset 110",
    label: "Symbol 11",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-12",
    symbolName: "Asset 111",
    label: "Symbol 12",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-13",
    symbolName: "Asset 112",
    label: "Symbol 13",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-14",
    symbolName: "Asset 113",
    label: "Symbol 14",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-15",
    symbolName: "Asset 114",
    label: "Symbol 15",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-16",
    symbolName: "Asset 116",
    label: "Symbol 16",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-17",
    symbolName: "Asset 117",
    label: "Symbol 17",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-18",
    symbolName: "Asset 118",
    label: "Symbol 18",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-19",
    symbolName: "Asset 119",
    label: "Symbol 19",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-20",
    symbolName: "Asset 12",
    label: "Symbol 20",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-21",
    symbolName: "Asset 120",
    label: "Symbol 21",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-22",
    symbolName: "Asset 121",
    label: "Symbol 22",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-23",
    symbolName: "Asset 122",
    label: "Symbol 23",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-24",
    symbolName: "Asset 123",
    label: "Symbol 24",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-25",
    symbolName: "Asset 124",
    label: "Symbol 25",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-26",
    symbolName: "Asset 125",
    label: "Symbol 26",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-27",
    symbolName: "Asset 127",
    label: "Symbol 27",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-28",
    symbolName: "Asset 128",
    label: "Symbol 28",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-29",
    symbolName: "Asset 129",
    label: "Symbol 29",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-30",
    symbolName: "Asset 13",
    label: "Symbol 30",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-31",
    symbolName: "Asset 130",
    label: "Symbol 31",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-32",
    symbolName: "Asset 131",
    label: "Symbol 32",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-33",
    symbolName: "Asset 132",
    label: "Symbol 33",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-34",
    symbolName: "Asset 133",
    label: "Symbol 34",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-35",
    symbolName: "Asset 134",
    label: "Symbol 35",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-36",
    symbolName: "Asset 135",
    label: "Symbol 36",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-37",
    symbolName: "Asset 137",
    label: "Symbol 37",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-38",
    symbolName: "Asset 16",
    label: "Symbol 38",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-39",
    symbolName: "Asset 160",
    label: "Symbol 39",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-40",
    symbolName: "Asset 161",
    label: "Symbol 40",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-41",
    symbolName: "Asset 162",
    label: "Symbol 41",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-42",
    symbolName: "Asset 163",
    label: "Symbol 42",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-43",
    symbolName: "Asset 2",
    label: "Symbol 43",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-44",
    symbolName: "Asset 20",
    label: "Symbol 44",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-45",
    symbolName: "Asset 21",
    label: "Symbol 45",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-46",
    symbolName: "Asset 22",
    label: "Symbol 46",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-47",
    symbolName: "Asset 23",
    label: "Symbol 47",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-48",
    symbolName: "Asset 24",
    label: "Symbol 48",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-49",
    symbolName: "Asset 25",
    label: "Symbol 49",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-50",
    symbolName: "Asset 26",
    label: "Symbol 50",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-51",
    symbolName: "Asset 27",
    label: "Symbol 51",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-52",
    symbolName: "Asset 28",
    label: "Symbol 52",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-53",
    symbolName: "Asset 29",
    label: "Symbol 53",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-54",
    symbolName: "Asset 3",
    label: "Symbol 54",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-55",
    symbolName: "Asset 31",
    label: "Symbol 55",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-56",
    symbolName: "Asset 32",
    label: "Symbol 56",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-57",
    symbolName: "Asset 33",
    label: "Symbol 57",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-58",
    symbolName: "Asset 34",
    label: "Symbol 58",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-59",
    symbolName: "Asset 35",
    label: "Symbol 59",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-60",
    symbolName: "Asset 36",
    label: "Symbol 60",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-61",
    symbolName: "Asset 37",
    label: "Symbol 61",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-62",
    symbolName: "Asset 38",
    label: "Symbol 62",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-63",
    symbolName: "Asset 39",
    label: "Symbol 63",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-64",
    symbolName: "Asset 4",
    label: "Symbol 64",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-65",
    symbolName: "Asset 40",
    label: "Symbol 65",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-66",
    symbolName: "Asset 41",
    label: "Symbol 66",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-67",
    symbolName: "Asset 42",
    label: "Symbol 67",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-68",
    symbolName: "Asset 43",
    label: "Symbol 68",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-69",
    symbolName: "Asset 44",
    label: "Symbol 69",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-70",
    symbolName: "Asset 45",
    label: "Symbol 70",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-71",
    symbolName: "Asset 46",
    label: "Symbol 71",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-72",
    symbolName: "Asset 47",
    label: "Symbol 72",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-73",
    symbolName: "Asset 48",
    label: "Symbol 73",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-74",
    symbolName: "Asset 5",
    label: "Symbol 74",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-75",
    symbolName: "Asset 52",
    label: "Symbol 75",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-76",
    symbolName: "Asset 53",
    label: "Symbol 76",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-77",
    symbolName: "Asset 54",
    label: "Symbol 77",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-78",
    symbolName: "Asset 55",
    label: "Symbol 78",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-79",
    symbolName: "Asset 56",
    label: "Symbol 79",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-80",
    symbolName: "Asset 57",
    label: "Symbol 80",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-81",
    symbolName: "Asset 58",
    label: "Symbol 81",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-82",
    symbolName: "Asset 59",
    label: "Symbol 82",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-83",
    symbolName: "Asset 6",
    label: "Symbol 83",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-84",
    symbolName: "Asset 60",
    label: "Symbol 84",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-85",
    symbolName: "Asset 61",
    label: "Symbol 85",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-86",
    symbolName: "Asset 62",
    label: "Symbol 86",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-87",
    symbolName: "Asset 63",
    label: "Symbol 87",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-88",
    symbolName: "Asset 64",
    label: "Symbol 88",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-89",
    symbolName: "Asset 65",
    label: "Symbol 89",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-90",
    symbolName: "Asset 66",
    label: "Symbol 90",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-91",
    symbolName: "Asset 67",
    label: "Symbol 91",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-92",
    symbolName: "Asset 68",
    label: "Symbol 92",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-93",
    symbolName: "Asset 69",
    label: "Symbol 93",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-94",
    symbolName: "Asset 7",
    label: "Symbol 94",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-95",
    symbolName: "Asset 70",
    label: "Symbol 95",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-96",
    symbolName: "Asset 71",
    label: "Symbol 96",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-97",
    symbolName: "Asset 72",
    label: "Symbol 97",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-98",
    symbolName: "Asset 73",
    label: "Symbol 98",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-99",
    symbolName: "Asset 74",
    label: "Symbol 99",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-100",
    symbolName: "Asset 75",
    label: "Symbol 100",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-101",
    symbolName: "Asset 76",
    label: "Symbol 101",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-102",
    symbolName: "Asset 77",
    label: "Symbol 102",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-103",
    symbolName: "Asset 78",
    label: "Symbol 103",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-104",
    symbolName: "Asset 79",
    label: "Symbol 104",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-105",
    symbolName: "Asset 8",
    label: "Symbol 105",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-106",
    symbolName: "Asset 80",
    label: "Symbol 106",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-107",
    symbolName: "Asset 81",
    label: "Symbol 107",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-108",
    symbolName: "Asset 82",
    label: "Symbol 108",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-109",
    symbolName: "Asset 83",
    label: "Symbol 109",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-110",
    symbolName: "Asset 85",
    label: "Symbol 110",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-111",
    symbolName: "Asset 86",
    label: "Symbol 111",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-112",
    symbolName: "Asset 87",
    label: "Symbol 112",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-113",
    symbolName: "Asset 88",
    label: "Symbol 113",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-114",
    symbolName: "Asset 89",
    label: "Symbol 114",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-115",
    symbolName: "Asset 9",
    label: "Symbol 115",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-116",
    symbolName: "Asset 90",
    label: "Symbol 116",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-117",
    symbolName: "Asset 91",
    label: "Symbol 117",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-118",
    symbolName: "Asset 92",
    label: "Symbol 118",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-119",
    symbolName: "Asset 93",
    label: "Symbol 119",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-120",
    symbolName: "Asset 94",
    label: "Symbol 120",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-121",
    symbolName: "Asset 95",
    label: "Symbol 121",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-122",
    symbolName: "Asset 96",
    label: "Symbol 122",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-123",
    symbolName: "Asset 97",
    label: "Symbol 123",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-124",
    symbolName: "Asset 98",
    label: "Symbol 124",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-125",
    symbolName: "Asset 99",
    label: "Symbol 125",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-2-symbol-1",
    symbolName: "Asset 130pencilcolored",
    label: "Symbol 1",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-2",
    symbolName: "Asset 131pencilcolored",
    label: "Symbol 2",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-3",
    symbolName: "Asset 132pencilcolored",
    label: "Symbol 3",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-4",
    symbolName: "Asset 133pencilcolored",
    label: "Symbol 4",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-5",
    symbolName: "Asset 134pencilcolored",
    label: "Symbol 5",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-6",
    symbolName: "Asset 135pencilcolored",
    label: "Symbol 6",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-7",
    symbolName: "Asset 136pencilcolored",
    label: "Symbol 7",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-8",
    symbolName: "Asset 137pencilcolored",
    label: "Symbol 8",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-9",
    symbolName: "Asset 138pencilcolored",
    label: "Symbol 9",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-10",
    symbolName: "Asset 139pencilcolored",
    label: "Symbol 10",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-11",
    symbolName: "Asset 140pencilcolored",
    label: "Symbol 11",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-12",
    symbolName: "Asset 141pencilcolored",
    label: "Symbol 12",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-13",
    symbolName: "Asset 142pencilcolored",
    label: "Symbol 13",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-14",
    symbolName: "Asset 143pencilcolored",
    label: "Symbol 14",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-15",
    symbolName: "Asset 144pencilcolored",
    label: "Symbol 15",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-16",
    symbolName: "Asset 145pencilcolored",
    label: "Symbol 16",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-17",
    symbolName: "Asset 146pencilcolored",
    label: "Symbol 17",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-18",
    symbolName: "Asset 147pencilcolored",
    label: "Symbol 18",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-19",
    symbolName: "Asset 148pencilcolored",
    label: "Symbol 19",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-20",
    symbolName: "Asset 149pencilcolored",
    label: "Symbol 20",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-21",
    symbolName: "Asset 150pencilcolored",
    label: "Symbol 21",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-23",
    symbolName: "Asset 151pencilcolored",
    label: "Symbol 23",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-24",
    symbolName: "Asset 152pencilcolored",
    label: "Symbol 24",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-25",
    symbolName: "Asset 153pencilcolored",
    label: "Symbol 25",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-26",
    symbolName: "Asset 154pencilcolored",
    label: "Symbol 26",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-27",
    symbolName: "Asset 155pencilcolored",
    label: "Symbol 27",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-28",
    symbolName: "Asset 156pencilcolored",
    label: "Symbol 28",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-29",
    symbolName: "Asset 157pencilcolored",
    label: "Symbol 29",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-30",
    symbolName: "Asset 158pencilcolored",
    label: "Symbol 30",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-31",
    symbolName: "Asset 159pencilcolored",
    label: "Symbol 31",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-32",
    symbolName: "Asset 160pencilcolored",
    label: "Symbol 32",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-33",
    symbolName: "Asset 161pencilcolored",
    label: "Symbol 33",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-34",
    symbolName: "Asset 162pencilcolored",
    label: "Symbol 34",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-35",
    symbolName: "Asset 163pencilcolored",
    label: "Symbol 35",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-36",
    symbolName: "Asset 164pencilcolored",
    label: "Symbol 36",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-37",
    symbolName: "Asset 200pencilcolored",
    label: "Symbol 37",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-38",
    symbolName: "Asset 201pencilcolored",
    label: "Symbol 38",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-39",
    symbolName: "Asset 202pencilcolored",
    label: "Symbol 39",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-40",
    symbolName: "Asset 203pencilcolored",
    label: "Symbol 40",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-41",
    symbolName: "Asset 204pencilcolored",
    label: "Symbol 41",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-42",
    symbolName: "Asset 205pencilcolored",
    label: "Symbol 42",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-43",
    symbolName: "Asset 207pencilcolored",
    label: "Symbol 43",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-44",
    symbolName: "Asset 208pencilcolored",
    label: "Symbol 44",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-45",
    symbolName: "Asset 209pencilcolored",
    label: "Symbol 45",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-46",
    symbolName: "Asset 210pencilcolored",
    label: "Symbol 46",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-47",
    symbolName: "Asset 211pencilcolored",
    label: "Symbol 47",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-48",
    symbolName: "Asset 212pencilcolored",
    label: "Symbol 48",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-49",
    symbolName: "Asset 213pencilcolored",
    label: "Symbol 49",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-50",
    symbolName: "Asset 214pencilcolored",
    label: "Symbol 50",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-51",
    symbolName: "Asset 215pencilcolored",
    label: "Symbol 51",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-52",
    symbolName: "Asset 216pencilcolored",
    label: "Symbol 52",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-53",
    symbolName: "Asset 217pencilcolored",
    label: "Symbol 53",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-54",
    symbolName: "Asset 218pencilcolored",
    label: "Symbol 54",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-55",
    symbolName: "Asset 240pencilcolored",
    label: "Symbol 55",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-56",
    symbolName: "Asset 241pencilcolored",
    label: "Symbol 56",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-57",
    symbolName: "Asset 242pencilcolored",
    label: "Symbol 57",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-58",
    symbolName: "Asset 243pencilcolored",
    label: "Symbol 58",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-59",
    symbolName: "Asset 244pencilcolored",
    label: "Symbol 59",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-60",
    symbolName: "Asset 245pencilcolored",
    label: "Symbol 60",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-61",
    symbolName: "Asset 246pencilcolored",
    label: "Symbol 61",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-62",
    symbolName: "Asset 247pencilcolored",
    label: "Symbol 62",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-63",
    symbolName: "Asset 248pencilcolored",
    label: "Symbol 63",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-64",
    symbolName: "Asset 249pencilcolored",
    label: "Symbol 64",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-65",
    symbolName: "Asset 250pencilcolored",
    label: "Symbol 65",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-66",
    symbolName: "Asset 251pencilcolored",
    label: "Symbol 66",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-67",
    symbolName: "Asset 252pencilcolored",
    label: "Symbol 67",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-68",
    symbolName: "Asset 253pencilcolored",
    label: "Symbol 68",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-69",
    symbolName: "Asset 254pencilcolored",
    label: "Symbol 69",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-70",
    symbolName: "Asset 255pencilcolored",
    label: "Symbol 70",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-71",
    symbolName: "Asset 256pencilcolored",
    label: "Symbol 71",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-72",
    symbolName: "Asset 257pencilcolored",
    label: "Symbol 72",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-73",
    symbolName: "Asset 258pencilcolored",
    label: "Symbol 73",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-74",
    symbolName: "Asset 259pencilcolored",
    label: "Symbol 74",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-75",
    symbolName: "Asset 260pencilcolored",
    label: "Symbol 75",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-76",
    symbolName: "Asset 261pencilcolored",
    label: "Symbol 76",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-77",
    symbolName: "Asset 262pencilcolored",
    label: "Symbol 77",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-78",
    symbolName: "Asset 263pencilcolored",
    label: "Symbol 78",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-79",
    symbolName: "Asset 264pencilcolored",
    label: "Symbol 79",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-80",
    symbolName: "Asset 265pencilcolored",
    label: "Symbol 80",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-81",
    symbolName: "Asset 266pencilcolored",
    label: "Symbol 81",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-82",
    symbolName: "Asset 267pencilcolored",
    label: "Symbol 82",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-83",
    symbolName: "Asset 268pencilcolored",
    label: "Symbol 83",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-84",
    symbolName: "Asset 269pencilcolored",
    label: "Symbol 84",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-85",
    symbolName: "Asset 270pencilcolored",
    label: "Symbol 85",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-86",
    symbolName: "Asset 271pencilcolored",
    label: "Symbol 86",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-87",
    symbolName: "Asset 272pencilcolored",
    label: "Symbol 87",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-88",
    symbolName: "Asset 273pencilcolored",
    label: "Symbol 88",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-89",
    symbolName: "Asset 274pencilcolored",
    label: "Symbol 89",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-90",
    symbolName: "Asset 275pencilcolored",
    label: "Symbol 90",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-91",
    symbolName: "Asset 276pencilcolored",
    label: "Symbol 91",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-92",
    symbolName: "Asset 277pencilcolored",
    label: "Symbol 92",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-93",
    symbolName: "Asset 278pencilcolored",
    label: "Symbol 93",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-94",
    symbolName: "Asset 279pencilcolored",
    label: "Symbol 94",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-95",
    symbolName: "Asset 280pencilcolored",
    label: "Symbol 95",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-96",
    symbolName: "Asset 281pencilcolored",
    label: "Symbol 96",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-97",
    symbolName: "Asset 282pencilcolored",
    label: "Symbol 97",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-98",
    symbolName: "Asset 283pencilcolored",
    label: "Symbol 98",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-99",
    symbolName: "Asset 284pencilcolored",
    label: "Symbol 99",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-100",
    symbolName: "Asset 285pencilcolored",
    label: "Symbol 100",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-101",
    symbolName: "Asset 286pencilcolored",
    label: "Symbol 101",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-102",
    symbolName: "Asset 287pencilcolored",
    label: "Symbol 102",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-103",
    symbolName: "Asset 288pencilcolored",
    label: "Symbol 103",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-104",
    symbolName: "Asset 289pencilcolored",
    label: "Symbol 104",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-105",
    symbolName: "Asset 290pencilcolored",
    label: "Symbol 105",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-106",
    symbolName: "Asset 291pencilcolored",
    label: "Symbol 106",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-107",
    symbolName: "Asset 292pencilcolored",
    label: "Symbol 107",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-108",
    symbolName: "Asset 293pencilcolored",
    label: "Symbol 108",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-109",
    symbolName: "Asset 295pencilcolored",
    label: "Symbol 109",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-110",
    symbolName: "Asset 296pencilcolored",
    label: "Symbol 110",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-111",
    symbolName: "Asset 301pencilcolored",
    label: "Symbol 111",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-112",
    symbolName: "Asset 302pencilcolored",
    label: "Symbol 112",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-113",
    symbolName: "Asset 303pencilcolored",
    label: "Symbol 113",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-114",
    symbolName: "Asset 304pencilcolored",
    label: "Symbol 114",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-115",
    symbolName: "Asset 305pencilcolored",
    label: "Symbol 115",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-116",
    symbolName: "Asset 306pencilcolored",
    label: "Symbol 116",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-117",
    symbolName: "Asset 308pencilcolored",
    label: "Symbol 117",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-118",
    symbolName: "Asset 310pencilcolored",
    label: "Symbol 118",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-119",
    symbolName: "Asset 311pencilcolored",
    label: "Symbol 119",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-120",
    symbolName: "Asset 312pencilcolored",
    label: "Symbol 120",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-121",
    symbolName: "Asset 313pencilcolored",
    label: "Symbol 121",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-122",
    symbolName: "Asset 314pencilcolored",
    label: "Symbol 122",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-123",
    symbolName: "Asset 315pencilcolored",
    label: "Symbol 123",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-124",
    symbolName: "Asset 321pencilcolored",
    label: "Symbol 124",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-125",
    symbolName: "Asset 322pencilcolored",
    label: "Symbol 125",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-126",
    symbolName: "Asset 323pencilcolored",
    label: "Symbol 126",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-127",
    symbolName: "Asset 324pencilcolored",
    label: "Symbol 127",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-128",
    symbolName: "Asset 325pencilcolored",
    label: "Symbol 128",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-129",
    symbolName: "Asset 326pencilcolored",
    label: "Symbol 129",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-130",
    symbolName: "Asset 327pencilcolored",
    label: "Symbol 130",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-131",
    symbolName: "Asset 328pencilcolored",
    label: "Symbol 131",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-132",
    symbolName: "Asset 329pencilcolored",
    label: "Symbol 132",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-133",
    symbolName: "Asset 330pencilcolored",
    label: "Symbol 133",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-134",
    symbolName: "Asset 331pencilcolored",
    label: "Symbol 134",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-135",
    symbolName: "Asset 332pencilcolored",
    label: "Symbol 135",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-136",
    symbolName: "Asset 333pencilcolored",
    label: "Symbol 136",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-137",
    symbolName: "Asset 334pencilcolored",
    label: "Symbol 137",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-138",
    symbolName: "Asset 335pencilcolored",
    label: "Symbol 138",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-139",
    symbolName: "Asset 336pencilcolored",
    label: "Symbol 139",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-140",
    symbolName: "Asset 337pencilcolored",
    label: "Symbol 140",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-141",
    symbolName: "Asset 338pencilcolored",
    label: "Symbol 141",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-142",
    symbolName: "Asset 339pencilcolored",
    label: "Symbol 142",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-143",
    symbolName: "Asset 340pencilcolored",
    label: "Symbol 143",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-144",
    symbolName: "Asset 341pencilcolored",
    label: "Symbol 144",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-145",
    symbolName: "Asset 342pencilcolored",
    label: "Symbol 145",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-146",
    symbolName: "Asset 343pencilcolored",
    label: "Symbol 146",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-147",
    symbolName: "Asset 344pencilcolored",
    label: "Symbol 147",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-148",
    symbolName: "Asset 345pencilcolored",
    label: "Symbol 148",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-149",
    symbolName: "Asset 346pencilcolored",
    label: "Symbol 149",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-150",
    symbolName: "Asset 347pencilcolored",
    label: "Symbol 150",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-151",
    symbolName: "Asset 348pencilcolored",
    label: "Symbol 151",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-152",
    symbolName: "Asset 349pencilcolored",
    label: "Symbol 152",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-153",
    symbolName: "Asset 350pencilcolored",
    label: "Symbol 153",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-154",
    symbolName: "Asset 351pencilcolored",
    label: "Symbol 154",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-155",
    symbolName: "Asset 352pencilcolored",
    label: "Symbol 155",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-156",
    symbolName: "Asset 353pencilcolored",
    label: "Symbol 156",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-157",
    symbolName: "Asset 354pencilcolored",
    label: "Symbol 157",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-158",
    symbolName: "Asset 355pencilcolored",
    label: "Symbol 158",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-159",
    symbolName: "Asset 359pencilcolored",
    label: "Symbol 159",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-160",
    symbolName: "Asset 361pencilcolored",
    label: "Symbol 160",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-161",
    symbolName: "Asset 375pencilcolored",
    label: "Symbol 161",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-162",
    symbolName: "Asset 383pencilcolored",
    label: "Symbol 162",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-163",
    symbolName: "Asset 384pencilcolored",
    label: "Symbol 163",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-164",
    symbolName: "Asset 385pencilcolored",
    label: "Symbol 164",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-165",
    symbolName: "Asset 386pencilcolored",
    label: "Symbol 165",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-166",
    symbolName: "Asset 387pencilcolored",
    label: "Symbol 166",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-167",
    symbolName: "Asset 388pencilcolored",
    label: "Symbol 167",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-168",
    symbolName: "Asset 389pencilcolored",
    label: "Symbol 168",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-169",
    symbolName: "Asset 390pencilcolored",
    label: "Symbol 169",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-170",
    symbolName: "Asset 391pencilcolored",
    label: "Symbol 170",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-171",
    symbolName: "Asset 392pencilcolored",
    label: "Symbol 171",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-172",
    symbolName: "Asset 393pencilcolored",
    label: "Symbol 172",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-173",
    symbolName: "Asset 394pencilcolored",
    label: "Symbol 173",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-174",
    symbolName: "Asset 395pencilcolored",
    label: "Symbol 174",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-175",
    symbolName: "Asset 396pencilcolored",
    label: "Symbol 175",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-176",
    symbolName: "Asset 397pencilcolored",
    label: "Symbol 176",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-177",
    symbolName: "Asset 398pencilcolored",
    label: "Symbol 177",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-178",
    symbolName: "Asset 399pencilcolored",
    label: "Symbol 178",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-179",
    symbolName: "Asset 400pencilcolored",
    label: "Symbol 179",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-180",
    symbolName: "Asset 401pencilcolored",
    label: "Symbol 180",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-181",
    symbolName: "Asset 402pencilcolored",
    label: "Symbol 181",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-182",
    symbolName: "Asset 404pencilcolored",
    label: "Symbol 182",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-183",
    symbolName: "Asset 405pencilcolored",
    label: "Symbol 183",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-184",
    symbolName: "Asset 406pencilcolored",
    label: "Symbol 184",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-185",
    symbolName: "Asset 407pencilcolored",
    label: "Symbol 185",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-186",
    symbolName: "Asset 408pencilcolored",
    label: "Symbol 186",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-187",
    symbolName: "Asset 441pencilcolored",
    label: "Symbol 187",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-188",
    symbolName: "Asset 442pencilcolored",
    label: "Symbol 188",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-189",
    symbolName: "Asset 443pencilcolored",
    label: "Symbol 189",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-190",
    symbolName: "Asset 435pencilcolored",
    label: "Symbol 190",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-191",
    symbolName: "Asset 444pencilcolored",
    label: "Symbol 191",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-192",
    symbolName: "Asset 445pencilcolored",
    label: "Symbol 192",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-193",
    symbolName: "Asset 447pencilcolored",
    label: "Symbol 193",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-194",
    symbolName: "Asset 448pencilcolored",
    label: "Symbol 194",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-195",
    symbolName: "Asset 446pencilcolored",
    label: "Symbol 195",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-196",
    symbolName: "Asset 449pencilcolored",
    label: "Symbol 196",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-197",
    symbolName: "Asset 450pencilcolored",
    label: "Symbol 197",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-198",
    symbolName: "Asset 451pencilcolored",
    label: "Symbol 198",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-199",
    symbolName: "Asset 452pencilcolored",
    label: "Symbol 199",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-200",
    symbolName: "Asset 454pencilcolored",
    label: "Symbol 200",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-201",
    symbolName: "Asset 453pencilcolored",
    label: "Symbol 201",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-202",
    symbolName: "Asset 455pencilcolored",
    label: "Symbol 202",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-203",
    symbolName: "Asset 456pencilcolored",
    label: "Symbol 203",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-204",
    symbolName: "Asset 457pencilcolored",
    label: "Symbol 204",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-205",
    symbolName: "Asset 458pencilcolored",
    label: "Symbol 205",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-206",
    symbolName: "Asset 460pencilcolored",
    label: "Symbol 206",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-207",
    symbolName: "Asset 461pencilcolored",
    label: "Symbol 207",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-208",
    symbolName: "Asset 462pencilcolored",
    label: "Symbol 208",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-209",
    symbolName: "Asset 463pencilcolored",
    label: "Symbol 209",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-210",
    symbolName: "Asset 464pencilcolored",
    label: "Symbol 210",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-211",
    symbolName: "Asset 465pencilcolored",
    label: "Symbol 211",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "arrows-arrow-1",
    symbolName: "Arrow 1_Arrows_3",
    label: "Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-2",
    symbolName: "Arrow 2_Arrows_3",
    label: "Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-3",
    symbolName: "Arrow 3_Arrows_3",
    label: "Arrow 3",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-4",
    symbolName: "Arrow 4_Arrows_3",
    label: "Arrow 4",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-5",
    symbolName: "Arrow 5_Arrows_3",
    label: "Arrow 5",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-6",
    symbolName: "Arrow 6_Arrows_3",
    label: "Arrow 6",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-7",
    symbolName: "Arrow 7_Arrows_3",
    label: "Arrow 7",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-8",
    symbolName: "Arrow 8_Arrows_3",
    label: "Arrow 8",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-9",
    symbolName: "Arrow 9_Arrows_3",
    label: "Arrow 9",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-10",
    symbolName: "Arrow 10_Arrows_3",
    label: "Arrow 10",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-11",
    symbolName: "Arrow 11_Arrows_3",
    label: "Arrow 11",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-12",
    symbolName: "Arrow 12_Arrows_3",
    label: "Arrow 12",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-13",
    symbolName: "Arrow 13_Arrows_3",
    label: "Arrow 13",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-14",
    symbolName: "Arrow 14_Arrows_3",
    label: "Arrow 14",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-15",
    symbolName: "Arrow 15_Arrows_3",
    label: "Arrow 15",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-16",
    symbolName: "Arrow 16_Arrows_3",
    label: "Arrow 16",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-17",
    symbolName: "Arrow 17_Arrows_3",
    label: "Arrow 17",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-18",
    symbolName: "Arrow 18_Arrows_3",
    label: "Arrow 18",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-19",
    symbolName: "Arrow 19_Arrows_3",
    label: "Arrow 19",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-20",
    symbolName: "Arrow 20_Arrows_3",
    label: "Arrow 20",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-cutout-1",
    symbolName: "Arrow Cutout 1_Arrows_3",
    label: "Arrow Cutout 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-cutout-2",
    symbolName: "Arrow Cutout 2_Arrows_3",
    label: "Arrow Cutout 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-cutout-3",
    symbolName: "Arrow Cutout 3_Arrows_3",
    label: "Arrow Cutout 3",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-clockwise-arrow",
    symbolName: "Clockwise Arrow_Other_3",
    label: "Clockwise Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-counterclockwise-arrow",
    symbolName: "Counterclockwise Arrow_Other_3",
    label: "Counterclockwise Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-left-turn-arrow-1",
    symbolName: "Left Turn Arrow 1_Other_3",
    label: "Left Turn Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-right-turn-arrow-1",
    symbolName: "Right Turn Arrow 1_Other_3",
    label: "Right Turn Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-left-turn-arrow-2",
    symbolName: "Left Turn Arrow 2_Other_3",
    label: "Left Turn Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-right-turn-arrow-2",
    symbolName: "Right Turn Arrow 2_Other_3",
    label: "Right Turn Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-paired-arrow",
    symbolName: "Paired Arrow_Other_3",
    label: "Paired Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-two-way-arrow",
    symbolName: "Two-Way Arrow_Other_3",
    label: "Two-Way Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-u-turn-arrow-1",
    symbolName: "U Turn Arrow 1_Other_3",
    label: "U Turn Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-u-turn-arrow-2",
    symbolName: "U Turn Arrow 2_Other_3",
    label: "U Turn Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-a",
    symbolName: "Arrowhead A_Arrowheads_3",
    label: "Arrowhead A",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-b",
    symbolName: "Arrowhead B_Arrowheads_3",
    label: "Arrowhead B",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-c",
    symbolName: "Arrowhead C_Arrowheads_3",
    label: "Arrowhead C",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-d",
    symbolName: "Arrowhead D_Arrowheads_3",
    label: "Arrowhead D",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-e",
    symbolName: "Arrowhead E_Arrowheads_3",
    label: "Arrowhead E",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-f",
    symbolName: "Arrowhead F_Arrowheads_3",
    label: "Arrowhead F",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-g",
    symbolName: "Arrowhead G_Arrowheads_3",
    label: "Arrowhead G",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-h",
    symbolName: "Arrowhead H_Arrowheads_3",
    label: "Arrowhead H",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-j",
    symbolName: "Arrowhead J_Arrowheads_3",
    label: "Arrowhead J",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-k",
    symbolName: "Arrowhead K_Arrowheads_3",
    label: "Arrowhead K",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-l",
    symbolName: "Arrowhead L_Arrowheads_3",
    label: "Arrowhead L",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-m",
    symbolName: "Arrowhead M_Arrowheads_3",
    label: "Arrowhead M",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-n",
    symbolName: "Arrowhead N_Arrowheads_3",
    label: "Arrowhead N",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-p",
    symbolName: "Arrowhead P_Arrowheads_3",
    label: "Arrowhead P",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-q",
    symbolName: "Arrowhead Q_Arrowheads_3",
    label: "Arrowhead Q",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-r",
    symbolName: "Arrowhead R_Arrowheads_3",
    label: "Arrowhead R",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-s",
    symbolName: "Arrowhead S_Arrowheads_3",
    label: "Arrowhead S",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "animated-circle-with-outline-scaling",
    symbolName: "Circle with outline scaling",
    label: "Circle with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-triangle-with-outline-scaling",
    symbolName: "Triangle with outline scaling",
    label: "Triangle with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-with-outline-scaling",
    symbolName: "Square with outline scaling",
    label: "Square with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-rounded-with-outline-scaling",
    symbolName: "Rounded with outline scaling",
    label: "Rounded with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-octagon-with-outline-scaling",
    symbolName: "Octagon with outline scaling",
    label: "Octagon with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-hexagon-with-outline-scaling",
    symbolName: "Hexagon with outline scaling",
    label: "Hexagon with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-star-with-outline-scaling",
    symbolName: "Star with outline scaling",
    label: "Star with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-circle-scaling",
    symbolName: "Circle scaling",
    label: "Circle scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-triangle-scaling",
    symbolName: "Triangle scaling",
    label: "Triangle scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-scaling",
    symbolName: "Square scaling",
    label: "Square scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-rounded-with-scaling",
    symbolName: "Rounded scaling",
    label: "Rounded with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-octagon-with-scaling",
    symbolName: "Octagon scaling",
    label: "Octagon with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-hexagon-with-scaling",
    symbolName: "Hexagon scaling",
    label: "Hexagon with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-star-with-scaling",
    symbolName: "Star with scaling",
    label: "Star with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-pin-offset",
    symbolName: "Pin offset",
    label: "Pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-teardrop-pin-offset",
    symbolName: "Teardrop pin offset",
    label: "Teardrop pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-offset",
    symbolName: "Esri pin offset",
    label: "Esri pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-pin-offset",
    symbolName: "Square pin offset",
    label: "Square pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-2-offset",
    symbolName: "Esri Pin 2 offset",
    label: "Esri Pin 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-tear-pin-2-offset",
    symbolName: "Tear Pin 2 offset",
    label: "Tear Pin 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-pin-scaling",
    symbolName: "Pin scaling",
    label: "Pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-teardrop-scaling",
    symbolName: "Teardrop scaling",
    label: "Teardrop scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-scaling",
    symbolName: "Esri pin  scaling",
    label: "Esri pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-pin-scaling",
    symbolName: "Square pin scaling",
    label: "Square pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-scaling-2",
    symbolName: "Esri Pin scaling",
    label: "Esri Pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-tear-pin-2-scaling",
    symbolName: "Tear Pin 2 scaling",
    label: "Tear Pin 2 scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-1-offset",
    symbolName: "Arrow Marker 1 offset",
    label: "Arrow Marker 1 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-2-offset",
    symbolName: "Arrow Marker 2 offset",
    label: "Arrow Marker 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-3-offset",
    symbolName: "Arrow Marker 3 offset",
    label: "Arrow Marker 3 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-4-offset",
    symbolName: "Arrow Marker 4 offset",
    label: "Arrow Marker 4 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-5-offset",
    symbolName: "Arrow Marker 5 offset",
    label: "Arrow Marker 5 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrowhead-1-offset",
    symbolName: "Arrowhead 1 offset",
    label: "Arrowhead 1 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrowhead-2-offset",
    symbolName: "Arrowhead 2 offset",
    label: "Arrowhead 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrowhead-3-offset",
    symbolName: "Arrowhead 3 offset",
    label: "Arrowhead 3 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-fire-station-color-change",
    symbolName: "Fire Station color change",
    label: "Fire Station color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-police-station-color-change",
    symbolName: "Police Station color change",
    label: "Police Station color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-hospital-color-change",
    symbolName: "Hospital color change",
    label: "Hospital color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-fire-warning-color-change",
    symbolName: "Fire_Incidents - Large_3",
    label: "Fire warning color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-road-block-color-change",
    symbolName: "Road Block",
    label: "Road block color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-warning-color-change",
    symbolName: "Animated 3_1",
    label: "Warning color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-incident-poi-scaling",
    symbolName: "Originator Incident",
    label: "Incident POI scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-information-scaling",
    symbolName: "Information",
    label: "Information scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-crosshair",
    symbolName: "Crosshair",
    label: "Crosshair",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-crosshair",
    symbolName: "Square Crosshair",
    label: "Square Crosshair",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-cross-triangle",
    symbolName: "Cross Triangle",
    label: "Cross Triangle",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  }
], Qn = "Sirkler", er = Array.from(
  new Set(Ls.map((t) => t.category))
), Es = Ls.map((t) => ({
  name: t.name,
  label: t.label,
  category: t.category,
  webStyle: { symbolName: t.symbolName, styleUrl: t.styleUrl }
})), xs = new Map(Es.map((t) => [t.name, t]));
function ar(t) {
  return xs.get(t);
}
const tr = /* @__PURE__ */ new Set(["Shapes"]);
function ks(t) {
  const e = xs.get(t)?.category;
  return e != null && tr.has(e);
}
const nt = /* @__PURE__ */ new Map(), rt = /* @__PURE__ */ new Map(), ct = /* @__PURE__ */ new Map();
function sr(t) {
  let e = nt.get(t);
  return e || (e = fetch(`${t}?f=json`).then((l) => l.json()).then((l) => l.items ?? []), e.catch(() => nt.delete(t)), nt.set(t, e)), e;
}
function lr(t, e) {
  return /^https?:\/\//.test(e) ? e : `${t.replace(/\/data$/, "")}/${e.replace(/^\.\//, "")}`;
}
function nr(t) {
  let e = rt.get(t);
  return e || (e = fetch(`${t}?f=json`).then((l) => l.json()), e.catch(() => rt.delete(t)), rt.set(t, e)), e;
}
function Ms(t, e) {
  const l = `${t}::${e}`;
  let r = ct.get(l);
  return r || (r = sr(t).then((n) => {
    const o = n.find((y) => y.name === e);
    if (!o?.cimRef)
      throw new Error(`Symbolet "${e}" ble ikke funnet i stilen ${t}`);
    return nr(lr(t, o.cimRef));
  }).then((n) => new Ul({ data: { type: "CIMSymbolReference", symbol: n } })), r.catch(() => ct.delete(l)), ct.set(l, r)), r;
}
function rr(t) {
  const e = ar(t)?.webStyle;
  if (!e)
    throw new Error(`Fant ikke web style-symbol for "${t}"`);
  return Ms(e.styleUrl, e.symbolName);
}
async function cr(t, e, l) {
  const n = (await rr(t)).clone();
  return ul(n, e), ks(t) && Al(n, new hl(l)), n.data.esriWebStyleName = t, n;
}
function or(t) {
  const e = t?.data?.esriWebStyleName;
  if (t?.type !== "cim" || !e)
    return null;
  const l = Nl(t), r = Sl(t);
  return {
    name: e,
    size: l ?? 16,
    color: r ? [r.r, r.g, r.b, r.a] : [0, 0, 0, 1]
  };
}
const mr = ({ symbol: t, size: e = 24 }) => {
  const l = X(null), [r, n] = H(!1);
  return F(() => {
    const o = l.current;
    if (!o)
      return;
    const y = new IntersectionObserver(
      (d) => {
        d[0]?.isIntersecting && (n(!0), y.disconnect());
      },
      { rootMargin: "100px" }
    );
    return y.observe(o), () => y.disconnect();
  }, []), F(() => {
    if (!r)
      return;
    const o = l.current;
    if (!o)
      return;
    let y = !1;
    return o.innerHTML = "", (t.type === "web-style" && t.styleUrl && t.name ? Ms(t.styleUrl, t.name) : Promise.resolve(t)).then((b) => vl(b, { size: e })).then((b) => {
      !y && b && o.appendChild(b);
    }).catch((b) => {
      console.error("Kunne ikke forhåndsvise symbol:", b);
    }), () => {
      y = !0;
    };
  }, [r, t, e]), /* @__PURE__ */ c.jsx(
    "div",
    {
      ref: l,
      style: {
        width: e,
        height: e,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }
  );
}, ir = "ShapePicker-module__fields___-LJ5Q", br = "ShapePicker-module__hint___VHJLO", Ot = {
  fields: ir,
  hint: br
}, fa = "simple", dr = "Sirkel", yr = er.map((t) => ({ value: t, label: t })), Cs = [
  { name: fa, label: dr, category: Qn },
  ...Es
];
function gr(t) {
  return t.name === fa ? new _l({
    color: [0, 0, 0, 1],
    size: 16,
    outline: { color: [255, 255, 255, 0.8], width: 1 }
  }) : new wl({ name: t.webStyle.symbolName, styleUrl: t.webStyle.styleUrl });
}
const fr = new Map(Cs.map((t) => [t.name, gr(t)])), pr = ({ value: t, onChange: e }) => {
  const [l, r] = H(""), n = Ut(() => l ? Cs.filter((o) => o.category === l).map(({ name: o, label: y }) => ({ value: o, label: y })) : [], [l]);
  return /* @__PURE__ */ c.jsxs("div", { className: Ot.fields, children: [
    /* @__PURE__ */ c.jsx("p", { className: Ot.hint, children: "Velg kategori for å endre symbol" }),
    /* @__PURE__ */ c.jsx(
      ja,
      {
        label: "Kategori",
        hideLabel: !0,
        value: l,
        placeholder: "Velg kategori",
        onChange: (o) => r(o.target.value),
        options: yr
      }
    ),
    l && /* @__PURE__ */ c.jsx(
      cl,
      {
        label: "Symbol",
        hideLabel: !0,
        placeholder: "Søk symbol (f.eks. skole, sirkel, kryss…)",
        value: [t],
        onChange: (o) => {
          o[0] && e(o[0]);
        },
        options: n,
        optionsLayout: "grid",
        renderOption: (o) => /* @__PURE__ */ c.jsx("span", { title: o.label, children: /* @__PURE__ */ c.jsx(mr, { symbol: fr.get(o.value), size: 32 }) })
      }
    )
  ] });
}, hr = ({ sketchVM: t, initialSymbol: e, onSymbolChange: l }) => {
  const r = t, [n, o] = H(() => {
    const g = e ?? r.pointSymbol, h = or(g);
    return h ? {
      shape: h.name,
      color: pa(h.color),
      transparency: ha(h.color),
      size: h.size
    } : {
      shape: fa,
      color: pa(g?.color),
      transparency: ha(g?.color),
      size: g?.size ?? 8
    };
  });
  function y(g) {
    o((h) => ({ ...h, ...g }));
  }
  const d = X(0), b = X(n);
  F(() => {
    const g = b.current, h = g.shape !== n.shape || g.color !== n.color || g.transparency !== n.transparency || g.size !== n.size;
    if (b.current = n, !h)
      return;
    let p = !1;
    function N(u) {
      p || (l ? l(u) : r.pointSymbol = u);
    }
    if (n.shape === fa)
      return N({
        type: "simple-marker",
        color: ua(n.color, n.transparency),
        size: n.size,
        outline: { color: [255, 255, 255, 0.8], width: 1 }
      }), () => {
        p = !0;
      };
    const E = ++d.current;
    return cr(n.shape, n.size, ua(n.color, n.transparency)).then((u) => {
      d.current === E && N(u);
    }).catch((u) => console.error("Kunne ikke bygge punktsymbol for", n.shape, u)), () => {
      p = !0;
    };
  }, [n.shape, n.color, n.transparency, n.size]);
  const i = n.shape === fa || ks(n.shape);
  return /* @__PURE__ */ c.jsxs("div", { className: fe.settings, children: [
    /* @__PURE__ */ c.jsx(pr, { value: n.shape, onChange: (g) => y({ shape: g }) }),
    i && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(
        Ca,
        {
          label: "Farge",
          value: n.color,
          onChange: (g) => y({ color: g })
        }
      ),
      /* @__PURE__ */ c.jsx(
        Ta,
        {
          label: "Gjennomsiktighet",
          value: n.transparency,
          min: 0,
          max: 100,
          step: 1,
          unit: "%",
          onChange: (g) => y({ transparency: g })
        }
      )
    ] }),
    /* @__PURE__ */ c.jsx(
      Ta,
      {
        label: "Størrelse",
        value: n.size,
        min: 2,
        max: 40,
        step: 1,
        unit: "px",
        onChange: (g) => y({ size: g })
      }
    )
  ] });
}, ur = ({ sketchVM: t, geometryType: e, selectedGraphic: l, initialSymbol: r, onSymbolChange: n }) => {
  const o = String(l?.uid ?? "");
  return e === "polyline" ? /* @__PURE__ */ c.jsx(Jn, { sketchVM: t, initialSymbol: r, onSymbolChange: n }, o) : e === "polygon" ? /* @__PURE__ */ c.jsx(Xn, { sketchVM: t, initialSymbol: r, onSymbolChange: n }, o) : e === "point" ? /* @__PURE__ */ c.jsx(hr, { sketchVM: t, initialSymbol: r, onSymbolChange: n }, o) : null;
}, Ar = "MeasurementSettings-module__settings___pm2BB", Nr = "MeasurementSettings-module__sectionHeading___4pQXh", Sr = "MeasurementSettings-module__blockContent___ed2tu", Ur = "MeasurementSettings-module__sliderRow___6ZKgg", wr = "MeasurementSettings-module__slider___iF-xF", _r = "MeasurementSettings-module__numberInput___0YlJh", ot = {
  settings: Ar,
  sectionHeading: Nr,
  blockContent: Sr,
  sliderRow: Ur,
  slider: wr,
  numberInput: _r
}, vr = ({ options: t, onChange: e, geometryType: l, selectedGraphic: r }) => {
  const [n, o] = H(t?.showOnMap ?? !0), [y, d] = H(t?.showSegmentLengths ?? !0), [b, i] = H(t?.labelStyle ?? "simple"), [g, h] = H(t?.textSize ?? "medium"), [p, N] = H(t?.precision ?? 2);
  F(() => {
    if (!r)
      return;
    const u = r.getAttribute("measurementShowOnMap"), S = r.getAttribute("measurementShowSegmentLengths"), w = r.getAttribute("measurementLabelStyle"), U = r.getAttribute("measurementTextSize"), M = r.getAttribute("measurementPrecision");
    u != null && o(u), S != null && d(S), w != null && i(w), U != null && h(U), M != null && N(M);
  }, [r]);
  const E = (u) => e(u, r ?? null);
  return /* @__PURE__ */ c.jsxs("div", { className: ot.settings, children: [
    /* @__PURE__ */ c.jsx(
      Zt,
      {
        label: "Vis mål",
        checked: n,
        onChange: (u) => {
          o(u), E({ showOnMap: u });
        }
      }
    ),
    n && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx("p", { className: ot.sectionHeading, children: "Innstillinger for mål" }),
      /* @__PURE__ */ c.jsxs("div", { className: ot.blockContent, children: [
        (l === "polyline" || l === "polygon") && /* @__PURE__ */ c.jsx(
          Zt,
          {
            label: "Vis delsegmenter / radius",
            checked: y,
            onChange: (u) => {
              d(u), E({ showSegmentLengths: u });
            }
          }
        ),
        /* @__PURE__ */ c.jsx(
          ja,
          {
            label: "Etikettstil",
            value: b,
            options: [
              { value: "simple", label: "Enkel" },
              { value: "boxed", label: "Med bakgrunn" }
            ],
            onChange: (u) => {
              const S = u.target.value;
              i(S), E({ labelStyle: S });
            }
          }
        ),
        /* @__PURE__ */ c.jsx(
          ol,
          {
            label: "Tekststørrelse",
            value: g,
            options: [
              { value: "small", label: "Liten" },
              { value: "medium", label: "Medium" },
              { value: "large", label: "Stor" }
            ],
            onChange: (u) => {
              h(u), E({ textSize: u });
            }
          }
        ),
        /* @__PURE__ */ c.jsx(
          vt,
          {
            label: "Desimaler",
            min: 0,
            max: 6,
            step: 1,
            value: p,
            onChange: (u) => {
              const S = parseInt(u.target.value);
              N(S), E({ precision: S });
            }
          }
        )
      ] })
    ] })
  ] });
}, Lr = "DrawingCustomSettings-module__container___RFOhU", Er = "DrawingCustomSettings-module__section___N7kaX", xr = {
  container: Lr,
  section: Er
}, kr = ({
  sketchVM: t,
  measurementOptions: e,
  onMeasurementOptionsChange: l,
  onGeometryTypeChange: r,
  onSymbolChange: n,
  measurementManager: o,
  graphic: y
}) => {
  const [d, b] = H(null), i = (M) => {
    b(M), r?.(M);
  }, [g, h] = H(void 0), p = X([]), N = (M) => {
    if (M.length === 0)
      return null;
    const q = M[0]?.geometry?.type;
    return q ? M.every((te) => te.geometry?.type === q) ? q : "multiple" : null;
  }, E = (M) => M.includes("point") ? "point" : M.includes("polyline") ? "polyline" : M.includes("polygon") || M.includes("rectangle") || M.includes("circle") ? "polygon" : M.includes("text") ? "text" : null;
  if (F(() => {
    if (!t || y)
      return;
    if (t.activeTool) {
      const _ = E(t.activeTool);
      _ && i(_);
    }
    const M = je.watch(() => t.polygonSymbol, (_) => {
      p.current.forEach((T) => {
        T.geometry?.type === "polygon" && (T.symbol = _);
      });
    }), q = je.watch(() => t.pointSymbol, (_) => {
      p.current.forEach((T) => {
        T.geometry?.type === "point" && T.symbol?.type !== "text" && (T.symbol = _);
      });
    }), te = je.watch(() => t.polylineSymbol, (_) => {
      p.current.forEach((T) => {
        T.geometry?.type === "polyline" && (T.symbol = _);
      });
    }), oe = je.watch(() => t.textSymbol, (_) => {
      p.current.forEach((T) => {
        T.geometry?.type === "point" && T.symbol?.type === "text" && (T.symbol = _);
      });
    }), se = je.watch(() => t.activeTool, (_) => {
      if (_) {
        const T = E(_);
        T && i(T);
      }
    }), ee = t.on("create", (_) => {
      _.graphic && (p.current = [_.graphic], h(_.graphic), o?.updateMeasurement(_.graphic)), _.state === "start" && i(E(t.activeTool ?? "")), _.state === "complete" && _.graphic && t.update([_.graphic]), _.state === "cancel" && (o?.removeMeasurement(_.graphic), p.current = [], h(void 0), i(null));
    }), O = t.on("delete", (_) => {
      _.graphics?.forEach((T) => o?.removeMeasurement(T)), p.current = [], h(void 0), i(null);
    }), Q = t.on("update", (_) => {
      p.current = _.graphics || [];
      const T = p.current[0], j = N(p.current);
      if (i(j), h(T), j && T?.symbol)
        switch (j) {
          case "point":
            t.pointSymbol = T.symbol;
            break;
          case "polyline":
            t.polylineSymbol = T.symbol;
            break;
          case "polygon":
            t.polygonSymbol = T.symbol;
            break;
          case "text":
            t.textSymbol = T.symbol;
            break;
        }
      _.graphics?.forEach(($) => o?.updateMeasurement($)), _.state === "complete" && (p.current = [], h(void 0), i(null));
    });
    return () => {
      M.remove(), q.remove(), te.remove(), oe.remove(), se.remove(), ee.remove(), O.remove(), Q.remove();
    };
  }, [t, o]), !t)
    return null;
  const u = y ? y.geometry?.type ?? null : d, S = y ?? g, w = S ? {
    showOnMap: S.getAttribute("measurementShowOnMap") ?? (u === "point" ? !1 : e?.showOnMap),
    showLabels: S.getAttribute("measurementShowLabels") ?? e?.showLabels,
    unit: S.getAttribute("measurementUnit") ?? e?.unit,
    precision: S.getAttribute("measurementPrecision") ?? e?.precision,
    labelStyle: S.getAttribute("measurementLabelStyle") ?? e?.labelStyle,
    showSegmentLengths: S.getAttribute("measurementShowSegmentLengths") ?? e?.showSegmentLengths,
    textSize: S.getAttribute("measurementTextSize") ?? e?.textSize
  } : e, U = (M, q) => {
    y ? l?.(M, y) : p.current.length > 0 ? p.current.forEach(
      (te) => l?.(M, te)
    ) : l?.(M, q ?? null);
  };
  return /* @__PURE__ */ c.jsx("div", { className: xr.container, children: u !== null && u !== "multiple" && u !== "text" && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      ur,
      {
        sketchVM: t,
        geometryType: u,
        selectedGraphic: S,
        initialSymbol: y ? y.symbol : void 0,
        onSymbolChange: y ? n ?? ((M) => {
          y.symbol = M;
        }) : void 0
      }
    ),
    /* @__PURE__ */ c.jsx(
      vr,
      {
        options: w,
        onChange: U,
        geometryType: u,
        selectedGraphic: S
      }
    )
  ] }) });
}, Mr = {
  point: "Punkt",
  polyline: "Linje",
  polygon: "Polygon",
  rectangle: "Rektangel",
  circle: "Sirkel",
  text: "Tekst"
}, Mt = class We {
  // Private constructor to prevent direct construction calls with the `new` operator
  constructor() {
    this.measurementLayer = null, this.graphicToLabelMap = /* @__PURE__ */ new Map(), this.graphicIdCounter = 0;
  }
  /**
   * Get the singleton instance
   */
  static getInstance() {
    return We.instance || (We.instance = new We()), We.instance;
  }
  /**
   * Initialize the MeasurementManager with a view
   */
  init(e) {
    const l = "measurements-graphics-layer", r = e.map;
    if (!r) {
      console.warn("MeasurementManager.init: view.map is not available");
      return;
    }
    const n = r.findLayerById(l);
    n ? this.measurementLayer = n : (this.measurementLayer = new ht({
      id: l,
      title: "Measurements",
      listMode: "hide"
    }), r.add(this.measurementLayer));
  }
  // Generer en unik ID for grafikk
  getGraphicId(e) {
    const l = e.getAttribute("id") || e.getAttribute("objectid");
    if (l)
      return l.toString();
    const r = `graphic-${this.graphicIdCounter++}`;
    return e.setAttribute("id", r), r;
  }
  // Hent målsettingsinnstillinger for en spesifikk grafikk
  getGraphicMeasurementOptions(e) {
    const l = { ...We.DEFAULT_OPTIONS };
    return e.geometry?.type === "point" && (l.showOnMap = !1), e.attributes && "measurementShowLabels" in e.attributes && (l.showLabels = e.getAttribute("measurementShowLabels")), e.attributes && "measurementShowOnMap" in e.attributes && (l.showOnMap = e.getAttribute("measurementShowOnMap")), e.attributes && "measurementUnit" in e.attributes && (l.unit = e.getAttribute("measurementUnit")), e.attributes && "measurementPrecision" in e.attributes && (l.precision = e.getAttribute("measurementPrecision")), e.attributes && "measurementLabelStyle" in e.attributes && (l.labelStyle = e.getAttribute("measurementLabelStyle")), e.attributes && "measurementShowSegmentLengths" in e.attributes && (l.showSegmentLengths = e.getAttribute("measurementShowSegmentLengths")), e.attributes && "measurementTextSize" in e.attributes && (l.textSize = e.getAttribute("measurementTextSize")), l.unit = "metric", l;
  }
  // Lagre målsettingsinnstillinger på en grafikk
  setGraphicMeasurementOptions(e, l) {
    l.showLabels !== void 0 && e.setAttribute("measurementShowLabels", l.showLabels), l.showOnMap !== void 0 && e.setAttribute("measurementShowOnMap", l.showOnMap), l.unit !== void 0 && e.setAttribute("measurementUnit", l.unit), l.precision !== void 0 && e.setAttribute("measurementPrecision", l.precision), l.labelStyle !== void 0 && e.setAttribute("measurementLabelStyle", l.labelStyle), l.showSegmentLengths !== void 0 && e.setAttribute("measurementShowSegmentLengths", l.showSegmentLengths), l.textSize !== void 0 && e.setAttribute("measurementTextSize", l.textSize), this.updateMeasurement(e);
  }
  // Hovedmetode for å legge til/oppdatere målsetting
  updateMeasurement(e) {
    if (this.removeMeasurement(e), !e.geometry)
      return;
    const l = this.getGraphicMeasurementOptions(e), r = this.calculateMeasurement(e.geometry, l);
    r && (e.setAttribute("measurement", r.formatted), e.setAttribute("measurementValue", r.value), l.showOnMap && l.showLabels && (this.addLabelMeasurement(e, r, l), (e.geometry.type === "polyline" || e.geometry.type === "polygon") && l.showSegmentLengths && this.addSegmentMeasurements(e, l)));
  }
  // Fjern målsetting for en grafikk
  removeMeasurement(e) {
    if (!this.measurementLayer)
      return;
    const l = this.getGraphicId(e);
    this.graphicToLabelMap.has(l) && (this.graphicToLabelMap.get(l).forEach((y) => {
      this.measurementLayer && this.measurementLayer.remove(y);
    }), this.graphicToLabelMap.delete(l));
    const n = this.measurementLayer.graphics.toArray().filter(
      (o) => o.attributes && o.attributes.parentGraphicId === l && o.attributes.isMeasurementLabel
    );
    for (const o of n)
      this.measurementLayer.remove(o);
  }
  // Beregn målsetting basert på geometri
  calculateMeasurement(e, l) {
    if (!e)
      return null;
    let r = null;
    try {
      switch (e.type) {
        case "point": {
          const n = e;
          r = {
            value: n.z || 0,
            formatted: n.z ? `Z: ${this.formatValue(n.z, "m", l.precision)}` : `(${this.formatValue(n.x, "", l.precision)}, ${this.formatValue(n.y, "", l.precision)})`
          };
          break;
        }
        case "polyline": {
          try {
            let n;
            n = Rt.execute(e, { unit: "meters" }), r = {
              value: n,
              formatted: this.formatLength(n, l.precision)
            };
          } catch (n) {
            console.error("Failed to calculate polyline length", n);
            const o = e;
            let y = 0;
            if (o.paths && o.paths.length > 0)
              for (const d of o.paths)
                for (let b = 1; b < d.length; b++) {
                  const i = d[b][0] - d[b - 1][0], g = d[b][1] - d[b - 1][1];
                  y += Math.sqrt(i * i + g * g);
                }
            r = {
              value: y,
              formatted: this.formatLength(y, l.precision)
            };
          }
          break;
        }
        case "polygon": {
          try {
            let n;
            n = kl.execute(e, { unit: "square-meters" }), r = {
              value: n,
              formatted: this.formatArea(n, l.precision)
            };
          } catch (n) {
            console.error("Failed to calculate polygon area", n), r = {
              value: 0,
              formatted: this.formatArea(0, l.precision)
            };
          }
          break;
        }
        default:
          r = null;
      }
    } catch (n) {
      console.error("Error in calculateMeasurement", n), r = {
        value: 0,
        formatted: "Beregning feilet"
      };
    }
    return r;
  }
  // Formater lengde med riktig enhet (alltid metrisk)
  formatLength(e, l) {
    return e < 1e3 ? `${this.formatValue(e, "m", l)}` : `${this.formatValue(e / 1e3, "km", l)}`;
  }
  // Formater areal med riktig enhet (alltid metrisk)
  formatArea(e, l) {
    return e < 1e4 ? `${this.formatValue(e, "m²", l)}` : `${this.formatValue(e / 1e4, "ha", l)}`;
  }
  // Formater tall med angitt presisjon
  formatValue(e, l, r) {
    return `${e.toFixed(r)} ${l}`;
  }
  // Finn posisjon for label basert på geometri (alltid senter/midtpunkt)
  getLabelPosition(e) {
    if (!e)
      return null;
    let l = null;
    switch (e.type) {
      case "point": {
        l = e;
        break;
      }
      case "polyline": {
        const r = e;
        r.extent && (l = r.extent.center);
        break;
      }
      case "polygon": {
        const r = e, n = Ml.execute(r);
        n ? l = n : r.extent && (l = r.extent.center);
        break;
      }
      default:
        e.extent && e.extent.center && (l = e.extent.center);
    }
    return l;
  }
  // Get font size based on text size option
  getFontSize(e, l = !1) {
    const r = {
      small: 10,
      medium: 12,
      large: 16
    };
    return l ? r[e] - 2 : r[e];
  }
  // Legg til tekstlabel for målsetting
  addLabelMeasurement(e, l, r) {
    if (!e.geometry)
      return;
    const n = this.getLabelPosition(e.geometry);
    if (!n)
      return;
    const o = this.getFontSize(r.textSize);
    let y;
    switch (r.labelStyle) {
      case "boxed": {
        y = {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: l.formatted,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          },
          backgroundColor: [255, 255, 255, 0.7],
          borderLineColor: [0, 0, 0, 0.5],
          borderLineSize: 1,
          yoffset: 3
        };
        break;
      }
      default: {
        y = {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: l.formatted,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          }
        };
        break;
      }
    }
    const d = this.getGraphicId(e), b = new lt({
      geometry: n,
      symbol: y,
      attributes: {
        parentGraphicId: d,
        isMeasurementLabel: !0,
        type: "main-measurement"
      }
    });
    this.measurementLayer && this.measurementLayer.add(b);
    const i = this.getGraphicId(e);
    this.graphicToLabelMap.has(i) || this.graphicToLabelMap.set(i, []), this.graphicToLabelMap.get(i).push(b);
  }
  // Create a text symbol for segment measurements
  createSegmentTextSymbol(e, l, r, n = !0) {
    const o = this.getFontSize(r.textSize, n);
    switch (r.labelStyle) {
      case "boxed":
        return {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: e,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          },
          backgroundColor: [255, 255, 255, 0.7],
          borderLineColor: [0, 0, 0, 0.5],
          borderLineSize: 1,
          yoffset: 3,
          angle: l
        };
      default:
        return {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: e,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          },
          angle: l
        };
    }
  }
  // Calculate segment length and create label
  createSegmentLabel(e, l, r, n) {
    const o = new Cl({
      paths: [[[e[0], e[1]], [l[0], l[1]]]],
      spatialReference: r
    }), y = Rt.execute(o, { unit: "meters" }), d = this.formatLength(y, n.precision), b = (e[0] + l[0]) / 2, i = (e[1] + l[1]) / 2, g = new Ea({
      x: b,
      y: i,
      spatialReference: r
    }), h = l[0] - e[0], p = l[1] - e[1];
    let N = -Math.atan2(p, h) * 180 / Math.PI;
    N < -90 ? N += 180 : N > 90 && (N -= 180);
    const E = this.createSegmentTextSymbol(d, N, n);
    return new lt({
      geometry: g,
      symbol: E,
      attributes: {
        // parentGraphicId will be set when added to the layer
        parentGraphicId: null,
        isMeasurementLabel: !0,
        type: "segment-measurement"
      }
    });
  }
  // Check if a polygon is approximately a circle
  isCircle(e) {
    if (!e)
      return { isCircle: !1 };
    if (!e.rings || e.rings.length !== 1)
      return { isCircle: !1 };
    const l = e.rings[0];
    if (l.length < 8)
      return { isCircle: !1 };
    let r = 0, n = 0;
    for (let p = 0; p < l.length - 1; p++)
      r += l[p][0], n += l[p][1];
    const o = r / (l.length - 1), y = n / (l.length - 1);
    let d = 0, b = [];
    for (let p = 0; p < l.length - 1; p++) {
      const N = l[p][0] - o, E = l[p][1] - y, u = Math.sqrt(N * N + E * E);
      b.push(u), d += u;
    }
    const i = d / (l.length - 1), g = 0.05;
    for (const p of b)
      if (Math.abs(p - i) / i > g)
        return { isCircle: !1 };
    return {
      isCircle: !0,
      center: new Ea({
        x: o,
        y,
        spatialReference: e.spatialReference
      }),
      radius: i
    };
  }
  // Add measurements for individual segments of polylines or polygon perimeters
  addSegmentMeasurements(e, l) {
    if (!e.geometry)
      return;
    const r = e.geometry, n = [];
    if (r.type === "polyline") {
      const o = r;
      if (o.paths && o.paths.length > 0)
        for (const y of o.paths)
          for (let d = 1; d < y.length; d++) {
            const b = this.createSegmentLabel(
              y[d - 1],
              y[d],
              o.spatialReference,
              l
            );
            if (b && this.measurementLayer) {
              const i = this.getGraphicId(e);
              b.attributes ? b.attributes.parentGraphicId = i : b.attributes = {
                parentGraphicId: i,
                isMeasurementLabel: !0,
                type: "segment-measurement"
              }, this.measurementLayer.add(b), n.push(b);
            }
          }
    } else if (r.type === "polygon") {
      const o = r, y = this.isCircle(o);
      if (y.isCircle && y.center && y.radius) {
        const b = `R: ${this.formatLength(y.radius, l.precision)}`, i = y.radius * 0.3, g = new Ea({
          x: y.center.x,
          y: y.center.y - i,
          // Move down (south) by subtracting from Y
          spatialReference: o.spatialReference
        }), h = this.createSegmentTextSymbol(b, 0, l), p = this.getGraphicId(e), N = new lt({
          geometry: g,
          symbol: h,
          attributes: {
            parentGraphicId: p,
            isMeasurementLabel: !0,
            type: "radius-measurement"
          }
        });
        this.measurementLayer && (this.measurementLayer.add(N), n.push(N));
      } else if (o.rings && o.rings.length > 0)
        for (const d of o.rings) {
          for (let b = 1; b < d.length - 1; b++) {
            const i = this.createSegmentLabel(
              d[b - 1],
              d[b],
              o.spatialReference,
              l
            );
            if (i && this.measurementLayer) {
              const g = this.getGraphicId(e);
              i.attributes ? i.attributes.parentGraphicId = g : i.attributes = {
                parentGraphicId: g,
                isMeasurementLabel: !0,
                type: "polygon-segment-measurement"
              }, this.measurementLayer.add(i), n.push(i);
            }
          }
          if (d.length >= 3) {
            const b = d.length - 2, i = this.createSegmentLabel(
              d[b],
              d[0],
              o.spatialReference,
              l
            );
            if (i && this.measurementLayer) {
              const g = this.getGraphicId(e);
              i.attributes ? i.attributes.parentGraphicId = g : i.attributes = {
                parentGraphicId: g,
                isMeasurementLabel: !0,
                type: "polygon-closing-segment-measurement"
              }, this.measurementLayer.add(i), n.push(i);
            }
          }
        }
    }
    if (n.length > 0) {
      const o = this.getGraphicId(e);
      this.graphicToLabelMap.has(o) || this.graphicToLabelMap.set(o, []), this.graphicToLabelMap.get(o).push(...n);
    }
  }
  // Clear all measurements without destroying the layer
  clearAllMeasurements() {
    if (!this.measurementLayer)
      return;
    const l = this.measurementLayer.graphics.toArray().filter(
      (r) => r.attributes && r.attributes.isMeasurementLabel
    );
    for (const r of l)
      this.measurementLayer.remove(r);
    this.graphicToLabelMap.clear();
  }
  // No need to destroy the singleton, but provide a method to reset if needed
  reset() {
    this.graphicToLabelMap.clear();
  }
};
Mt.instance = null;
Mt.DEFAULT_OPTIONS = {
  showLabels: !0,
  showOnMap: !0,
  unit: "metric",
  precision: 2,
  labelStyle: "simple",
  showSegmentLengths: !0,
  textSize: "medium"
};
let Cr = Mt;
const Ft = "drawing-custom-graphics-layer", $t = "drawing-custom-selection-layer";
function Hr(t, e) {
  return t.graphics.filter((l) => !!l.geometry && Ll.execute(e, l.geometry)).toArray();
}
function ke(t, e, l) {
  t.has(e) || t.set(e, []), t.get(e).push(l);
}
function Tr(t) {
  const e = X(null), l = X(null), r = X(null), n = X(null), o = X(null), y = X("point"), d = X(null), b = X(/* @__PURE__ */ new Map()), i = X(/* @__PURE__ */ new Map()), g = X(/* @__PURE__ */ new Map()), h = X(/* @__PURE__ */ new Map()), p = X(!1), N = X(null), [E, u] = H(null), [S, w] = H(null), [U, M] = H(null), [q, te] = H(!0), [oe, se] = H(0), [ee, O] = H(0), [Q, _] = H([]), [T, j] = H(!1), [$, ne] = H(!1), [G, B] = H(0), [me, ye] = H(0), [we, Me] = H(null), C = le(() => {
    const L = d.current ? d.current.uid : null, D = L ? (b.current.get(L)?.length ?? 0) > 0 || g.current.has(L) : !1, Y = L ? (i.current.get(L)?.length ?? 0) > 0 : !1;
    j(D), ne(Y);
  }, []);
  F(() => {
    const L = t?.map;
    if (!t || !L || !t.container)
      return;
    let D = !1;
    const Y = [];
    let z = L.findLayerById(Ft);
    z || (z = new ht({ id: Ft, listMode: "hide" }), L.add(z)), e.current = z;
    const W = z.graphics.toArray();
    W.length > 0 && (_(W.map((V) => ({
      graphic: V,
      toolType: V.__toolType ?? V.geometry?.type ?? "point"
    }))), O(W.length));
    let re = L.findLayerById($t);
    re || (re = new ht({ id: $t, listMode: "hide" }), L.add(re)), l.current = re;
    const pe = (V) => {
      if (V.state !== "complete")
        return;
      V.graphic.__toolType = y.current, o.current?.updateMeasurement(V.graphic), O((I) => I + 1), _((I) => [...I, { graphic: V.graphic, toolType: y.current }]);
      const be = V.graphic.uid;
      ke(b.current, be, { kind: "geometry" }), i.current.set(be, []), C();
    }, he = (V) => {
      V.graphics?.forEach((I) => o.current?.updateMeasurement(I)), ye((I) => I + 1);
      const be = V.state === "complete" ? 0 : V.graphics?.length ?? 0;
      if (se(be), V.state === "start") {
        const I = V.graphics?.length === 1 ? V.graphics[0] : null;
        d.current = I, Me(I ? I.uid : null), p.current = !1, N.current = I?.geometry ? I.geometry.clone() : null;
      } else if (V.state === "active") {
        if (!p.current && V.graphics?.length === 1) {
          const I = V.graphics[0].uid, Ne = N.current ?? void 0;
          ke(b.current, I, { kind: "geometry", geometry: Ne }), i.current.set(I, []), p.current = !0;
        }
      } else if (V.state === "complete") {
        if (!p.current && V.graphics?.length === 1) {
          const I = V.graphics[0].uid, Ne = N.current ?? void 0;
          ke(b.current, I, { kind: "geometry", geometry: Ne }), i.current.set(I, []);
        }
        p.current = !1, N.current = null, Me(null);
      }
      C();
    }, Je = (V) => {
      V.graphics?.forEach((I) => o.current?.removeMeasurement(I)), se(0), O((I) => Math.max(0, I - (V.graphics?.length ?? 0)));
      const be = new Set(V.graphics ?? []);
      _((I) => I.filter((Ne) => !be.has(Ne.graphic)));
    };
    return t.when(() => {
      if (D)
        return;
      const V = new jt({
        layer: z,
        view: t,
        defaultCreateOptions: { mode: "hybrid" },
        pointSymbol: {
          type: "simple-marker",
          color: [255, 0, 0],
          size: 8,
          outline: { color: [255, 255, 255, 0.8], width: 1 }
        },
        snappingOptions: {
          enabled: !0,
          selfEnabled: !0,
          featureEnabled: !0,
          distance: 10,
          featureSources: L.allLayers.filter((I) => I.type === "feature" || I.type === "graphics").map((I) => new xl({ layer: I, enabled: !0 })).toArray()
        },
        tooltipOptions: { enabled: !0 }
      }), be = new jt({ layer: re, view: t });
      r.current = V, n.current = be, u(V), Y.push(
        je.watch(() => V.activeTool, (I) => {
          w(I ?? null), I && M(null);
        }),
        V.on("create", pe),
        V.on("update", he),
        V.on("undo", C),
        V.on("redo", C),
        V.on("delete", Je),
        be.on("create", (I) => {
          const Ne = I.graphic?.geometry;
          if (I.state !== "complete" || !Ne)
            return;
          const Ve = Hr(z, Ne);
          re.removeAll(), Ve.length > 0 && V.update(Ve);
        })
      ), o.current = Cr.getInstance(), o.current.init(t);
    }), () => {
      D = !0, Y.forEach((V) => V.remove()), r.current?.destroy(), r.current = null, n.current?.destroy(), n.current = null;
    };
  }, [t, C]);
  const de = le((L) => {
    if (n.current?.cancel(), M(null), S === L) {
      r.current?.cancel();
      return;
    }
    y.current = L, r.current?.create(L);
  }, [S]), He = le((L) => {
    if (r.current?.cancel(), n.current?.cancel(), l.current?.removeAll(), U === L) {
      M(null);
      return;
    }
    M(L), L === "rectangle" ? n.current?.create("rectangle") : L === "lasso" && n.current?.create("polygon", { mode: "freehand" });
  }, [U]), Re = le(() => {
    const L = r.current;
    if (!L)
      return;
    const D = !L.snappingOptions.enabled;
    L.snappingOptions = new El({
      enabled: D,
      selfEnabled: !0,
      featureEnabled: !0,
      distance: 10,
      featureSources: L.snappingOptions.featureSources
    }), te(D);
  }, []), _e = le(() => r.current?.delete(), []), ve = le(() => {
    const L = d.current;
    if (!L)
      return;
    const D = L.uid, Y = r.current, z = g.current.get(D);
    if (z !== void 0) {
      clearTimeout(h.current.get(D)), h.current.delete(D), g.current.delete(D), L.symbol && ke(i.current, D, { kind: "symbol", symbol: L.symbol.clone() }), L.symbol = z, B((re) => re + 1), C();
      return;
    }
    const W = b.current.get(D);
    for (; W?.length; ) {
      const re = W[W.length - 1];
      if (re.kind === "symbol") {
        W.pop(), L.symbol && ke(i.current, D, { kind: "symbol", symbol: L.symbol.clone() }), L.symbol = re.symbol, B((pe) => pe + 1);
        break;
      }
      if (re.geometry) {
        W.pop();
        const pe = L.geometry ? L.geometry.clone() : void 0;
        ke(i.current, D, { kind: "geometry", geometry: pe }), L.geometry = re.geometry, ye((he) => he + 1), o.current?.updateMeasurement(L);
        break;
      }
      if (Y?.canUndo()) {
        Y.undo(), Y.canUndo() || (W.pop(), ke(i.current, D, { kind: "geometry" }));
        break;
      }
      W.pop();
    }
    C();
  }, [C]), Le = le(() => {
    const L = d.current;
    if (!L)
      return;
    const D = L.uid, Y = r.current, z = i.current.get(D);
    for (; z?.length; ) {
      const W = z[z.length - 1];
      if (W.kind === "symbol") {
        z.pop(), L.symbol && ke(b.current, D, { kind: "symbol", symbol: L.symbol.clone() }), L.symbol = W.symbol, B((re) => re + 1);
        break;
      }
      if (W.geometry) {
        z.pop();
        const re = L.geometry ? L.geometry.clone() : void 0;
        ke(b.current, D, { kind: "geometry", geometry: re }), L.geometry = W.geometry, ye((pe) => pe + 1), o.current?.updateMeasurement(L);
        break;
      }
      if (Y?.canRedo()) {
        Y.redo(), Y.canRedo() || (z.pop(), ke(b.current, D, { kind: "geometry" }));
        break;
      }
      z.pop();
    }
    C();
  }, [C]), Te = le((L, D) => {
    const Y = L.uid;
    !g.current.has(Y) && L.symbol && g.current.set(Y, L.symbol.clone()), clearTimeout(h.current.get(Y));
    const z = setTimeout(() => {
      const W = g.current.get(Y);
      W && (ke(b.current, Y, { kind: "symbol", symbol: W }), g.current.delete(Y), h.current.delete(Y), C());
    }, 500);
    h.current.set(Y, z), i.current.set(Y, []), L.symbol = D, C();
  }, [C]), Ee = le((L) => {
    const D = L.uid;
    clearTimeout(h.current.get(D)), g.current.delete(D), h.current.delete(D), b.current.delete(D), i.current.delete(D), d.current === L && (d.current = null), r.current?.cancel(), n.current?.cancel(), l.current?.removeAll(), o.current?.removeMeasurement(L), e.current?.remove(L), se(0), O((Y) => Math.max(0, Y - 1)), _((Y) => Y.filter((z) => z.graphic !== L)), C();
  }, [C]), Ye = le((L) => {
    d.current = L, n.current?.cancel(), l.current?.removeAll(), L ? r.current?.update([L]) : r.current?.cancel(), C();
  }, [C]);
  return {
    sketchVM: E,
    measurementManager: o.current,
    activeTool: S,
    selectMode: U,
    snappingEnabled: q,
    selectionCount: oe,
    graphicCount: ee,
    drawings: Q,
    canUndo: T,
    canRedo: $,
    symbolRevision: G,
    geometryRevision: me,
    selectedGraphicUid: we,
    handleCreate: de,
    handleSelect: He,
    handleToggleSnapping: Re,
    handleUndo: ve,
    handleRedo: Le,
    handleSymbolChange: Te,
    handleDelete: _e,
    handleDeleteGraphic: Ee,
    handleActivateDrawing: Ye
  };
}
const Zr = "DrawingCustom-module__root___C3yS5", jr = "DrawingCustom-module__drawingNotice___o1Ho6", Rr = "DrawingCustom-module__drawingHistoryActions___nXng9", Vr = "DrawingCustom-module__measurementLabel___HwBOC", xa = {
  root: Zr,
  drawingNotice: jr,
  drawingHistoryActions: Rr,
  measurementLabel: Vr
}, Pr = {
  showLabels: !0,
  showOnMap: !0,
  unit: "metric",
  precision: 2,
  textSize: "medium",
  labelStyle: "simple",
  showSegmentLengths: !0
};
function Ir(t) {
  return t ? t.includes("point") ? "point" : t.includes("polyline") ? "polyline" : t.includes("polygon") || t.includes("rectangle") || t.includes("circle") ? "polygon" : t.includes("text") ? "text" : null : null;
}
function Or(t, e) {
  const l = e.filter((r) => r.toolType === t.toolType).indexOf(t) + 1;
  return `${Mr[t.toolType] ?? t.toolType} ${l}`;
}
function Fr({ geometryType: t, graphicCount: e }) {
  let l;
  return t !== null ? l = "Velg objekter av samme type for å endre symboler" : l = "Velg et verktøy ovenfor. Du kan tegne opp flere objekter.", /* @__PURE__ */ c.jsx(es, { variant: "info", icon: /* @__PURE__ */ c.jsx(Ra, { size: 20, weight: "regular" }), className: xa.drawingNotice, children: /* @__PURE__ */ c.jsx("p", { children: l }) });
}
const Ti = () => {
  const { mapView: t } = Fe(), { setDisableMapClick: e } = sl();
  F(() => (e(!0), () => {
    e(!1);
  }), []);
  const {
    sketchVM: l,
    measurementManager: r,
    activeTool: n,
    selectMode: o,
    snappingEnabled: y,
    selectionCount: d,
    graphicCount: b,
    drawings: i,
    handleCreate: g,
    handleSelect: h,
    handleToggleSnapping: p,
    canUndo: N,
    canRedo: E,
    symbolRevision: u,
    geometryRevision: S,
    selectedGraphicUid: w,
    handleUndo: U,
    handleRedo: M,
    handleSymbolChange: q,
    handleDelete: te,
    handleDeleteGraphic: oe,
    handleActivateDrawing: se
  } = Tr(t), ee = Ir(n), [O, Q] = H(null), [_, T] = H(0), j = X(0);
  F(() => {
    w !== null && w !== O && Q(w);
  }, [w]), Jt(() => {
    const G = i.length > j.current;
    if (j.current = i.length, i.length === 0) {
      Q(null);
      return;
    }
    const B = i[i.length - 1];
    Q(B.graphic.uid), G && se(B.graphic);
  }, [i.length]);
  const $ = (G, B) => {
    B && r && (r.setGraphicMeasurementOptions(B, G), T((me) => me + 1));
  }, ne = Ut(() => {
    const G = /* @__PURE__ */ new Map();
    for (const B of i) {
      const me = B.graphic.uid, ye = B.toolType !== "point" && B.toolType !== "text";
      G.set(me, ye ? B.graphic.getAttribute("measurement") : null);
    }
    return G;
  }, [i, _, S]);
  return /* @__PURE__ */ c.jsxs("div", { id: "drawing-custom-details", className: xa.root, children: [
    /* @__PURE__ */ c.jsx(
      $n,
      {
        activeTool: n,
        selectMode: o,
        snappingEnabled: y,
        hasDrawings: b > 0,
        selectionCount: d,
        onCreate: g,
        onSelect: h,
        onDelete: te,
        onToggleSnapping: p
      }
    ),
    /* @__PURE__ */ c.jsxs("div", { id: "drawing-custom-list", children: [
      i.length === 0 && /* @__PURE__ */ c.jsx(Fr, { geometryType: ee, graphicCount: b }),
      i.map((G) => {
        const B = G.graphic.uid;
        return /* @__PURE__ */ c.jsxs(
          Tn,
          {
            heading: Or(G, i),
            open: O === B,
            onOpenChange: (me) => {
              Q(me ? B : null), se(me ? G.graphic : null);
            },
            headerActions: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
              ne.get(B) && /* @__PURE__ */ c.jsx("span", { className: xa.measurementLabel, children: ne.get(B) }),
              /* @__PURE__ */ c.jsx(
                Qt,
                {
                  icon: /* @__PURE__ */ c.jsx(xt, { size: 16 }),
                  label: "Slett tegning",
                  size: "sm",
                  onClick: () => oe(G.graphic)
                }
              )
            ] }),
            children: [
              /* @__PURE__ */ c.jsxs(ml, { "aria-label": "Angre/gjør om", className: xa.drawingHistoryActions, children: [
                /* @__PURE__ */ c.jsx(
                  ga,
                  {
                    icon: /* @__PURE__ */ c.jsx(os, { size: 20 }),
                    label: "Angre",
                    disabled: !N,
                    onClick: U
                  }
                ),
                /* @__PURE__ */ c.jsx(
                  ga,
                  {
                    icon: /* @__PURE__ */ c.jsx(ms, { size: 20 }),
                    label: "Gjør om",
                    disabled: !E,
                    onClick: M
                  }
                )
              ] }),
              /* @__PURE__ */ c.jsx(
                kr,
                {
                  graphic: G.graphic,
                  sketchVM: l,
                  measurementOptions: Pr,
                  onMeasurementOptionsChange: $,
                  onSymbolChange: (me) => q(G.graphic, me),
                  measurementManager: r
                },
                B === O ? `${B}-${u}` : B
              )
            ]
          },
          B
        );
      })
    ] })
  ] });
}, $r = "LayerSelector-module__cardGroup___dog-Z", Dr = "LayerSelector-module__centerContainer___aSILL", Br = "LayerSelector-module__messageContainer___pyCOj", zr = "LayerSelector-module__thumbnail___DRTN9", Gr = "LayerSelector-module__cardFooter___KmyW-", Wr = "LayerSelector-module__layerVisible___bsAVM", Sa = {
  cardGroup: $r,
  centerContainer: Dr,
  messageContainer: Br,
  thumbnail: zr,
  cardFooter: Gr,
  layerVisible: Wr
}, Zi = ({
  layersGroupId: t,
  onError: e,
  fallbackThumbnail: l = "public/images/basis terreng.png"
}) => {
  const { t: r } = qe(["kartinnhold"]), { mapView: n } = Fe(), [o, y] = H([]), [d, b] = H(!0);
  F(() => {
    if (!n || !t)
      return;
    (async () => {
      try {
        b(!0);
        const h = new ts();
        await h.load();
        const N = await new ss({
          portal: h,
          id: t
        }).queryItems(), E = await Promise.all(
          N.results.map(async (u) => {
            if (!u.id || !u.title)
              throw new Error("Invalid portal item: missing id or title");
            const S = n.map?.allLayers.find(
              (w) => w.title === u.title
            );
            return {
              id: u.id,
              title: u.title,
              portalItem: u,
              layer: S,
              thumbnailUrl: u.thumbnailUrl || l
            };
          })
        );
        y(E);
      } catch (h) {
        console.error("Error loading group layers:", h), e?.(r("kartinnhold:errorLoadingLayers"));
      } finally {
        b(!1);
      }
    })();
  }, [n, t, e, l, r]);
  const i = async (g) => {
    if (n)
      try {
        y((h) => {
          const p = [...h], N = p.findIndex((E) => E.id === g);
          if (N >= 0) {
            const E = p[N];
            E.layer ? (n.map && n.map.remove(E.layer), p[N] = {
              ...E,
              layer: void 0
            }) : (y((u) => {
              const S = [...u];
              return S[N] = {
                ...S[N],
                isLoading: !0
              }, S;
            }), Hl.fromPortalItem({
              portalItem: new ls({
                id: E.id
              })
            }).then((u) => {
              if (u.blendMode = "multiply", n.map)
                n.map.add(u);
              else
                throw new Error("Map is not available");
              const S = je.watch(() => n.updating, () => {
                const w = n.allLayerViews.find((U) => U.layer === u);
                w && !w.updating && (S.remove(), y((U) => {
                  const M = [...U];
                  return M[N] = {
                    ...M[N],
                    layer: u,
                    isLoading: !1
                  }, M;
                }));
              });
            }).catch((u) => {
              console.error("Error adding layer:", u), e?.(r("kartinnhold:errorAddingLayer", { title: E.title }));
            }));
          }
          return p;
        });
      } catch (h) {
        console.error("Error managing layer:", h), e?.(r("kartinnhold:errorManagingLayer"));
      }
  };
  return d ? /* @__PURE__ */ c.jsx("div", { className: Sa.centerContainer, children: /* @__PURE__ */ c.jsx($s, { scale: "s", type: "indeterminate" }) }) : o.length === 0 ? /* @__PURE__ */ c.jsx("div", { className: Sa.messageContainer, children: r("kartinnhold:noLayers") }) : /* @__PURE__ */ c.jsx(Ds, { selectionMode: "none", children: o.map((g) => /* @__PURE__ */ c.jsxs(
    Bs,
    {
      "thumbnail-position": "block-start",
      children: [
        /* @__PURE__ */ c.jsx(
          "img",
          {
            slot: "thumbnail",
            className: Sa.thumbnail,
            src: g.thumbnailUrl,
            alt: g.title
          }
        ),
        /* @__PURE__ */ c.jsx("span", { className: Sa.cardTitle, slot: "footer-start", children: g.title }),
        /* @__PURE__ */ c.jsx(
          Xt,
          {
            scale: "s",
            slot: "footer-end",
            loading: g.isLoading,
            disabled: g.isLoading,
            icon: g.layer ? "minus-circle" : "add-layer",
            onClick: () => i(g.id)
          }
        )
      ]
    },
    g.id
  )) });
}, Kr = "MapItem-module__item___VfsvS", qr = "MapItem-module__active___wncKR", Yr = "MapItem-module__thumbnail___IweqH", Jr = "MapItem-module__card___tWfIb", Xr = "MapItem-module__title___MLNdF", Qr = "MapItem-module__image___IkGzb", ec = "MapItem-module__text___sh1cd", ac = "MapItem-module__description___XGEsY", Pe = {
  item: Kr,
  active: qr,
  thumbnail: Yr,
  card: Jr,
  title: Xr,
  image: Qr,
  text: ec,
  description: ac
};
function tc({ title: t, description: e, thumbnailUrl: l, isActive: r, onClick: n, variant: o = "list", role: y, ariaChecked: d, tabIndex: b, id: i }) {
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      id: i,
      role: y,
      "aria-checked": y === "radio" ? d : void 0,
      tabIndex: b,
      className: `${Pe.item} ${o === "card" ? Pe.card : ""} ${r ? Pe.active : ""}`,
      onClick: n,
      type: "button",
      children: [
        /* @__PURE__ */ c.jsx("div", { className: Pe.thumbnail, children: /* @__PURE__ */ c.jsx("img", { src: l, alt: "", className: Pe.image }) }),
        /* @__PURE__ */ c.jsxs("div", { className: Pe.text, children: [
          /* @__PURE__ */ c.jsx("span", { className: Pe.title, children: t }),
          e && /* @__PURE__ */ c.jsx("span", { className: Pe.description, children: e })
        ] })
      ]
    }
  );
}
const sc = "ThematicMapSelector-module__centerContainer___MgqzU", lc = "ThematicMapSelector-module__messageContainer___s34HH", nc = "ThematicMapSelector-module__gallery___dNrUU", mt = {
  centerContainer: sc,
  messageContainer: lc,
  gallery: nc
}, it = /* @__PURE__ */ new WeakMap(), ji = ({
  thematicMapsGroupId: t,
  onError: e,
  fallbackThumbnail: l = "public/images/basis terreng.png"
}) => {
  const { t: r } = qe(["kartinnhold"]), { mapView: n } = Fe(), [o, y] = H([]), [d, b] = H(!0);
  F(() => {
    if (!n || !t)
      return;
    it.has(n) || it.set(n, n.map), (async () => {
      try {
        b(!0);
        const N = new ts();
        await N.load();
        const E = new ss({
          portal: N,
          id: t
        }), u = {
          query: "type:'Web Map'",
          sortField: "title",
          sortOrder: "asc",
          num: 100
        }, w = (await E.queryItems(u)).results.map((U) => {
          if (!U.id || !U.title)
            throw new Error("Invalid portal item: missing id or title");
          const M = U.thumbnailUrl || l;
          return {
            id: U.id,
            title: U.title,
            active: n.map.portalItem?.id === U.id,
            thumbnailUrl: M
          };
        });
        y(w);
      } catch (N) {
        console.error("Error loading thematic maps:", N), e?.("Kunne ikke laste tematiske kart");
      } finally {
        b(!1);
      }
    })();
  }, [n, t, e, l]);
  const i = () => {
    const p = n && it.get(n);
    !n || !p || (n.map = p, y((N) => N.map((E) => ({ ...E, active: !1 }))));
  }, g = async (p) => {
    if (n)
      try {
        const N = new Tl({
          portalItem: new ls({
            id: p
          })
        });
        await N.load(), n.map = N, y(
          (E) => E.map((u) => ({
            ...u,
            active: u.id === p
          }))
        );
      } catch (N) {
        console.error("Error changing web map:", N), e?.("Kunne ikke bytte til valgt temakart");
      }
  };
  if (d)
    return /* @__PURE__ */ c.jsx("div", { className: mt.centerContainer, children: /* @__PURE__ */ c.jsx(il, {}) });
  if (o.length === 0)
    return /* @__PURE__ */ c.jsx("div", { className: mt.messageContainer, children: r("kartinnhold:noThematicMaps") });
  const h = o.some((p) => p.active);
  return /* @__PURE__ */ c.jsxs("div", { id: "kartinnhold-gallery", className: mt.gallery, children: [
    o.map((p) => /* @__PURE__ */ c.jsx(
      tc,
      {
        title: p.title,
        thumbnailUrl: p.thumbnailUrl,
        isActive: p.active,
        onClick: () => p.active ? i() : g(p.id)
      },
      p.id
    )),
    h && /* @__PURE__ */ c.jsx(_t, { variant: "secondary", size: "sm", onClick: i, children: r("kartinnhold:resetThematicMap") })
  ] });
}, rc = "AddressSearch-module__wrapper___Lt7Og", cc = "AddressSearch-module__searchInput___SL0JK", oc = "AddressSearch-module__listbox___SBRWu", mc = "AddressSearch-module__noResults___3zjaP", ic = "AddressSearch-module__optionItem___CaFU6", bc = "AddressSearch-module__active___7g0Sv", dc = "AddressSearch-module__resultsHeader___yXnWw", yc = "AddressSearch-module__indexBadge___-gCz0", Ie = {
  wrapper: rc,
  searchInput: cc,
  listbox: oc,
  noResults: mc,
  optionItem: ic,
  active: bc,
  resultsHeader: dc,
  indexBadge: yc
};
function Ri({ input: t, suggestions: e, isFetchingDetails: l, onInputChange: r, onSuggestionClick: n, onHoverChange: o, className: y }) {
  const { t: d } = qe("common"), [b, i] = H(!1), [g, h] = H(-1), p = X(null), N = "address-search-listbox", E = b && t.length > 0 && !l, u = (S) => {
    switch (S.key) {
      case "ArrowDown":
        S.preventDefault(), h((w) => Math.min(w + 1, e.length - 1));
        break;
      case "ArrowUp":
        S.preventDefault(), h((w) => Math.max(w - 1, 0));
        break;
      case "Enter": {
        const w = g >= 0 ? e[g] : e[0];
        w && (n(w), i(!1), h(-1));
        break;
      }
      case "Escape":
        r(""), i(!1), h(-1), p.current?.blur();
        break;
    }
  };
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: `${Ie.wrapper}${y ? ` ${y}` : ""}`,
      onBlur: (S) => {
        S.currentTarget.contains(S.relatedTarget) || (i(!1), h(-1));
      },
      children: [
        /* @__PURE__ */ c.jsx(
          bl,
          {
            ref: p,
            label: d("addressSearch.label"),
            hideLabel: !0,
            size: "md",
            className: Ie.searchInput,
            prefix: /* @__PURE__ */ c.jsx(hs, { size: 16 }),
            suffix: t ? /* @__PURE__ */ c.jsx(
              Qt,
              {
                icon: /* @__PURE__ */ c.jsx(ws, { size: 14 }),
                label: d("addressSearch.clearLabel"),
                variant: "ghost",
                size: "sm",
                onMouseDown: (S) => S.preventDefault(),
                onClick: () => {
                  r(""), i(!1), h(-1), p.current?.focus();
                }
              }
            ) : void 0,
            role: "combobox",
            "aria-expanded": E,
            "aria-controls": N,
            "aria-activedescendant": g >= 0 ? `address-search-option-${g}` : void 0,
            "aria-autocomplete": "list",
            value: t,
            placeholder: d("addressSearch.placeholder"),
            disabled: l,
            onChange: (S) => {
              r(S.target.value), i(!0), h(-1);
            },
            onFocus: () => i(!0),
            onKeyDown: u,
            autoComplete: "off"
          }
        ),
        E && /* @__PURE__ */ c.jsxs(
          "ul",
          {
            id: N,
            role: "listbox",
            "aria-label": d("addressSearch.suggestionsLabel"),
            className: Ie.listbox,
            children: [
              e.length === 0 && /* @__PURE__ */ c.jsx("li", { role: "option", "aria-selected": !1, className: Ie.noResults, children: d("addressSearch.noResults") }),
              e.length > 0 && /* @__PURE__ */ c.jsx("li", { className: Ie.resultsHeader, children: d("addressSearch.resultsHeader") }),
              e.map((S, w) => /* @__PURE__ */ c.jsx(
                "li",
                {
                  id: `address-search-option-${w}`,
                  role: "option",
                  "aria-selected": w === g,
                  className: Ie.optionItem,
                  onMouseDown: (U) => U.preventDefault(),
                  children: /* @__PURE__ */ c.jsx(
                    dl,
                    {
                      title: S.address,
                      prefix: /* @__PURE__ */ c.jsx("span", { className: Ie.indexBadge, children: w + 1 }),
                      action: /* @__PURE__ */ c.jsx(Et, { size: 16, color: "var(--text-primary)" }),
                      className: w === g ? Ie.active : void 0,
                      onClick: () => {
                        n(S), i(!1), h(-1);
                      },
                      onMouseEnter: () => {
                        h(w), o(w);
                      },
                      onMouseLeave: () => o(null)
                    }
                  )
                },
                `${S.text}-${S.x}-${S.y}`
              ))
            ]
          }
        )
      ]
    }
  );
}
const St = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4
};
function gc(t) {
  return !!t && t in St;
}
function fc() {
  if (typeof window < "u")
    try {
      const t = new URLSearchParams(window.location.search).get("debug");
      if (t === "verbose" || t === "debug")
        return "debug";
      if (t === "off" || t === "silent")
        return "silent";
      const e = window.localStorage?.getItem("origoLogLevel");
      if (gc(e))
        return e;
    } catch {
    }
  return "info";
}
let pc = fc();
function Va(t) {
  const e = `[${t}]`, l = (r) => St[r] >= St[pc];
  return {
    debug: (...r) => {
      l("debug") && console.debug(e, ...r);
    },
    info: (...r) => {
      l("info") && console.info(e, ...r);
    },
    warn: (...r) => {
      l("warn") && console.warn(e, ...r);
    },
    error: (...r) => {
      l("error") && console.error(e, ...r);
    }
  };
}
class hc extends Error {
  constructor(e, l, r) {
    super(e), this.name = "SettingsError", this.errorType = l, Object.assign(this, r);
  }
  /**
   * Creates user-friendly Norwegian error message
   */
  toUserMessage() {
    switch (this.errorType) {
      case "NOT_FOUND":
        return `Kunne ikke finne innstillinger for ${this.itemName || "applikasjonen"}. Kontakt administrator.`;
      case "NETWORK":
        return "Kunne ikke laste innstillinger på grunn av nettverksfeil. Prøv igjen.";
      case "PARSE":
        return "Innstillingene har ugyldig format. Kontakt administrator.";
      case "UNAUTHORIZED":
        return "Du har ikke tilgang til å laste innstillinger. Kontakt administrator.";
      default:
        return "En ukjent feil oppstod ved lasting av innstillinger. Kontakt administrator.";
    }
  }
}
const Ua = Va("Auth");
let ia = null;
function Hs() {
  if (ia !== null)
    return ia;
  const t = window.location.hostname;
  if (t === "localhost" || t === "127.0.0.1") {
    const l = typeof import.meta < "u" && { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 }.VITE_DEV_CUSTOMER, r = l || "mars";
    return l ? Ua.debug(`Development mode: using VITE_DEV_CUSTOMER='${r}'`) : Ua.debug(`Development mode: using default customer '${r}'. Set VITE_DEV_CUSTOMER to override.`), ia = r, r;
  }
  const e = t.split(".");
  if (e.length >= 2) {
    const l = e[1];
    return Ua.debug(`Extracted customer domain from hostname: '${l}'`), ia = l, l;
  }
  return Ua.warn(`Unexpected hostname format: '${t}'. Using hostname as customer domain.`), ia = t, t;
}
const uc = {
  isSignedIn: !1,
  user: void 0,
  status: "idle",
  error: void 0,
  isAuthRequired: !1
}, bt = Ke(
  "auth/checkSignInStatus",
  async ({ authService: t, requireAuth: e }, { rejectWithValue: l }) => {
    try {
      return await t.checkSignInStatus(e);
    } catch (r) {
      return l(r.message);
    }
  }
), dt = Ke(
  "auth/requireSignIn",
  async ({ authService: t }, { rejectWithValue: e }) => {
    try {
      return await t.requireSignIn();
    } catch (l) {
      return e(l.message);
    }
  }
), yt = Ke(
  "auth/signOut",
  async ({ authService: t }, { rejectWithValue: e }) => {
    try {
      await t.signOut();
    } catch (l) {
      return e(l.message);
    }
  }
), Ts = Za({
  name: "auth",
  initialState: uc,
  reducers: {
    setIsAuthRequired: (t, e) => {
      t.isAuthRequired = e.payload;
    },
    clearAuth: (t) => {
      t.isSignedIn = !1, t.user = void 0, t.status = "idle", t.error = void 0;
    }
  },
  extraReducers: (t) => {
    t.addCase(bt.pending, (e) => {
      e.status = "loading", e.error = void 0;
    }).addCase(bt.fulfilled, (e, l) => {
      e.status = "succeeded", e.isSignedIn = l.payload.isSignedIn, e.user = l.payload.user;
    }).addCase(bt.rejected, (e, l) => {
      e.status = "failed", e.error = l.payload;
    }).addCase(dt.pending, (e) => {
      e.status = "loading", e.error = void 0;
    }).addCase(dt.fulfilled, (e, l) => {
      e.status = "succeeded", e.isSignedIn = !0, e.user = l.payload;
    }).addCase(dt.rejected, (e, l) => {
      e.status = "failed", e.error = l.payload;
    }).addCase(yt.pending, (e) => {
      e.status = "loading";
    }).addCase(yt.fulfilled, (e) => {
      e.status = "idle", e.isSignedIn = !1, e.user = void 0, e.error = void 0;
    }).addCase(yt.rejected, (e, l) => {
      e.status = "failed", e.error = l.payload;
    });
  }
});
Ts.actions;
const Ac = Ts.reducer, Zs = Va("tokenSlice"), Nc = {
  token: void 0,
  expiresAt: void 0,
  isRefreshing: !1,
  lastRefreshError: void 0,
  appName: void 0,
  username: void 0,
  customerName: void 0,
  applicationRoles: []
}, gt = Ke("token/getToken", async ({ tokenProvider: t }) => {
  try {
    return await t.getTokenMetadata?.();
  } catch (e) {
    Zs.warn("Failed to get token:", e);
    return;
  }
}), ft = Ke(
  "token/refreshToken",
  async ({ tokenProvider: t }) => {
    try {
      return await t.refreshToken(), await t.getTokenMetadata?.();
    } catch (e) {
      Zs.warn("Failed to refresh token:", e);
      return;
    }
  }
), js = Za({
  name: "token",
  initialState: Nc,
  reducers: {
    setToken: (t, e) => {
      t.token = e.payload;
    },
    setTokenMetadata: (t, e) => {
      e.payload.token && (t.token = e.payload.token), e.payload.expiresAt && (t.expiresAt = e.payload.expiresAt), e.payload.username && (t.username = e.payload.username), e.payload.customerName && (t.customerName = e.payload.customerName), e.payload.applicationRoles && (t.applicationRoles = e.payload.applicationRoles);
    },
    setAppName: (t, e) => {
      t.appName = e.payload;
    },
    clearToken: (t) => {
      t.token = void 0, t.expiresAt = void 0, t.lastRefreshError = void 0, t.username = void 0, t.customerName = void 0, t.applicationRoles = [];
    }
  },
  extraReducers: (t) => {
    t.addCase(gt.pending, (e) => {
      e.isRefreshing = !0, e.lastRefreshError = void 0;
    }).addCase(gt.fulfilled, (e, l) => {
      e.isRefreshing = !1, l.payload && (e.token = l.payload.token, e.expiresAt = l.payload.expiresAt, e.username = l.payload.username, e.customerName = l.payload.customerName, e.applicationRoles = l.payload.applicationRoles || []);
    }).addCase(gt.rejected, (e, l) => {
      e.isRefreshing = !1, e.lastRefreshError = l.error?.message;
    }).addCase(ft.pending, (e) => {
      e.isRefreshing = !0, e.lastRefreshError = void 0;
    }).addCase(ft.fulfilled, (e, l) => {
      e.isRefreshing = !1, l.payload && (e.token = l.payload.token, e.expiresAt = l.payload.expiresAt, e.username = l.payload.username, e.customerName = l.payload.customerName, e.applicationRoles = l.payload.applicationRoles || []);
    }).addCase(ft.rejected, (e, l) => {
      e.isRefreshing = !1, e.lastRefreshError = l.error?.message;
    });
  }
});
js.actions;
const Sc = js.reducer, Uc = (t) => t.auth.token.token, wc = Va("settingsSlice"), _c = {
  settings: void 0,
  isLoading: !1,
  error: void 0
}, Dt = Ke(
  "settings/loadSettings",
  async ({ settingsService: t, config: e, requireAuth: l }) => {
    try {
      return { settings: await t.loadSettings(e, l) };
    } catch (r) {
      wc.warn("Failed to load settings, using defaults:", r);
      const n = r instanceof hc ? { type: r.errorType, message: r.toUserMessage() } : { type: "UNKNOWN", message: "En ukjent feil oppstod ved lasting av innstillinger." };
      return { settings: e.defaultSettings, error: n };
    }
  }
), Rs = Za({
  name: "settings",
  initialState: _c,
  reducers: {
    setSettings: (t, e) => {
      t.settings = e.payload;
    }
  },
  extraReducers: (t) => {
    t.addCase(Dt.pending, (e) => {
      e.isLoading = !0;
    }).addCase(Dt.fulfilled, (e, l) => {
      e.isLoading = !1, e.settings = l.payload.settings, e.error = l.payload.error;
    });
  }
});
Rs.actions;
const vc = Rs.reducer;
var ba = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bt;
function Lc() {
  if (Bt)
    return ba;
  Bt = 1;
  var t = Ue, e = Symbol.for("react.element"), l = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function y(d, b, i) {
    var g, h = {}, p = null, N = null;
    i !== void 0 && (p = "" + i), b.key !== void 0 && (p = "" + b.key), b.ref !== void 0 && (N = b.ref);
    for (g in b)
      r.call(b, g) && !o.hasOwnProperty(g) && (h[g] = b[g]);
    if (d && d.defaultProps)
      for (g in b = d.defaultProps, b)
        h[g] === void 0 && (h[g] = b[g]);
    return { $$typeof: e, type: d, key: p, ref: N, props: h, _owner: n.current };
  }
  return ba.Fragment = l, ba.jsx = y, ba.jsxs = y, ba;
}
var wa = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zt;
function Ec() {
  return zt || (zt = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ue, e = Symbol.for("react.element"), l = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), d = Symbol.for("react.context"), b = Symbol.for("react.forward_ref"), i = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), E = Symbol.iterator, u = "@@iterator";
    function S(s) {
      if (s === null || typeof s != "object")
        return null;
      var m = E && s[E] || s[u];
      return typeof m == "function" ? m : null;
    }
    var w = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function U(s) {
      {
        for (var m = arguments.length, f = new Array(m > 1 ? m - 1 : 0), A = 1; A < m; A++)
          f[A - 1] = arguments[A];
        M("error", s, f);
      }
    }
    function M(s, m, f) {
      {
        var A = w.ReactDebugCurrentFrame, k = A.getStackAddendum();
        k !== "" && (m += "%s", f = f.concat([k]));
        var Z = f.map(function(x) {
          return String(x);
        });
        Z.unshift("Warning: " + m), Function.prototype.apply.call(console[s], console, Z);
      }
    }
    var q = !1, te = !1, oe = !1, se = !1, ee = !1, O;
    O = Symbol.for("react.module.reference");
    function Q(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === r || s === o || ee || s === n || s === i || s === g || se || s === N || q || te || oe || typeof s == "object" && s !== null && (s.$$typeof === p || s.$$typeof === h || s.$$typeof === y || s.$$typeof === d || s.$$typeof === b || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === O || s.getModuleId !== void 0));
    }
    function _(s, m, f) {
      var A = s.displayName;
      if (A)
        return A;
      var k = m.displayName || m.name || "";
      return k !== "" ? f + "(" + k + ")" : f;
    }
    function T(s) {
      return s.displayName || "Context";
    }
    function j(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && U("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case r:
          return "Fragment";
        case l:
          return "Portal";
        case o:
          return "Profiler";
        case n:
          return "StrictMode";
        case i:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case d:
            var m = s;
            return T(m) + ".Consumer";
          case y:
            var f = s;
            return T(f._context) + ".Provider";
          case b:
            return _(s, s.render, "ForwardRef");
          case h:
            var A = s.displayName || null;
            return A !== null ? A : j(s.type) || "Memo";
          case p: {
            var k = s, Z = k._payload, x = k._init;
            try {
              return j(x(Z));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, ne = 0, G, B, me, ye, we, Me, C;
    function de() {
    }
    de.__reactDisabledLog = !0;
    function He() {
      {
        if (ne === 0) {
          G = console.log, B = console.info, me = console.warn, ye = console.error, we = console.group, Me = console.groupCollapsed, C = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: de,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        ne++;
      }
    }
    function Re() {
      {
        if (ne--, ne === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, s, {
              value: G
            }),
            info: $({}, s, {
              value: B
            }),
            warn: $({}, s, {
              value: me
            }),
            error: $({}, s, {
              value: ye
            }),
            group: $({}, s, {
              value: we
            }),
            groupCollapsed: $({}, s, {
              value: Me
            }),
            groupEnd: $({}, s, {
              value: C
            })
          });
        }
        ne < 0 && U("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var _e = w.ReactCurrentDispatcher, ve;
    function Le(s, m, f) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (k) {
            var A = k.stack.trim().match(/\n( *(at )?)/);
            ve = A && A[1] || "";
          }
        return `
` + ve + s;
      }
    }
    var Te = !1, Ee;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      Ee = new Ye();
    }
    function L(s, m) {
      if (!s || Te)
        return "";
      {
        var f = Ee.get(s);
        if (f !== void 0)
          return f;
      }
      var A;
      Te = !0;
      var k = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Z;
      Z = _e.current, _e.current = null, He();
      try {
        if (m) {
          var x = function() {
            throw Error();
          };
          if (Object.defineProperty(x.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(x, []);
            } catch (J) {
              A = J;
            }
            Reflect.construct(s, [], x);
          } else {
            try {
              x.call();
            } catch (J) {
              A = J;
            }
            s.call(x.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (J) {
            A = J;
          }
          s();
        }
      } catch (J) {
        if (J && A && typeof J.stack == "string") {
          for (var v = J.stack.split(`
`), K = A.stack.split(`
`), R = v.length - 1, P = K.length - 1; R >= 1 && P >= 0 && v[R] !== K[P]; )
            P--;
          for (; R >= 1 && P >= 0; R--, P--)
            if (v[R] !== K[P]) {
              if (R !== 1 || P !== 1)
                do
                  if (R--, P--, P < 0 || v[R] !== K[P]) {
                    var ae = `
` + v[R].replace(" at new ", " at ");
                    return s.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", s.displayName)), typeof s == "function" && Ee.set(s, ae), ae;
                  }
                while (R >= 1 && P >= 0);
              break;
            }
        }
      } finally {
        Te = !1, _e.current = Z, Re(), Error.prepareStackTrace = k;
      }
      var Ae = s ? s.displayName || s.name : "", ge = Ae ? Le(Ae) : "";
      return typeof s == "function" && Ee.set(s, ge), ge;
    }
    function D(s, m, f) {
      return L(s, !1);
    }
    function Y(s) {
      var m = s.prototype;
      return !!(m && m.isReactComponent);
    }
    function z(s, m, f) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return L(s, Y(s));
      if (typeof s == "string")
        return Le(s);
      switch (s) {
        case i:
          return Le("Suspense");
        case g:
          return Le("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case b:
            return D(s.render);
          case h:
            return z(s.type, m, f);
          case p: {
            var A = s, k = A._payload, Z = A._init;
            try {
              return z(Z(k), m, f);
            } catch {
            }
          }
        }
      return "";
    }
    var W = Object.prototype.hasOwnProperty, re = {}, pe = w.ReactDebugCurrentFrame;
    function he(s) {
      if (s) {
        var m = s._owner, f = z(s.type, s._source, m ? m.type : null);
        pe.setExtraStackFrame(f);
      } else
        pe.setExtraStackFrame(null);
    }
    function Je(s, m, f, A, k) {
      {
        var Z = Function.call.bind(W);
        for (var x in s)
          if (Z(s, x)) {
            var v = void 0;
            try {
              if (typeof s[x] != "function") {
                var K = Error((A || "React class") + ": " + f + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw K.name = "Invariant Violation", K;
              }
              v = s[x](m, x, A, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (R) {
              v = R;
            }
            v && !(v instanceof Error) && (he(k), U("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", A || "React class", f, x, typeof v), he(null)), v instanceof Error && !(v.message in re) && (re[v.message] = !0, he(k), U("Failed %s type: %s", f, v.message), he(null));
          }
      }
    }
    var V = Array.isArray;
    function be(s) {
      return V(s);
    }
    function I(s) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, f = m && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return f;
      }
    }
    function Ne(s) {
      try {
        return Ve(s), !1;
      } catch {
        return !0;
      }
    }
    function Ve(s) {
      return "" + s;
    }
    function Xe(s) {
      if (Ne(s))
        return U("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", I(s)), Ve(s);
    }
    var xe = w.ReactCurrentOwner, Pa = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Qe, ea, $e;
    $e = {};
    function Ia(s) {
      if (W.call(s, "ref")) {
        var m = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function Oa(s) {
      if (W.call(s, "key")) {
        var m = Object.getOwnPropertyDescriptor(s, "key").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function Fa(s, m) {
      if (typeof s.ref == "string" && xe.current && m && xe.current.stateNode !== m) {
        var f = j(xe.current.type);
        $e[f] || (U('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(xe.current.type), s.ref), $e[f] = !0);
      }
    }
    function $a(s, m) {
      {
        var f = function() {
          Qe || (Qe = !0, U("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        f.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Da(s, m) {
      {
        var f = function() {
          ea || (ea = !0, U("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        f.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var Ba = function(s, m, f, A, k, Z, x) {
      var v = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: s,
        key: m,
        ref: f,
        props: x,
        // Record the component responsible for creating this element.
        _owner: Z
      };
      return v._store = {}, Object.defineProperty(v._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(v, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.defineProperty(v, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.freeze && (Object.freeze(v.props), Object.freeze(v)), v;
    };
    function za(s, m, f, A, k) {
      {
        var Z, x = {}, v = null, K = null;
        f !== void 0 && (Xe(f), v = "" + f), Oa(m) && (Xe(m.key), v = "" + m.key), Ia(m) && (K = m.ref, Fa(m, k));
        for (Z in m)
          W.call(m, Z) && !Pa.hasOwnProperty(Z) && (x[Z] = m[Z]);
        if (s && s.defaultProps) {
          var R = s.defaultProps;
          for (Z in R)
            x[Z] === void 0 && (x[Z] = R[Z]);
        }
        if (v || K) {
          var P = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          v && $a(x, P), K && Da(x, P);
        }
        return Ba(s, v, K, k, A, xe.current, x);
      }
    }
    var De = w.ReactCurrentOwner, aa = w.ReactDebugCurrentFrame;
    function ue(s) {
      if (s) {
        var m = s._owner, f = z(s.type, s._source, m ? m.type : null);
        aa.setExtraStackFrame(f);
      } else
        aa.setExtraStackFrame(null);
    }
    var Be;
    Be = !1;
    function ze(s) {
      return typeof s == "object" && s !== null && s.$$typeof === e;
    }
    function ta() {
      {
        if (De.current) {
          var s = j(De.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function Ga(s) {
      {
        if (s !== void 0) {
          var m = s.fileName.replace(/^.*[\\\/]/, ""), f = s.lineNumber;
          return `

Check your code at ` + m + ":" + f + ".";
        }
        return "";
      }
    }
    var sa = {};
    function Wa(s) {
      {
        var m = ta();
        if (!m) {
          var f = typeof s == "string" ? s : s.displayName || s.name;
          f && (m = `

Check the top-level render call using <` + f + ">.");
        }
        return m;
      }
    }
    function la(s, m) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var f = Wa(m);
        if (sa[f])
          return;
        sa[f] = !0;
        var A = "";
        s && s._owner && s._owner !== De.current && (A = " It was passed a child from " + j(s._owner.type) + "."), ue(s), U('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, A), ue(null);
      }
    }
    function na(s, m) {
      {
        if (typeof s != "object")
          return;
        if (be(s))
          for (var f = 0; f < s.length; f++) {
            var A = s[f];
            ze(A) && la(A, m);
          }
        else if (ze(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var k = S(s);
          if (typeof k == "function" && k !== s.entries)
            for (var Z = k.call(s), x; !(x = Z.next()).done; )
              ze(x.value) && la(x.value, m);
        }
      }
    }
    function Ka(s) {
      {
        var m = s.type;
        if (m == null || typeof m == "string")
          return;
        var f;
        if (typeof m == "function")
          f = m.propTypes;
        else if (typeof m == "object" && (m.$$typeof === b || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        m.$$typeof === h))
          f = m.propTypes;
        else
          return;
        if (f) {
          var A = j(m);
          Je(f, s.props, "prop", A, s);
        } else if (m.PropTypes !== void 0 && !Be) {
          Be = !0;
          var k = j(m);
          U("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", k || "Unknown");
        }
        typeof m.getDefaultProps == "function" && !m.getDefaultProps.isReactClassApproved && U("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qa(s) {
      {
        for (var m = Object.keys(s.props), f = 0; f < m.length; f++) {
          var A = m[f];
          if (A !== "children" && A !== "key") {
            ue(s), U("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", A), ue(null);
            break;
          }
        }
        s.ref !== null && (ue(s), U("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
      }
    }
    var ra = {};
    function ca(s, m, f, A, k, Z) {
      {
        var x = Q(s);
        if (!x) {
          var v = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var K = Ga(k);
          K ? v += K : v += ta();
          var R;
          s === null ? R = "null" : be(s) ? R = "array" : s !== void 0 && s.$$typeof === e ? (R = "<" + (j(s.type) || "Unknown") + " />", v = " Did you accidentally export a JSX literal instead of a component?") : R = typeof s, U("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, v);
        }
        var P = za(s, m, f, k, Z);
        if (P == null)
          return P;
        if (x) {
          var ae = m.children;
          if (ae !== void 0)
            if (A)
              if (be(ae)) {
                for (var Ae = 0; Ae < ae.length; Ae++)
                  na(ae[Ae], s);
                Object.freeze && Object.freeze(ae);
              } else
                U("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(ae, s);
        }
        if (W.call(m, "key")) {
          var ge = j(s), J = Object.keys(m).filter(function(at) {
            return at !== "key";
          }), Ge = J.length > 0 ? "{key: someKey, " + J.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ra[ge + Ge]) {
            var et = J.length > 0 ? "{" + J.join(": ..., ") + ": ...}" : "{}";
            U(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ge, ge, et, ge), ra[ge + Ge] = !0;
          }
        }
        return s === r ? qa(P) : Ka(P), P;
      }
    }
    function Ya(s, m, f) {
      return ca(s, m, f, !0);
    }
    function Ja(s, m, f) {
      return ca(s, m, f, !1);
    }
    var Xa = Ja, Qa = Ya;
    wa.Fragment = r, wa.jsx = Xa, wa.jsxs = Qa;
  }()), wa;
}
process.env.NODE_ENV === "production" ? Lc() : Ec();
Gs({
  auth: Ac,
  token: Sc,
  settings: vc
});
const Gt = 25833, xc = /^\d+\s*\/\s*\d+/, kc = /^(\d{3,4})[\s-]+(\d+\s*\/\s*\d+.*)$/, Mc = (t) => xc.test(t.trim()), Vs = (t) => {
  const e = t.trim(), l = e.match(kc);
  return l ? { query: l[2], kommunenr: l[1].padStart(4, "0") } : { query: e };
}, Cc = (t) => [t.gardsnr, t.bruksnr, t.festenr || void 0, t.seksjonsnr || void 0].filter((l) => l !== void 0).join("/"), Hc = (t) => {
  const e = new URLSearchParams();
  return Object.entries(t).forEach(([l, r]) => {
    r != null && r !== "" && e.set(l, String(r));
  }), e;
}, Tc = {
  async fetchSuggestions(t, e, l, r, n, o) {
    const { query: y, kommunenr: d } = Vs(t), b = Mc(y) ? "eiendom" : "adresse", i = b === "eiendom" ? y : t, g = d ? { filter_kommunenr: d } : n, h = Hc({ query: i, token: e, maxsize: String(r), filter_kilde: b, ...g }), p = `${l}?${h.toString()}`, N = await fetch(p, { signal: o });
    if (!N.ok)
      throw new Error("Failed to fetch suggestions");
    const E = await N.json();
    if (b === "eiendom") {
      const u = g?.filter_kommunenavn?.toLowerCase();
      return (E.hits ?? []).filter((S) => !u || S.kommunenavn?.toLowerCase().includes(u)).map((S) => {
        if (typeof S.x != "number" || typeof S.y != "number" || S.gardsnr === void 0 || S.bruksnr === void 0)
          return null;
        const w = Cc(S), U = S.kommunenavn ?? "";
        return {
          text: [w, U].filter(Boolean).join(", "),
          address: w,
          postalCode: "",
          postalArea: U,
          x: S.x,
          y: S.y,
          wkid: Gt,
          gnr: S.gardsnr,
          bnr: S.bruksnr,
          fnr: S.festenr,
          snr: S.seksjonsnr,
          kommunenr: S.kommunenr != null ? String(S.kommunenr) : void 0
        };
      }).filter((S) => !!S);
    }
    return (E.hits ?? []).map((u) => {
      if (typeof u.x != "number" || typeof u.y != "number")
        return null;
      const S = u.postnr ?? "", w = u.poststed ?? "", U = u.adresse ?? `${u.gatenavn ?? ""} ${u.husnrbokstav ?? `${u.husnr ?? ""}${u.husbokstav ?? ""}`.trim()}`.trim(), M = [U, `${S} ${w}`.trim()].filter(Boolean).join(", ");
      return M ? {
        text: M,
        address: U,
        postalCode: S,
        postalArea: w,
        x: u.x,
        y: u.y,
        wkid: Gt,
        adresseId: u.adresseid
      } : null;
    }).filter((u) => u !== null);
  }
}, Wt = (t) => t.toLowerCase().normalize("NFKD").replace(/[^\p{L}\p{N}]+/gu, " ").trim(), ka = Va("useAddressSearch"), Ma = {
  mars: "Fredrikstad",
  venus: "Nesodden",
  neptun: "Kongsberg"
}, Zc = (t) => {
  if (t && !(t.toLowerCase() in Ma))
    return t;
  const e = Hs(), l = Ma[e] ?? e;
  return Ma[e] || ka.warn(`Ingen kommunenavn konfigurert — gjetter på domenet «${e}» som søkefilter`), l;
}, jc = (t, e) => {
  const l = Ma[Hs()];
  return l ? { filter_kommunenavn: l } : t && Object.keys(t).length > 0 ? t : { filter_kommunenavn: Zc(e) };
}, Rc = "https://services.geodataonline.no/arcgis/rest/services/ProxyServices/search/adresse", Vi = ({ searchApiUrl: t = Rc, minChars: e = 2, maxResults: l = 4, kommunenavn: r, searchFilter: n, onValidateLocation: o, matrikkelClient: y }) => {
  const [d, b] = H(""), [i, g] = H([]), [h, p] = H(!1), [N, E] = H(null), [u, S] = H(!1), [w, U] = H(!1), M = X(null), q = wt(Uc), te = JSON.stringify(n ?? null), oe = Ut(
    () => jc(n, r),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [te, r]
  ), se = le(
    async (_) => {
      try {
        const T = new Ea({ x: _.x, y: _.y, spatialReference: { wkid: _.wkid } });
        let j;
        if (y) {
          const $ = y;
          if ($.getMatrikkelEnhetFromGeometry) {
            const ne = await $.getMatrikkelEnhetFromGeometry(T);
            j = (Array.isArray(ne) ? ne : [])[0];
          }
        }
        return {
          ..._,
          matrikkelEnhet: j ? { ...j, kommunenr: String(j.kommunenr) } : void 0
        };
      } catch (T) {
        return ka.error("Matrikkel lookup failed", T), null;
      }
    },
    [y]
  ), ee = le(
    (_) => {
      const T = _.trim(), j = !!q && T.length >= e;
      b(_), E(null), g([]), p(!1), S(j), M.current && clearTimeout(M.current), M.current = setTimeout(async () => {
        if (!j || !q) {
          g([]), p(!1), S(!1);
          return;
        }
        try {
          const $ = await Tc.fetchSuggestions(_, q, t, l, oe), { query: ne } = Vs(_), G = Wt(ne).split(/\s+/).filter(Boolean), B = $.filter((me) => {
            const ye = Wt(me.text ?? "");
            return G.every((we) => ye.includes(we));
          });
          g(B);
        } catch ($) {
          $.name !== "AbortError" && (ka.error("Suggestions error", $), g([]));
        } finally {
          S(!1), p(!0);
        }
      }, 500);
    },
    [q, t, e, l, oe]
  ), O = le(
    async (_) => {
      try {
        const T = {
          selected: !0,
          id: _.adresseId != null ? String(_.adresseId) : void 0,
          name: _.text,
          address: _.address,
          postalCode: _.postalCode,
          postalArea: _.postalArea,
          x: _.x,
          y: _.y,
          wkid: _.wkid
        }, j = await se(T);
        return !j || o && !await o(j) ? null : j;
      } catch (T) {
        return T.name !== "AbortError" && ka.error("Error fetching address details:", T), null;
      }
    },
    [se, o]
  ), Q = le((_) => {
    b(_.address ?? ""), E(_), g([]), p(!1);
  }, []);
  return {
    input: d,
    setInput: b,
    suggestions: i,
    hasFetchedSuggestions: h,
    selectedSuggestion: N,
    isLoading: u,
    isFetchingDetails: w,
    setIsFetchingDetails: U,
    handleInputChange: ee,
    handleSuggestionClick: Q,
    fetchAddressDetailsFromSuggestion: O
  };
}, Vc = "VersionInfo-module__headerButton___9pT0V", Pc = "VersionInfo-module__footerLink___2Y7St", Ic = "VersionInfo-module__notice___je-0O", Oc = "VersionInfo-module__noticeButton___ZGSac", Fc = "VersionInfo-module__dialogMeta___akGsY", $c = "VersionInfo-module__versionLine___BG1s6", Dc = "VersionInfo-module__commit___t0UtV", Bc = "VersionInfo-module__buildDate___MKUGB", zc = "VersionInfo-module__changelogTitle___bnj-w", Gc = "VersionInfo-module__introText___7w45N", Wc = "VersionInfo-module__entries___6gHwp", Kc = "VersionInfo-module__entry___VEyTs", qc = "VersionInfo-module__entryHeader___HTZHe", Yc = "VersionInfo-module__entryVersion___7YAYZ", Jc = "VersionInfo-module__entryDate___NSX41", Xc = "VersionInfo-module__section___-zx9O", Qc = "VersionInfo-module__sectionHeading___NcjpI", eo = "VersionInfo-module__itemList___W9JnR", ie = {
  headerButton: Vc,
  footerLink: Pc,
  notice: Ic,
  noticeButton: Oc,
  dialogMeta: Fc,
  versionLine: $c,
  commit: Dc,
  buildDate: Bc,
  changelogTitle: zc,
  introText: Gc,
  entries: Wc,
  entry: Kc,
  entryHeader: qc,
  entryVersion: Yc,
  entryDate: Jc,
  section: Xc,
  sectionHeading: Qc,
  itemList: eo
};
function Pi({ placement: t = "footer", appName: e, onClick: l }) {
  return t === "header" ? /* @__PURE__ */ c.jsxs(
    "button",
    {
      type: "button",
      className: ie.headerButton,
      onClick: l,
      "aria-label": "Vis versjonsinformasjon og endringslogg",
      children: [
        /* @__PURE__ */ c.jsx(Ra, { size: 14, weight: "regular", "aria-hidden": "true" }),
        /* @__PURE__ */ c.jsxs("span", { children: [
          "v",
          __APP_VERSION__
        ] })
      ]
    }
  ) : /* @__PURE__ */ c.jsx(
    "button",
    {
      type: "button",
      className: ie.footerLink,
      onClick: l,
      "aria-label": `Vis versjonsinformasjon og endringslogg${e ? ` for ${e}` : ""}`,
      children: e ? `${e} v${__APP_VERSION__}` : `v${__APP_VERSION__}`
    }
  );
}
const ao = /^##\s*\[?([^\]\s]+)\]?\s*[–-]\s*(.+?)\s*$/, to = /^###\s+(.+?)\s*$/, so = /^[-*]\s+(.+?)\s*$/;
function lo(t) {
  const e = [];
  let l = null, r = null;
  for (const n of t.split(/\r?\n/)) {
    const o = n.trim(), y = o.match(ao);
    if (y) {
      l = { version: y[1], date: y[2], sections: [] }, e.push(l), r = null;
      continue;
    }
    if (!l)
      continue;
    const d = o.match(to);
    if (d) {
      r = { heading: d[1], items: [] }, l.sections.push(r);
      continue;
    }
    const b = o.match(so);
    b && r && r.items.push(b[1]);
  }
  return e;
}
function no(t) {
  return t.split(/\*\*(.+?)\*\*/).map((l, r) => r % 2 === 1 ? /* @__PURE__ */ c.jsx("strong", { children: l }, r) : l);
}
function ro(t, e) {
  const l = new Date(t);
  return Number.isNaN(l.getTime()) ? t : e === "long" ? l.toLocaleDateString("nb-NO", { day: "numeric", month: "long", year: "numeric" }) : l.toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric" });
}
function Ii({
  open: t,
  onClose: e,
  appName: l,
  changelogMarkdown: r,
  introText: n,
  showCommit: o = !0,
  buildDateLabel: y = "Bygget",
  buildDateFormat: d = "short"
}) {
  const b = lo(r);
  return /* @__PURE__ */ c.jsxs(yl, { open: t, onClose: e, title: `Om ${l}`, children: [
    /* @__PURE__ */ c.jsxs("div", { className: ie.dialogMeta, children: [
      /* @__PURE__ */ c.jsxs("div", { className: ie.versionLine, children: [
        /* @__PURE__ */ c.jsxs("strong", { children: [
          "Versjon ",
          __APP_VERSION__
        ] }),
        o && /* @__PURE__ */ c.jsxs("span", { className: ie.commit, children: [
          "(",
          __APP_COMMIT__,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ c.jsxs("div", { className: ie.buildDate, children: [
        y,
        " ",
        ro(__APP_BUILD_DATE__, d)
      ] })
    ] }),
    /* @__PURE__ */ c.jsx("h3", { className: ie.changelogTitle, children: "Endringslogg" }),
    n && /* @__PURE__ */ c.jsx("p", { className: ie.introText, children: n }),
    b.length === 0 ? n ? null : /* @__PURE__ */ c.jsx("p", { children: "Ingen endringer registrert ennå." }) : /* @__PURE__ */ c.jsx("ol", { className: ie.entries, children: b.map((i) => /* @__PURE__ */ c.jsxs("li", { className: ie.entry, children: [
      /* @__PURE__ */ c.jsxs("header", { className: ie.entryHeader, children: [
        /* @__PURE__ */ c.jsx("span", { className: ie.entryVersion, children: i.version }),
        /* @__PURE__ */ c.jsx("span", { className: ie.entryDate, children: i.date })
      ] }),
      i.sections.map((g) => /* @__PURE__ */ c.jsxs("div", { className: ie.section, children: [
        /* @__PURE__ */ c.jsx("h4", { className: ie.sectionHeading, children: g.heading }),
        /* @__PURE__ */ c.jsx("ul", { className: ie.itemList, children: g.items.map((h, p) => /* @__PURE__ */ c.jsx("li", { children: no(h) }, p)) })
      ] }, g.heading))
    ] }, i.version)) })
  ] });
}
function Oi({ onOpenChangelog: t, onDismiss: e }) {
  return /* @__PURE__ */ c.jsxs(es, { variant: "info", className: ie.notice, onDismiss: e, children: [
    "Ny versjon (",
    __APP_VERSION__,
    ") er rullet ut.",
    " ",
    /* @__PURE__ */ c.jsx("button", { type: "button", className: ie.noticeButton, onClick: t, children: "Se hva som er nytt" })
  ] });
}
function Fi(t) {
  const [e, l] = H(!1);
  return F(() => {
    try {
      const n = window.localStorage.getItem(t);
      n && n !== __APP_VERSION__ ? l(!0) : n || window.localStorage.setItem(t, __APP_VERSION__);
    } catch {
    }
  }, [t]), { hasNewVersion: e, dismiss: () => {
    try {
      window.localStorage.setItem(t, __APP_VERSION__);
    } catch {
    }
    l(!1);
  } };
}
const co = "SearchSuggestionLayer-module__popup___ltkFS", oo = "SearchSuggestionLayer-module__popupArrow___LHemA", mo = "SearchSuggestionLayer-module__popupArrowFlipped___RvYFW", _a = {
  popup: co,
  popupArrow: oo,
  popupArrowFlipped: mo
}, da = 8, Kt = 10, pt = 28, io = ({ anchorX: t, anchorY: e, container: l, children: r }) => {
  const n = X(null), [o, y] = H(null);
  return Jt(() => {
    if (!n.current)
      return;
    const d = n.current.offsetWidth, b = n.current.offsetHeight, i = l.offsetWidth, g = l.offsetHeight, h = t - d / 2, p = Math.max(da, Math.min(h, i - d - da)), N = e - b - pt < da, E = N ? Math.min(e + pt, g - b - da) : Math.max(da, e - b - pt), u = Math.max(Kt, Math.min(t - p, d - Kt));
    y({ left: p, top: E, arrowLeft: u, flipped: N });
  }, [t, e, l]), /* @__PURE__ */ c.jsxs(
    "div",
    {
      ref: n,
      className: _a.popup,
      style: o ? { left: o.left, top: o.top } : { visibility: "hidden", left: t, top: e },
      children: [
        r,
        /* @__PURE__ */ c.jsx(
          "span",
          {
            className: o?.flipped ? `${_a.popupArrow} ${_a.popupArrowFlipped}` : _a.popupArrow,
            style: { left: o ? o.arrowLeft : void 0 }
          }
        )
      ]
    }
  );
}, va = 200;
function bo(t, e) {
  const l = t.map((n) => n.x), r = t.map((n) => n.y);
  return new Zl({
    xmin: Math.min(...l) - va,
    ymin: Math.min(...r) - va,
    xmax: Math.max(...l) + va,
    ymax: Math.max(...r) + va,
    spatialReference: { wkid: e }
  });
}
function yo(t) {
  const e = String(t + 1), l = 24, r = 3, n = l * r, o = `<svg xmlns="http://www.w3.org/2000/svg" width="${n}" height="${n}" viewBox="0 0 ${n} ${n}">
        <circle cx="${n / 2}" cy="${n / 2}" r="${n / 2 - r}" fill="#0037F8" stroke="white" stroke-width="${2 * r}"/>
        <text x="${n / 2}" y="${n / 2}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * r}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(o)}`,
    width: l,
    height: l
  };
}
function qt(t) {
  const e = String(t + 1), l = 32, r = 3, n = l * r, o = n / 2, y = n / 2 - r, d = y - 4 * r, b = `<svg xmlns="http://www.w3.org/2000/svg" width="${n}" height="${n}" viewBox="0 0 ${n} ${n}">
        <defs>
            <filter id="shadow" x="-30%" y="-30%" width="160%" height="160%">
                <feDropShadow dx="0" dy="${r}" stdDeviation="${2 * r}" flood-color="rgba(0,0,0,0.35)"/>
            </filter>
        </defs>
        <circle cx="${o}" cy="${o}" r="${y}" fill="white" filter="url(#shadow)"/>
        <circle cx="${o}" cy="${o}" r="${d}" fill="#0037F8"/>
        <text x="${o}" y="${o}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * r}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(b)}`,
    width: l,
    height: l
  };
}
function go(t) {
  const e = String(t + 1), l = 24, r = 3, n = l * r, o = `<svg xmlns="http://www.w3.org/2000/svg" width="${n}" height="${n}" viewBox="0 0 ${n} ${n}">
        <circle cx="${n / 2}" cy="${n / 2}" r="${n / 2 - r}" fill="#B0B7C3" stroke="white" stroke-width="${2 * r}"/>
        <text x="${n / 2}" y="${n / 2}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * r}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(o)}`,
    width: l,
    height: l
  };
}
function $i({
  suggestions: t,
  hoveredIndex: e,
  paddingLeft: l = 0,
  onPinHit: r,
  onPinClick: n,
  onPopupDismiss: o,
  onMapClick: y,
  renderPopupContent: d
}) {
  const { graphicsLayer: b, mapView: i } = Fe(), [g, h] = H(null), p = Ue.useRef(g);
  F(() => {
    p.current = g;
  }, [g]);
  const [N, E] = H(null), u = Ue.useRef([]), S = Ue.useCallback(() => {
    !b || u.current.length === 0 || (u.current.forEach((ee) => b.remove(ee)), u.current = []);
  }, [b]);
  F(() => {
    h(null), E(null);
  }, [t]), F(() => {
    if (i)
      return i.padding = { left: l }, () => {
        i.padding = { left: 0 };
      };
  }, [i, l]), F(() => {
    if (b && (S(), t.length !== 0))
      return t.forEach((ee, O) => {
        let Q;
        g !== null ? Q = O === g ? qt(O) : go(O) : O === e ? Q = qt(O) : Q = yo(O);
        const _ = new jl({
          geometry: new Na({ x: ee.x, y: ee.y, spatialReference: { wkid: ee.wkid } }),
          symbol: Q,
          attributes: { pinIndex: O }
        });
        b.add(_), u.current.push(_);
      }), () => {
        S();
      };
  }, [t, e, g, b, S]), F(() => {
    if (t.length === 0 || !i)
      return;
    const ee = t.map(
      (O) => new Na({ x: O.x, y: O.y, spatialReference: { wkid: O.wkid } })
    );
    i.goTo(bo(ee, t[0].wkid));
  }, [t, i]);
  const w = Ue.useRef(r), U = Ue.useRef(n), M = Ue.useRef(o), q = Ue.useRef(y), te = Ue.useRef(d);
  F(() => {
    w.current = r;
  }, [r]), F(() => {
    U.current = n;
  }, [n]), F(() => {
    M.current = o;
  }, [o]), F(() => {
    q.current = y;
  }, [y]), F(() => {
    te.current = d;
  }, [d]), F(() => {
    if (!i || !b)
      return;
    const ee = i.on("click", async (O) => {
      const _ = (await i.hitTest(O, { include: [b] })).results.find((T) => T.type === "graphic");
      if (_ && u.current.includes(_.graphic)) {
        const T = _.graphic.attributes?.pinIndex, j = t[T];
        if (j != null)
          if (w.current?.(), te.current) {
            h(T);
            const $ = i.toScreen(
              new Na({ x: j.x, y: j.y, spatialReference: { wkid: j.wkid } })
            );
            $ && E({ x: $.x, y: $.y });
          } else
            U.current?.(j);
      } else if (p.current !== null && t[p.current]) {
        const T = t[p.current];
        h(null), E(null), M.current?.(T);
      } else
        h(null), E(null), q.current?.();
    });
    return () => ee.remove();
  }, [i, b, t]), F(() => {
    if (!i || g === null)
      return;
    const ee = Rl.watch(() => i.extent, () => {
      const O = t[g];
      if (!O)
        return;
      const Q = i.toScreen(
        new Na({ x: O.x, y: O.y, spatialReference: { wkid: O.wkid } })
      );
      Q && E({ x: Q.x, y: Q.y });
    });
    return () => ee.remove();
  }, [i, g, t]);
  const oe = i?.container instanceof HTMLElement ? i.container : null, se = g !== null ? t[g] : null;
  return !d || !oe || !se || !N ? null : ns(
    /* @__PURE__ */ c.jsx(io, { anchorX: N.x, anchorY: N.y, container: oe, children: d(se) }),
    oe
  );
}
const fo = "Toaster-module__container___azaFy", po = "Toaster-module__slide-in___zkFuc", ho = {
  container: fo,
  slideIn: po
};
function Di({
  message: t,
  open: e,
  onClose: l,
  variant: r = "info",
  icon: n,
  autoCloseDuration: o = 4e3
}) {
  return e ? ns(
    /* @__PURE__ */ c.jsx("div", { className: ho.container, children: /* @__PURE__ */ c.jsx(
      as,
      {
        variant: r,
        icon: n,
        open: e,
        onClose: l,
        autoCloseDuration: o,
        children: t
      }
    ) }),
    document.body
  ) : null;
}
const uo = "AccessDeniedScreen-module__wrapper___IXNNC", Ao = "AccessDeniedScreen-module__card___CN-hi", No = "AccessDeniedScreen-module__cardBody___EPoRu", So = "AccessDeniedScreen-module__icon___kXZSB", Uo = "AccessDeniedScreen-module__text___s5-8T", wo = "AccessDeniedScreen-module__title___TTTYe", _o = "AccessDeniedScreen-module__message___ymqHi", vo = "AccessDeniedScreen-module__cardFooter___Dy8aM", Oe = {
  wrapper: uo,
  card: Ao,
  cardBody: No,
  icon: So,
  text: Uo,
  title: wo,
  message: _o,
  cardFooter: vo
}, Bi = ({ title: t, message: e, actionLabel: l, onAction: r }) => /* @__PURE__ */ c.jsx("div", { className: Oe.wrapper, children: /* @__PURE__ */ c.jsxs("div", { className: Oe.card, role: "alert", children: [
  /* @__PURE__ */ c.jsxs("div", { className: Oe.cardBody, children: [
    /* @__PURE__ */ c.jsx(kt, { size: 32, weight: "duotone", className: Oe.icon, "aria-hidden": "true" }),
    /* @__PURE__ */ c.jsxs("div", { className: Oe.text, children: [
      /* @__PURE__ */ c.jsx("strong", { className: Oe.title, children: t }),
      /* @__PURE__ */ c.jsx("p", { className: Oe.message, children: e })
    ] })
  ] }),
  /* @__PURE__ */ c.jsx("div", { className: Oe.cardFooter, children: /* @__PURE__ */ c.jsx(_t, { variant: "secondary", onClick: r, children: l }) })
] }) }), Lo = {
  group: {
    title: "Ingen tilgang",
    message: "Manglende tilgang kan skyldes at brukeren din ikke er medlem av nødvendig gruppe i ArcGIS Online. Ta kontakt med administrator."
  },
  notFound: {
    title: "Ingen tilgang",
    message: "Kunne ikke finne innstillinger. Ta kontakt med administrator."
  },
  parse: {
    title: "Ingen tilgang",
    message: "Innstillingene har ugyldig format. Ta kontakt med administrator."
  },
  networkOrUnknown: {
    title: "Ingen tilgang",
    message: "Kunne ikke laste innstillinger. Prøv igjen senere."
  }
};
function zi(t, e, l) {
  if (!t)
    return null;
  const r = { ...Lo, ...l };
  if (t.kind === "group")
    return {
      ...r.group,
      actionLabel: "Logg ut",
      onAction: e
    };
  switch (t.error.type) {
    case "NOT_FOUND":
      return {
        ...r.notFound,
        actionLabel: "Logg ut",
        onAction: e
      };
    case "PARSE":
      return {
        ...r.parse,
        actionLabel: "Logg ut",
        onAction: e
      };
    case "NETWORK":
    case "UNKNOWN":
    default:
      return {
        ...r.networkOrUnknown,
        actionLabel: "Prøv igjen",
        onAction: () => window.location.reload()
      };
  }
}
const Eo = {
  notFound: {
    title: "Innstillinger mangler",
    message: "Kunne ikke finne innstillinger for løsningen. Ta kontakt med administrator."
  },
  parse: {
    title: "Innstillinger mangler",
    message: "Innstillingene har ugyldig format. Ta kontakt med administrator."
  },
  networkOrUnknown: {
    title: "Kunne ikke laste innstillinger",
    message: "Kunne ikke laste innstillinger. Prøv igjen senere."
  }
};
function Gi(t, e) {
  if (!t)
    return null;
  const l = { ...Eo, ...e };
  switch (t.type) {
    case "NOT_FOUND":
      return {
        ...l.notFound,
        actionLabel: "Prøv igjen",
        onAction: () => window.location.reload()
      };
    case "PARSE":
      return {
        ...l.parse,
        actionLabel: "Prøv igjen",
        onAction: () => window.location.reload()
      };
    case "NETWORK":
    case "UNKNOWN":
    default:
      return {
        ...l.networkOrUnknown,
        actionLabel: "Prøv igjen",
        onAction: () => window.location.reload()
      };
  }
}
const Ps = Yt(null), xo = "ToastProvider-module__container___89FP-", ko = {
  container: xo
}, Mo = {
  success: /* @__PURE__ */ c.jsx(is, { size: 20 }),
  danger: /* @__PURE__ */ c.jsx(kt, { size: 20 }),
  warning: /* @__PURE__ */ c.jsx(Us, { size: 20 }),
  info: /* @__PURE__ */ c.jsx(Ra, { size: 20 })
};
function Wi({ children: t }) {
  const [e, l] = H([]), r = le((o) => {
    l((y) => y.filter((d) => d.id !== o));
  }, []), n = le((o) => {
    const y = crypto.randomUUID();
    l((d) => [...d, { ...o, id: y }]);
  }, []);
  return /* @__PURE__ */ c.jsxs(Ps.Provider, { value: { add: n, remove: r }, children: [
    t,
    /* @__PURE__ */ c.jsx("div", { className: ko.container, "aria-live": "polite", children: e.map((o) => /* @__PURE__ */ c.jsx(
      as,
      {
        open: !0,
        variant: o.variant,
        icon: Mo[o.variant],
        onClose: () => r(o.id),
        autoCloseDuration: o.duration,
        children: o.message
      },
      o.id
    )) })
  ] });
}
const Co = 5e3;
function Ki() {
  const t = Os(Ps);
  if (!t)
    throw new Error("useToast must be used inside <ToastProvider>");
  const e = (r, n, o = Co) => {
    t.add({ message: r, variant: n, duration: o });
  };
  return {
    success: (r, n) => e(r, "success", n),
    error: (r, n) => e(r, "danger", n),
    warning: (r, n) => e(r, "warning", n),
    info: (r, n) => e(r, "info", n),
    execute: async (r, n) => {
      try {
        const o = await r();
        return e(n.success, "success"), o;
      } catch (o) {
        const y = n.error ?? (o instanceof Error ? o.message : "Noe gikk galt");
        e(y, "danger");
      }
    }
  };
}
const Ho = {
  title: "Applikasjon",
  description: "Kart og datavisning",
  showInfoLabel: "Vis informasjon",
  showInfoTooltip: "Klikk for å vise hjelpeinformasjon",
  themeToggleLabel: "Bytt tema",
  languageToggleLabel: "Bytt språk",
  arcgisOnlineLabel: "ArcGIS Online",
  signoutLabel: "Logg ut",
  userDropdownTooltip: "Brukerinnstillinger",
  toggleMenuLabel: "Åpne/lukk meny"
}, To = {
  close: "Lukk",
  expand: "Utvid",
  collapse: "Slå sammen"
}, Zo = {
  header: Ho,
  panel: To
}, jo = {
  title: "Application",
  description: "Map and data visualization",
  showInfoLabel: "Show information",
  showInfoTooltip: "Click to show help information",
  themeToggleLabel: "Toggle theme",
  languageToggleLabel: "Change language",
  arcgisOnlineLabel: "ArcGIS Online",
  signoutLabel: "Sign out",
  userDropdownTooltip: "User settings",
  toggleMenuLabel: "Toggle menu"
}, Ro = {
  close: "Close",
  expand: "Expand",
  collapse: "Collapse"
}, Vo = {
  header: jo,
  panel: Ro
}, Po = "Legg til kartlag", Io = "Legg til kartlag", Oo = "Temakart", Fo = "Bakgrunnskart", $o = "Ingen kartlag tilgjengelig", Do = "Ingen temakart tilgjengelig", Bo = "Tilbakestill temakart", zo = "Feil", Go = "Vi fikk ikke lastet inn kartlagene fra ArcGIS Online. Prøv igjen, eller kontakt kommunens kartavdeling om problemet vedvarer.", Wo = "Kunne ikke legge til kartlag: {{title}}", Ko = "Kunne ikke håndtere kartlaget", qo = {
  loadingLayer: "Kunne ikke laste kartlag",
  loadingThematicMap: "Kunne ikke laste temakart"
}, Yo = {
  layers: "Vis kartlag",
  mapType: "Velg karttype",
  basemap: "Velg bakgrunnskart"
}, Jo = {
  title: Po,
  layers: Io,
  thematicMaps: Oo,
  basemaps: Fo,
  noLayers: $o,
  noThematicMaps: Do,
  resetThematicMap: Bo,
  error: zo,
  errorLoadingLayers: Go,
  errorAddingLayer: Wo,
  errorManagingLayer: Ko,
  errors: qo,
  tabs: Yo
}, Xo = "Ja", Qo = "Nei", em = "Skjul", am = "Vis", tm = "Fra", sm = "Til", lm = {
  ok: "OK",
  cancel: "Avbryt",
  previous: "Forrige",
  next: "Neste"
}, nm = {
  placeholder: "Søk etter sted eller klikk i kartet..."
}, rm = {
  placeholder: "Søk etter butikk..."
}, cm = {
  placeholder: "Velg analyseområde...",
  placeholderPlural: "Velg analyseområder...",
  mapExtent: "Kartutsnitt",
  contextDelete: "Slett analyseområdet",
  contextNew: "Lag nytt analyseområde",
  contextEdit: "Rediger analyseområdet"
}, om = {
  placeholder: "Søk..."
}, mm = {
  label: "Søk etter adresse eller gårds-/bruksnummer",
  placeholder: "Søk etter adresse eller gnr/bnr…",
  clearLabel: "Tøm søk",
  suggestionsLabel: "Adresseforslag",
  noResults: "Ingen treff",
  resultsHeader: "Resultater"
}, im = {
  yes: Xo,
  no: Qo,
  hide: em,
  show: am,
  from: tm,
  to: sm,
  buttons: lm,
  locationhistoryselect: nm,
  storelocationselect: rm,
  analysisareaselect: cm,
  search: om,
  addressSearch: mm
}, bm = "Layers", dm = "Layers", ym = "Thematic Maps", gm = "Basemaps", fm = "No layers available", pm = "No thematic maps available", hm = "Reset thematic map", um = "Error", Am = "We could not load the layers from ArcGIS Online. Try again, or contact the municipality's map department if the problem persists.", Nm = "Could not add layer: {{title}}", Sm = "Could not manage layer", Um = {
  loadingLayer: "Could not load layer",
  loadingThematicMap: "Could not load thematic map"
}, wm = {
  layers: "Show layers",
  mapType: "Select map type",
  basemap: "Select basemap"
}, _m = {
  title: bm,
  layers: dm,
  thematicMaps: ym,
  basemaps: gm,
  noLayers: fm,
  noThematicMaps: pm,
  resetThematicMap: hm,
  error: um,
  errorLoadingLayers: Am,
  errorAddingLayer: Nm,
  errorManagingLayer: Sm,
  errors: Um,
  tabs: wm
}, vm = "Yes", Lm = "No", Em = "Hide", xm = "Show", km = "From", Mm = "To", Cm = {
  ok: "OK",
  cancel: "Cancel",
  previous: "Previous",
  next: "Next"
}, Hm = {
  placeholder: "Search or click in the map..."
}, Tm = {
  placeholder: "Select analysis area...",
  placeholderPlural: "Select analysis areas...",
  mapExtent: "Map extent",
  contextDelete: "Delete analysis area",
  contextNew: "Create new analysis area",
  contextEdit: "Edit analysis area"
}, Zm = {
  placeholder: "Search..."
}, jm = {
  label: "Search for address or cadastral number",
  placeholder: "Search for address or gnr/bnr…",
  clearLabel: "Clear search",
  suggestionsLabel: "Address suggestions",
  noResults: "No results",
  resultsHeader: "Results"
}, Rm = {
  yes: vm,
  no: Lm,
  hide: Em,
  show: xm,
  from: km,
  to: Mm,
  buttons: Cm,
  locationhistoryselect: Hm,
  analysisareaselect: Tm,
  search: Zm,
  addressSearch: jm
}, qi = {
  nb: {
    uiComponents: Zo,
    common: im,
    kartinnhold: Jo
  },
  en: {
    uiComponents: Vo,
    common: Rm,
    kartinnhold: _m
  }
};
export {
  Bi as AccessDeniedScreen,
  Ri as AddressSearch,
  Ii as ChangelogDialog,
  Ti as DrawingCustom,
  Mi as EsriBasemapGallery,
  xi as EsriLayerList,
  Ci as EsriPrint,
  Hi as FlowWrapper,
  wi as Header,
  ki as LayerListCustom,
  Zi as LayerSelector,
  _i as LeftPanel,
  tc as MapItem,
  Oi as NewVersionNotice,
  Li as OrigoLeftPanel,
  cs as OrigoPanel,
  Ei as OrigoRightPanel,
  Il as PanelToolbar,
  vi as RightPanel,
  $i as SearchSuggestionLayer,
  ji as ThematicMapSelector,
  Wi as ToastProvider,
  Di as Toaster,
  Pi as VersionTrigger,
  Tc as addressService,
  Ai as panelReducer,
  lo as parseChangelog,
  hi as setActiveLeftPanel,
  ui as setActiveRightPanel,
  qi as uiTranslations,
  zi as useAccessErrorScreen,
  Ni as useActiveLeftPanel,
  Si as useActiveRightPanel,
  Vi as useAddressSearch,
  Fi as useNewVersionNotice,
  Ui as usePanelDispatch,
  Gi as useSettingsErrorScreen,
  Ki as useToast
};
//# sourceMappingURL=index.mjs.map
